import { Component, Inject, ViewChild, ViewChildren, Input, Output, EventEmitter, SimpleChanges, DOCUMENT } from '@angular/core';
import { DxAccordionComponent } from 'devextreme-angular/ui/accordion';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';

import { WorkFlowTab, Service } from '../WorkflowDashBoard/WorkflowDashBoard.service';
import {
  BusinessProcessHTML, BusinessProcessViewModel, BusinessProcessStateHTML, BusinessProcessDefinitionDetail,
  BusinessProcessInstanceViewModel, BusinessProcessInstanceCurrentStateData, BusinessProcessStateAction,
  BusinessProcessStateActionExecute, BusinessProcessUserAction, JSONCurrentInstanceData, FileDetail,
  BusinessProcessConfig, SwitchPortal, BusinessProcessStateLessDefinitionDetail, BusinessProcessStatelessDataContext,
  DynamicQueryResult, BusinessProcessStatelessQueryResult, BusinessProcessStatelessInstanceViewModel, BusinessProcessStateGridDataContext,
  BusinessProcessStateGridDataInstanceViewModel, BusinessProcessStateGridDataQueryResult, ItemSource, BusinessProcessStateLessActionDetail,
  Action, BusinessProcessStatelessUserAction, BusinessProcessParam, BusinessProcessStateGridData, StateGenericDataGridWidgetInstance, BusinessProcessStatelessDependantDataItemSource, StateDataGroup, ControlData, ColumnNameWithDataType, BusinessProcessStateDataGridUserAction, DocumentTemplateView, DocumentTemplate, DocumentTemplateDetail, DocumentTemplateData, DocumentTemplateContent, DocumentTemplateFunctionResult, DocumentTemplateFunctionColumnDetail, FileContent
} from '../WorkflowDashBoard/WorkflowDashBoard.model'
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { GenericService, ResponseContentType } from '../common/common.service';
import { environment } from '../environments/environment';
import { DatePipe } from '@angular/common';
import { DashboardappComponent } from '../DashBoardManagement/dashboardapp/dashboardapp.component';
import { LazyLoadingService } from '../common/lazyloading';
import { StatelessWorkflowComponent } from '../StatelessWorkflow/StatelessWorkflow.component';
import { ScoringQualitativeDetail } from '../WorkflowDashBoard/Controls/WFScoringQualitativeDetail/WFScoringQualitativeDetail.component';
import { ScoringQuantitativeDetail } from '../WorkflowDashBoard/Controls/WFScoringQuantitativeDetail/WFScoringQuantitativeDetail.component';
import { ScoreAnalysis } from '../WorkflowDashBoard/Controls/ScoreAnalysis/ScoreAnalysis.component';
import { PowerBI } from '../WorkflowDashBoard/Controls/PowerBIControl/PowerBI.component';
import { UtilityService } from '../common/utility.service';
import { catchError, filter, map } from 'rxjs/operators';
import { Constants } from '../common/constants'; //FB38211-charles
import { ConfirmationComponent, ConfirmationType } from '../common/Controls/Confirmation/confirmation.component';
import CustomStore from 'devextreme/data/custom_store';
import { wfBusinessProcessStateActionExecute, wfBusinessProcessStateDataGridAction } from '../business-process-management/ChildComponents/BusinessProcessState/State.model';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import { Column } from '../DocumentTemplateMangement/DocumentTemplateMangement.service';
import { DatePickerService } from '../common/date-picker/date-picker.service';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import { DocumentCategories } from '../DocumentTemplateMangement/DocumentTemplateMangement.model';
import { FileManager } from '../FileManager/FileManager.component';
import { Location } from '@angular/common';
import { ExportService } from '../common/export.service';

@Component({
    selector: 'app-WorkflowDashBoard',
    templateUrl: './WorkflowDashBoard.component.html',
    styleUrls: ['./WorkflowDashBoard.component.css'],
    providers: [Service, UtilityService],
    standalone: false
})
export class WorkflowDashBoardcomponent {

  private __sUserName: string;
  private __oBusinessProcessViewModels: BusinessProcessViewModel[] = [];
  private __oBusinessProcessFilterViewModels: BusinessProcessViewModel[] = [];
  private __oWFBusinessProcessDefinition: BusinessProcessDefinitionDetail;
  private __oBusinessProcessDefinitionName: string;
  private __oBusinessProcessStateName: string;
  private __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public __oFroalaEditorOptions: Object = {};
  public __oFroalaEditorOptionReadOnly: Object = {};
  public __IsFroalaConfigReady = false;
  private __oBusinessProcessStates: BusinessProcessStateHTML[];
  hideDashboardMenu: boolean = false;

  private __sStartNewProcessButtonText: string = "Start New Process";
  private __bStartNewProcessButtonVisible: boolean = false;
  private __oBusinessProcessInstanceViewModel: BusinessProcessInstanceViewModel;

  private __oStatecolumns: Array<any> = [];
  private __oStateDataSource: Array<any> = [];

  private __bStateRightPanelVisisble: boolean = true;
  private __bStateInstanceRightPanelVisisble: boolean = false;

  private __oBusinessProcessInstanceCurrentStateDatas: BusinessProcessInstanceCurrentStateData[];

  private __oBusinessProcessStateActions: BusinessProcessStateAction[];

  private __oBusinessProcessStateActionExecutes: BusinessProcessStateActionExecute[];

  private __oWFTabs: WorkFlowTab[];

  public __bIsLoadingVisible: boolean = false;

  private __iBusinessProcessAccordionSelectedIndex: number = 0;

  private __oInstanceAllStateData: JSONCurrentInstanceData[] = [];
  private __oInstanceCurrentStateData: JSONCurrentInstanceData[] = [];
  private __sInstanceComment: string = null;
  private __sInstanceName: string = null;
  private __sAuditInfo: string = null;

  private __bIsOpenedThroughURL: boolean = false;
  private __sUserAction: string = null;
  @Input() public __sURLBPDId: number;//FB47640-Pawan Prajapati
  @Input() public __sURLBPI: number;//FB47640-Pawan Prajapati
  @Input() public __sURLBPS: number;//FB47640-Pawan Prajapati
  private __sURLBPRAID: number;
  private __sURLBPRA: string;
  @ViewChild("documentTemplates") documentTemplatesInstance;

  public __bHideInboxPageForUserActionThroughURL: boolean = false;
  private __sUserActionExecuteResult: string = null;

  private __oFileDetails: FileDetail[] = [];
  private __bShowFileManager: boolean = false;
  private __oBusinessProcessConfig: BusinessProcessConfig = null;
  private __oSwitchPortal: SwitchPortal = null;
  private __iMenuId: number;
  private __oSub: any;
  public __sBreadCrumbs: string = '';
  private __lDataGridColumns: any[] = [];
  private __oGridDatacolumns: any[] = [];
  private __oGridDataItemSource: any[] = [];
  private __oBusinessProcessStateGridDataContext: BusinessProcessStateGridDataContext[] = [];
  private __oBusinessProcessStateGridDataQueryResult: BusinessProcessStatelessQueryResult[] = [];
  @ViewChild('StateDataGrid') stateDataGrid: DxDataGridComponent;
  private __oStateDataGridSelectedKeys: number[] = [];
  private __bAutoCompleteOpened: boolean = false;
  private __iExecutedRuleActionId: number = 0;
  private __oBusinessProcessStateDataGridActionExecuteWebUrls: string[] = [];
  // #region Stateless workflow

  private __bStateWorkflowVisible: boolean = false;
  private __bStatelessWorkflowVisible: boolean = false;
  private __oBusinessProcessStateLessDefinitionDetails: BusinessProcessStateLessDefinitionDetail[] = [];

  //private __oStatelessDataContext: Array<any> = [];
  private __oStatelesscolumns: Array<any> = [];
  //private __oStatelessItemSource: any;

  private __oBusinessProcessStatelessQueryResult: BusinessProcessStatelessQueryResult[] = [];
  private __oBusinessProcessStatelessDataContext: BusinessProcessStatelessDataContext[] = [];

  private __oMultiSelectControlColumnIndex: number[] = [];
  private __oStatelessColumnDetail: string[] = [];
  private __oStatelessGridSelectedKeys: number[] = [];
  private __oBusinessProcessStateLessActionDetail: BusinessProcessStateLessActionDetail[] = [];
  private __oBusinessProcessStateLessCommonAction: Action[] = [];
  private __oBusinessProcessStateLessActionExecuteWebUrls: string[] = [];

  private __sWFName: string = null;
  private __sIsFilterApplied: string = null;
  private __sParam: string = null;
  private __oStatelessGridMasterDetailOption: any;

  private __oUserDefinedWorkflowNames: string[] = ['Collateral Substitution - Cpty Calls', 'Collateral Substitution - Our Calls', 'Counterparty Limit Change', 'Manually Loaded Exposures', 'Limits Deviation', 'Manually Adjusted Exposure', 'MAC Event Restriction', 'Collateral Workflow - Our Calls', 'Collateral Workflow - Cpty Calls', 'Auto Settle Margin Calls', 'Collateral Interest - Cpty Calls', 'Collateral Interest - Our Calls', 'Trade Restriction Instruction', 'Approval Of Contracts', 'Limits Deviated', 'PD Matrix Audit', 'Collateral Expiry', 'MAC Event Restriction Overridden', 'PR Re-Run'];
  private __sWFNameInQueryString: string = null;
  private __oStatelessGridFilters: any = null;
  private __oStatelessGridSortings: any[] = [];
  private __oStatelessGridColumnDetail: any = null;
  public __bStateLessGridAddRowButtonVisible: boolean = false;
  __sEntityGroup: string = "Workflow Inbox";
  // #endregion

  //private __oElement: any;

  private __sKAESCreditRequestWorkflowName: string = 'Credit Request';
  private __oStateDataGridWidgetInstances: StateGenericDataGridWidgetInstance[] = [];


  @ViewChild("Inboxaccordion") InboxaccordionControl: DxAccordionComponent;
  @ViewChild("GridStatelessInstances") dataGrid: DxDataGridComponent;
  //@ViewChild(CustomPropertyComponent) __oCustomPropertyComponent: CustomPropertyComponent;

  private __activeProcess: number = -1;
  private __activeState: number = -1;


  //START: StatelessWF Tab implimentation
  private __bStatelessParentContainer: boolean = false;
  private __lStatelessWorkflowTabs: any[] = [];

  private __oStateDataGroup: StateDataGroup[] = [];
  private __oControlData: ControlData[] = [];

  private __oStateGenericDataGridMasterDetailOption: any;

  oStatelessworkflowComponent: StatelessWorkflowComponent = null;

  oStatelessworkflowComponentNonParent: StatelessWorkflowComponent = null;

  private __bStateDataValueChanged: boolean = false;
  __TPSelectedIndex: number = -1;
  __TPSelectedItem: any = {};

  //END: StatelessWF Tab implimentation

  __oDGStateActionsCog: any = {};


  @ViewChild(ConfirmationComponent) __oConfirmationComponent: ConfirmationComponent;

  //StartFB47640-Pawan Prajapati
  public __bHideStateSidebar: boolean = false;
  public __bIsFullWidthContent: boolean = false;
  @Output() public __oOnClosePopup: EventEmitter<string> = new EventEmitter<string>();
  //End FB47640-Pawan Prajapati

  private swfBusinessProcessRuleAction: string;  //FB47642-Pawan Prajapati
  public __bIsLoadingVisibleForPermission: boolean = false;//FB48599-Pawan Prajapati

  public __bIsDataGridAddRowViaPopup: boolean = false;
  public __bIsDataGridViewViaPopup: boolean = false;
  public oDataGridAddRowPopupDataContext: BusinessProcessInstanceCurrentStateData;
  public __bIsClickOkOrCancelButtonOnPopup: boolean = false;
  isEditorDisplay: boolean = false;
  //document generate
  public __bIsDataGridDocumentGeneratePopup: boolean = false;
  public __oDocumentTemplates: DocumentTemplate[] = [];
  public __oTemplatesByCategory: DocumentTemplate[] = [];
  public __oDocumentTemplateDetails: DocumentTemplateView[] = [];
  public __oDocumentCategories: DocumentCategories[] = [];
  public templates: number[] = [];
  public templateContent: string;
  public selectedTemplate: DocumentTemplate;
  public __selectedCategory: DocumentCategories[] = [];
  public documentTemplateFunctionParameter: any;
  public documentTemplateKeyValuePairs: any;
  public lwfBusinessProcessStateDataGridActionId: number;
  public isDocumentGenerateFroStateAction: boolean = false;
  public lwfBusinessProcessRuleActionId: any;
  public hideTemplateDropDown: boolean = false;
  public __oBusinessProcessStateDisplayName: string;
  public oDataGridAddRowPopupItemSource: BusinessProcessStateGridDataContext;
  private __sXMLProcessStateData: string;
  public __bSharepointDocumentGeneratePopup: boolean = false;
  public __sFileSystem: string = "";
  public __sDirectory: string = "";
  public __bUploadSharepointFileManagerReady: boolean = false;
  private selectedTabIndex: number = 0;
  @ViewChild('filemanager_UploadSharePoint') __oFileManagerSharePoint: FileManager;
  constructor(@Inject(DOCUMENT) private document: any, public WFservice: Service, public service: GenericService,
  private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private http: HttpClient, private lazyLoadingService: LazyLoadingService,
  private dashboardappComponent: DashboardappComponent, public __oUtilityService: UtilityService, 
      public datePickerService: DatePickerService, private sanitizer: DomSanitizer, public exportService: ExportService, private location: Location) 
  {
  this.__oStateGenericDataGridMasterDetailOption = { enabled: true, template: 'detail' }

  this.dashboardappComponent.__bIsPopUpLoadingVisible = false;

  this.__oStatelessGridMasterDetailOption = { enabled: true, template: 'detail' }

    // #region opening through URL
        // this.InitialCall();
  }
  
  InitialCall() {
    this.__sUserAction = this.route.snapshot.paramMap.get('UserAction');

  if (this.__sUserAction != undefined && this.__sUserAction != null) {
    this.__bIsOpenedThroughURL = true;

    if (this.__sUserAction == 'Open') {

        this.__sWFNameInQueryString = this.route.snapshot.paramMap.get('Name');
        this.__sParam = this.route.snapshot.paramMap.get('Param');
        this.__sURLBPDId = parseInt(this.route.snapshot.paramMap.get('BPD'));
        this.__sURLBPI = parseInt(this.route.snapshot.paramMap.get('BPI'));
        this.__sURLBPS = parseInt(this.route.snapshot.paramMap.get('BPS'));

    if ((!Number.isNaN(this.__sURLBPDId) && !Number.isNaN(this.__sURLBPI) && Number.isNaN(this.__sURLBPS)) || (!Number.isNaN(this.__sURLBPDId) && Number.isNaN(this.__sURLBPI) && !Number.isNaN(this.__sURLBPS))) {
        if (this.route.snapshot.paramMap.get('BPS').startsWith("hidesidepanel")) {
          this.__sURLBPS = parseInt(this.route.snapshot.paramMap.get('BPI'));
          this.__sParam = this.route.snapshot.paramMap.get('BPS');
          this.__sURLBPI = null;
        }
        this.OpenStateWorkflowInstancesForSelectedState();
      } else {
        if (Number.isNaN(this.__sURLBPDId)) {
          if (!this.__sWFNameInQueryString) {
            this.__sWFNameInQueryString = this.route.snapshot.paramMap.get('BPD')
          }
          this.__sParam = this.route.snapshot.paramMap.get('BPS');
        }
        this.OpenStateWorkflowInstance();
      }

    }
    else if (this.__sUserAction == 'Execute') {
      this.__bHideInboxPageForUserActionThroughURL = true;
      this.__bIsOpenedThroughURL = true;

      this.__sURLBPDId = parseInt(this.route.snapshot.paramMap.get('BPD'));
      this.__sURLBPI = parseInt(this.route.snapshot.paramMap.get('BPI'));
      this.__sURLBPS = parseInt(this.route.snapshot.paramMap.get('BPS'));
      this.__sURLBPRAID = parseInt(this.route.snapshot.paramMap.get('BPRAID'));
      this.__sURLBPRA = this.route.snapshot.paramMap.get('BPRA');


      let oBusinessProcessUserAction: BusinessProcessUserAction = new BusinessProcessUserAction();

        oBusinessProcessUserAction.lwfBusinessProcessInstanceId = this.__sURLBPI;
        oBusinessProcessUserAction.lwfBusinessProcessStateId = this.__sURLBPS;
        oBusinessProcessUserAction.lwfBusinessProcessRuleActionId = this.__sURLBPRAID;
        this.lwfBusinessProcessRuleActionId = this.__sURLBPRAID;
        oBusinessProcessUserAction.swfBusinessProcessRuleAction = this.__sURLBPRA;

      oBusinessProcessUserAction.sXMLProcessInstanceStateData = null;
      oBusinessProcessUserAction.swfBusinessProcessInstanceComments = "UserActionThroughURL"; //FB 28587 - Vidya


      this.service.UpdateAllDataByPromise(oBusinessProcessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostUserAction").then(
        result => this.OnSuccessSave(result, false)
      ).
        catch(error => this.OnError(error))

    }
    else if (this.__sUserAction == 'New') {
      this.__sURLBPDId = parseInt(this.route.snapshot.paramMap.get('Name'));
      if (Number.isNaN(this.__sURLBPDId)) {
        this.__sURLBPDId = parseInt(this.route.snapshot.paramMap.get('BPD'));
      }

      this.__sParam = this.route.snapshot.paramMap.get('Param');
      this.__sParam = this.route.snapshot.paramMap.get('BPS');

      this.__bIsOpenedThroughURL = true;
      this.__bStatelessWorkflowVisible = false;
      this.__bStateWorkflowVisible = true;
      this.OpenStateWOrkflowNewInstance();
    }
    else if (this.__sUserAction == 'OpenSL') {
      this.__bIsOpenedThroughURL = true;

      this.__sWFName = this.route.snapshot.paramMap.get('Name');

      if (this.__sWFName == null || this.__sWFName == '' || this.__sWFName == undefined) {
        this.__sWFName = this.route.snapshot.paramMap.get('BPD');
      }


      this.__sIsFilterApplied = this.route.snapshot.paramMap.get('BPI');
      this.__sParam = this.route.snapshot.paramMap.get('BPS');

      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcesses").then((Data) => {

        if (Data != null) {
          this.__oBusinessProcessViewModels = Data;
          this.hideSidePanelForStatelessWorkflow();
          for (let oBPVM of this.__oBusinessProcessViewModels) {
            let oBP: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == this.__sWFName);

            if (oBP != null) {
              let iIndex = this.__oBusinessProcessViewModels.indexOf(oBPVM);
              this.__iBusinessProcessAccordionSelectedIndex = iIndex;

              for (var oBPS of oBPVM.BusinessProcesses) {
                //Start FB 13378, Handled special character check in the WF name.
                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + oBPS.BusinessProcess.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                  //End FB 13378, Handled special character check in the WF name.
                  if (Data != null) {

                    try {
                      var oCount = JSON.parse(Data);
                    }
                    catch
                    {
                      console.log(Data);
                    }

                    let oBusinessProcessHTML: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);

                    oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;

                  }

                });

              }

              oBPVM.GetIsCountFetched = 1;
              return;
            }
          }


        }

      });
      this.OnBusinessProcessButtonClicked(this.__sWFName, 0);

    }
  }
  else {
    this.__bIsOpenedThroughURL = false;

    //#region Authenticate checking

    this.service.getAuthenticate().subscribe(
      data => {
        this.__sUserName = data
        //START Rajendra -- FB 20697 -- SSO Message
        if (!this.service.VerifyGetAuthenticate(this.__sUserName, this.router)) {
          return;
        }
        //END Rajendra -- FB 20697 -- SSO Message
        this.GetBusinessProcesses();
      }
    );
    //#endregion
  }

  // #endregion


  this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessConfig").then((Data) => {

    if (Data != null && Data.length > 0) {
      this.__oBusinessProcessConfig = Data[0];

      if(this.__oBusinessProcessConfig?.FilePath!=null && this.__oBusinessProcessConfig?.FilePath!='')
      {
        this.__oBusinessProcessConfig.FilePath=this.__oUtilityService.DecryptStringAES(this.__oBusinessProcessConfig.FilePath, Constants.EXTERNALSOURCE_AESKEY);
      }
      this.__sKAESCreditRequestWorkflowName = this.__oBusinessProcessConfig.KAESCreditRequestBusinessProcessName;
    }

  });


  this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetSwitchPortal").then((Data) => {

    if (Data != null) {
      this.__oSwitchPortal = Data[0];
    }

  });
  this.service.getDataByObservable(this.__sGetApiUrl + "api/CommonBase/FroalaKey").subscribe((data) => {
    if (data != null) {
      //#region Froala editior options
      let that = this; // Store component reference
      this.__oFroalaEditorOptions = {
        key: data,
        attribution: false,
        heightMin: 100,
        heightMax: 230,
        width: 800,
        charCounterMax: 20000,
        charCounterCount: false,
        tableResizer: true,
        imageResize: true,
        useClasses: false,
        placeholderText: 'Enter Details ...',
        // Set the image upload parameter.
        imageUploadParam: 'image_param',

        // Set the image upload URL.
        imageUploadURL: 'assets/upload_image',

        // Additional upload params.
        imageUploadParams: { id: 'my_editor' },

        // Set request type.
        imageUploadMethod: 'POST',

        imageDefaultAlign: 'left',
        imageDefaultDisplay: 'inline-block',
        // Set max image size to 5MB.
        imageMaxSize: 5 * 1024 * 1024,

        // Allow to upload PNG and JPG.
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'textColor', 'backgroundColor', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'undo', 'redo'],
        //toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertFile', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'help', 'html', '|', 'undo', 'redo'],
        colorsBackground: [
          '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
          '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
        ],
        colorsStep: 6,
        colorsText: [
          '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
          '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
        ],
        pluginsEnabled: ['align', 'colors', 'draggable', 'fontFamily', 'fontSize', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'print', 'quote', 'image', 'table', 'specialCharacters', 'url', 'wordPaste'],
        events: {
          'froalaEditor.initialized': function (e: any, editor: any) {

          },
          'image.beforeUpload': function (images) {

            const formData = new FormData();

            for (let fileIndex in images) {
              if (fileIndex.toUpperCase() != 'LENGTH' && fileIndex.toUpperCase() != 'ITEM') {
                let file: File = images[fileIndex];
                formData.append('image', file, file.name);
              }
            }

            let sLink: string = '';

            let headers = new Headers()
            let options = new Object({ headers: headers, withCredentials: true });

            let apiUrl1 = that.__sGetApiUrl + "api/WorkflowDashBoard/UploadImage";
            that.http.post(apiUrl1, formData, options)
              .pipe(map(res => JSON.parse(JSON.stringify(res)), catchError(error => throwError(error))))
              .subscribe(
                data => sLink = data,
                error => console.log(error),
                () => {

                  this.image.insert(sLink, null, null, this.image.get());

                }
              )

            console.log('before upload');
            return false;
          },
          'froalaEditor.mousedown': (e, editor, mousedownEvent) => {

          },
          'froalaEditor.mouseup': (e, editor, mouseupEvent) => {

          }

        }
      };
      this.__oFroalaEditorOptionReadOnly = {
        key: data,
        attribution: false,
        heightMin: 100,
        // heightMax: 230,
        width: 800,
        charCounterMax: 20000,
        charCounterCount: false,
        tableResizer: true,
        imageResize: true,
        useClasses: false,
        placeholderText: '',
        // Set the image upload parameter.
        imageUploadParam: 'image_param',
    
        // Set the image upload URL.
        imageUploadURL: 'assets/upload_image',
    
        // Additional upload params.
        imageUploadParams: { id: 'my_editor' },
    
        // Set request type.
        imageUploadMethod: 'POST',
    
        // Set max image size to 5MB.
        imageMaxSize: 5 * 1024 * 1024,
    
        // Allow to upload PNG and JPG.
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    
        toolbarButtons: [],
        pluginsEnabled: [],
        events: {
          'initialized': function () {
            this.edit.off();
          }
        },
    
      }
      this.__IsFroalaConfigReady = true;
    }
  });

  //Get breadcrum
  this.__oSub = this.route.params.subscribe(params => {
    this.__iMenuId = +params['menuId']; // (+) converts string 'id' to a number
    if (this.__iMenuId) {
      this.__sBreadCrumbs = '';
      this.service.getDataByObservable(this.__sGetApiUrl + "api/PortalMenu/DashBoardPortalmenuHierarchy/" + this.__iMenuId).subscribe(res => {
        if (res.length > 0) {
          this.__sBreadCrumbs = res.map(a => a.DashBoardPortalMenu).join('> ');
        }
      });
    }
  });



}





  AddTodayButtonClicked(e:any,DataCaption : string) {
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.DataCaption == DataCaption);
    oBusinessProcessInstanceCurrentStateData.DataValue = new Date();
    if (!this.__oUtilityService.IsNullOrUndefined(e.element)) {
      if (!this.__oUtilityService.IsNullOrUndefined(e.element.className)) {
        e.element.className = "dx-widget dx-button dx-button-mode-contained dx-button-default dx-button-has-text dx-state-active";
      }
    }
  }

  ngOnInit() {
    this.__bIsLoadingVisible = true;

    (this.router.events as Observable<RouterEvent>)
    .pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (event.url.includes('/Inbox/10/Open/') || event.url.includes('/Inbox/10/OpenSL/') || event.url.includes('/Inbox/10/New/')) {
        window.location.reload();
        }

        this.InitialCall();
        this.__bIsLoadingVisible = false;
        
    });
    this.route.paramMap.subscribe(params => {
      this.__sUserAction = params.get('UserAction');
      this.InitialCall();
    });
    this.route.queryParamMap.subscribe(params => {
      this.hideDashboardMenu = params.get('hideDashboardMenu') === 'true';
    });
  }
  //StartFB47640-Pawan Prajapati
  ngOnChanges(oSimpleChanges: SimpleChanges) {
    if (oSimpleChanges && oSimpleChanges.__sURLBPI && this.__sURLBPDId && this.__sURLBPI && this.__sURLBPS) {
      if (oSimpleChanges.__sURLBPI.firstChange) {
        this.OpenStateWorkflowInstance();
      } else {
        this.GetBusinessProcessInstanceCurrentStateData(this.__sURLBPI);
      }
    }

  }
  //End FB47640-Pawan Prajapati
  public searchButton: any = {};
  public __WorkFlowInstanseSearchValue: string = '';
  public __WorkFlowInstanseSearchDataSource: any = {};
  ngAfterViewInit() {
    this.searchButton = {
      icon: "search",
      type: "default",
      onClick: () => {
        this.GOButtonClicked();
      }
    }
    this.LoadDataStore();
    if (this.router.url.indexOf('hidesidepanel:true') > -1) {
      this.hideSidePanel();
    }
  }
  LoadDataStore() {
    this.__WorkFlowInstanseSearchDataSource = {
      store: new CustomStore({
        load: (loadOptions: any) => {
          return this.LoadDataToWorkFlowInstanseSearchAutoEntities(!this.__oUtilityService.IsNullOrEmpty(this.__WorkFlowInstanseSearchValue) ? this.__WorkFlowInstanseSearchValue : loadOptions.searchValue);
        }
      })
    };
  }
  LoadDataToWorkFlowInstanseSearchAutoEntities(eValue: any) {
    let oBusinessProcessViewModel: any = [];
    if (eValue !== '' && eValue !== "" && eValue !== null && eValue !== undefined) {
      let oModel = JSON.parse(JSON.stringify(this.__oBusinessProcessViewModels));
      oModel.forEach(x => {
        if (x.BusinessProcesses.length) {
          x.BusinessProcesses = x.BusinessProcesses.filter(oBusinessProcesses => oBusinessProcesses.BusinessProcess.toUpperCase().indexOf(eValue.toUpperCase()) > -1);
          if (x.BusinessProcesses.length)
            x.BusinessProcesses.forEach(y => { oBusinessProcessViewModel.push(y.BusinessProcess); });
        }
      });
      return oBusinessProcessViewModel;
    }
  }
  GOButtonClicked() {
    this.__oBusinessProcessViewModels.forEach(x => {
      x.BusinessProcesses.forEach(y => {
        if (y.BusinessProcess === this.__WorkFlowInstanseSearchValue) {
          this.__activeProcess = x.BusinessProcesses.indexOf(y);
          this.__iBusinessProcessAccordionSelectedIndex = this.__oBusinessProcessViewModels.indexOf(x);
        }
      });
    });
    this.OnBusinessProcessButtonClicked(this.__WorkFlowInstanseSearchValue, this.__activeProcess);
  }
  onSelectionChanged(e: any) {
    if (!this.__oUtilityService.IsNullOrEmpty(e.selectedItem)) {
      this.__WorkFlowInstanseSearchValue = e.selectedItem;
    }
  }
  //#region button click events

  OnBusinessProcessButtonClicked(e: any, index: any) {

    this.__bStateInstanceRightPanelVisisble = false;
    this.__bStateRightPanelVisisble = true;
    this.__bIsLoadingVisible = true;
    this.__oStateDataSource = [];
    this.__oStatecolumns = [];
    this.__oBusinessProcessStateName = '';
    this.__sInstanceName = '';
    this.__activeProcess = index;
    this.__activeState = -1; //FB 27348 - Vidya
    //this.__bStatelessParentContainer = false;
    // opening user defined workflows in silverlight

    if (this.__oUserDefinedWorkflowNames.find(x => x == e) != null) {
      let sWebURL: string = this.__oSwitchPortal.UrlSilverLIght;
      sWebURL = sWebURL.replace('RCPortalFrameWork.aspx', '');
      sWebURL = sWebURL + "/wfDataCaptureFormSL.aspx?Form=Workflow&Name=" + e.replace(/&/g, '%26');
      this.__bIsLoadingVisible = false;
      window.open(sWebURL, "_blank");
      return;
    }

    this.__oBusinessProcessDefinitionName = e;

    //Start FB 13378, Handled special character check in the WF name.
    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetwfBusinessProcessDefinition/" + this.replaceAllExportString(e.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash"))).then((Data) => {
      //End FB 13378, Handled special character check in the WF name.
      if (Data != null) {
        this.__oWFBusinessProcessDefinition = Data;

        if (this.__oWFBusinessProcessDefinition.wfBusinessProcessModel == 'State') {
          this.__bStatelessWorkflowVisible = false;
          this.__bStateWorkflowVisible = true;
          this.oStatelessworkflowComponentNonParent = null;
          //Start FB 13378, Handled special character check in the WF name.
          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStates/" + this.replaceAllExportString(e.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash"))).then((Data) => {
            //End FB 13378, Handled special character check in the WF name.
            if (Data != null) {
              this.__oBusinessProcessStates = Data;
              if (this.hideDashboardMenu) {
                $('.pCollapsable').css({ 'top': '4.5rem' });
                $('.pStateCollapsable').css({ 'top': '4.5rem' });
                $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
                $('#statesPane').css({ 'height': 'calc(100vh - 8.5rem)' });
                $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 8.5rem)' });
              } else {
                this.showDashboardMenu();
              }

              this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetPermissionInfo/138/" + this.__oWFBusinessProcessDefinition.lProcessStartUpRuleId).then((Data) => {

                if (Data != null) {

                  if (Data == 1) {
                    this.__bStartNewProcessButtonVisible = true;
                    this.__sStartNewProcessButtonText = this.__oWFBusinessProcessDefinition.wfBusinessProcessRuleAction;

                    if (this.__sStartNewProcessButtonText == null || this.__sStartNewProcessButtonText.trim() == '') {
                      this.__bStartNewProcessButtonVisible = false;
                    }
                  }
                  else {
                    this.__bStartNewProcessButtonVisible = false;
                  }

                }

                this.__bIsLoadingVisible = false;
              });

            }



          });


        }
        else {
          this.RefreshStatelessGrid();
          if (this.hideDashboardMenu) {
            $('.pCollapsable').css({ 'top': '4.5rem' });
            $('.pStateCollapsable').css({ 'top': '4.5rem' });
            $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
            $('#statesPane').css({ 'height': 'calc(100vh - 8.5rem)' });
            $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 8.5rem)' });
          } else {
            this.showDashboardMenu();
          }
          //this.__bIsLoadingVisible = false;
          //this.__oStatelessItemSource = [];
          //this.__oStatelessDataContext = [];
          //this.__oStatelessItemSource = [];

          //let sItemSOurce1 = '[{"DisplayMember":"Barclays"},{"DisplayMember":"BNP"}]';
          //let sItemSOurce2 = '[{"DisplayMember":"Barclays1"},{"DisplayMember":"BNP1"}]';
          //let sItemSource3 = [];


          //let oIS1 = JSON.parse(sItemSOurce1);
          //let oIS2 = JSON.parse(sItemSOurce2);

          ////this.__oStatelessItemSource.push(oIS1);
          ////this.__oStatelessItemSource.push(oIS2);
          ////this.__oStatelessItemSource.push(sItemSource3);


          //this.__oStatelesscolumns.push({
          //  //dataField: "DataValue[" + 1 + "]",
          //  caption: 'Tradingcounterparty',
          //  cellTemplate: 'cellTemplateComboBox',
          //  width: 250
          //  //lookup: {
          //  //  dataSource: this.__oStatelessItemSource[0]
          //  //}

          //})


          //this.__oStatelesscolumns.push({
          //  //dataField: "DataValue[" + 1 + "]",
          //  caption: 'Tradingcounterparty Multiselect',
          //  cellTemplate: 'cellTemplateMultiSelect',
          //  width: 250
          //  //lookup: {
          //  //  dataSource: this.__oStatelessItemSource[0]
          //  //}

          //})


          //this.__oStatelesscolumns.push({
          //  //dataField: "DataValue[" + 1 + "]",
          //  caption: 'Tradingcounterparty AutoComplete',
          //  cellTemplate: 'cellTemplateAutoComplete',
          //  width: 250
          //  //lookup: {
          //  //  dataSource: this.__oStatelessItemSource[0]
          //  //}

          //})


          //this.__oStatelesscolumns.push({
          //  caption: 'lTradingcounterpartyId',
          //  cellTemplate: 'cellTemplateMultiline',
          //  width: 250
          //})

          //this.__oStatelesscolumns.push({
          //  caption: 'Description',
          //  cellTemplate: 'cellTemplateMultiline',
          //  width: 250
          //})

          //this.__oStatelesscolumns.push({
          //  caption: 'caption',
          //  cellTemplate: 'cellTemplate',
          //  width: 250
          //})


          //this.__oStatelesscolumns.push({
          //  caption: 'index',
          //  cellTemplate: 'cellTemplate1',
          //  width: 250
          //})

          //let sDataCOntext: BusinessProcessStatelessDataContext[] = [];

          //let sJSON = '[{"lTradingcounterpartyId":"1","Tradingcounterparty":"Barclays","Description":"Barclays PLC","DataValue":["1","Barclays"]}]';

          //sDataCOntext = JSON.parse(sJSON);


          //for (var obj of sDataCOntext)
          //{

          //  obj.ItemSource = [];

          //  let sItemSOurce1 = '[{"DisplayMember":"Barclays"},{"DisplayMember":"BNP"}]';
          //  let sItemSOurce2 = '[{"DisplayMember":"Barclays1"},{"DisplayMember":"BNP1"}]';
          //  let sItemSource3 = [];


          //  let oIS1 = JSON.parse(sItemSOurce1);
          //  let oIS2 = JSON.parse(sItemSOurce2);

          //  obj.ItemSource.push(oIS1);
          //  obj.ItemSource.push(oIS2);
          //  obj.ItemSource.push(sItemSource3);

          //  obj.MultiSelectedItems = [];
          //  let Multiselect = [];
          //  let multiselect2 = [];
          //  let multiselect3 = [];
          //  obj.MultiSelectedItems.push(Multiselect);
          //  obj.MultiSelectedItems.push(multiselect2);
          //  obj.MultiSelectedItems.push(multiselect3);

          //}

          //this.__oStatelessDataContext = sDataCOntext;




        }


      }

    });

  }

  OnBusinessProcessStateButtonClicked(e: any, index: any) {
    this.__oBusinessProcessStateName = e;
    this.__bIsLoadingVisible = true;
    this.__oStatecolumns = [];
    this.__activeState = index;
    this.__bStateInstanceRightPanelVisisble = false;
    this.__bStateRightPanelVisisble = true;

    //Start FB 13378, Handled special character check in the WF name.
    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstances/" + this.replaceAllExportString(this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")) + "/" + this.replaceAllExportString(this.__oBusinessProcessStateName.replace("&", "annd").replace("/", "baccckslash").replace('+', 'pluuus').replace("\\", "forwardslaaash"))).then((Data) => {
      //End FB 13378, Handled special character check in the WF name.
      if (Data != null) {
        this.__oBusinessProcessInstanceViewModel = Data;
        if (this.__oBusinessProcessInstanceViewModel != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != undefined) {
          this.__oStatecolumns.push({
            caption: "",
            cellTemplate: 'cellTemplate',
            width: '35px',
            allowEditing: false
          })

          for (var oColumn of this.__oBusinessProcessInstanceViewModel.DynamicColumns) {

            if (oColumn.ColumnName == 'Initialized On' || oColumn.ColumnName == 'Initialized_On') { //FB38211-charles
              this.__oStatecolumns.push({
                dataField: oColumn.ColumnName,
                caption: oColumn.ColumnName.replace("_", " "),
                allowEditing: false,
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                sortOrder: 'desc',
                dataType: 'date',
                format: 'dd-MMM-yyyy HH:mm:ss' //FB 25619 - Vidya
              })
            }
            else {
              this.__oStatecolumns.push(this.makeColumn(oColumn)); //FB38211-charles
            }
          }

        }

        try {

          let sStateGridInstance = this.__oUtilityService.EscapeCharacters(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);//fb 37019 Rajendra tab key
          /* Start FB 19240 VIDYA 11/08/2020*/
          // sStateGridInstance = sStateGridInstance.replace(/quoootes/g, '\\"').replace(/backslaaash/g, "\\\\");;
          /* End FB 19240 VIDYA 11/08/2020*/
          sStateGridInstance = this.replaceAllSpecialCharacters(sStateGridInstance);// FB 25619 - Vidya
          this.__oStateDataSource = JSON.parse(sStateGridInstance);
        }
        catch
        {
          console.log(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);
        }

      }

      this.__bIsLoadingVisible = false;

    });

  }

  OnNewProcessButtonClicked(e: any) {
    this.__bIsLoadingVisible = true;
    this.__oFileDetails = [];
    this.__activeState = 0;
    //Start FB 13378, Handled special character check in the WF name.
    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStartNewBusinessProcess/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId + "/" + this.replaceAllExportString(this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash"))).then((Data) => {
      //End FB 13378, Handled special character check in the WF name.
      if (Data != null) {
        let InstanceId: number = Data;
        this.__oBusinessProcessInstanceCurrentStateDatas = [];
        this.GetBusinessProcessInstanceCurrentStateData(InstanceId);

      }

      this.__bIsLoadingVisible = false;

    });
  }

  onInstanceButtonClick(e: any, Info: any) {
    this.isEditorDisplay = false;
    this.GetBusinessProcessInstanceCurrentStateData(Info.data.__lwfBusinessProcessInstanceId);
  }

  ExecuteUserAction(e: any) {
    //Start FB48599-Pawan Prajapati
    if (e.IsDisabled && e.DisabledMessage) {
      this.__oConfirmationComponent.showAlert(e.DisabledMessage, 'auto', 'Error', ConfirmationType.Error);
      return;
    }
    if (e.IsDisabled) {
      return;
    }
    //End FB48599-Pawan Prajapati
    this.__bIsLoadingVisible = true;
    //this.__sInstanceComment = null;
    //this.__sInstanceName = null; //CRD-4238
    this.__sAuditInfo = null;
    this.__sXMLProcessStateData = null;

    //// Parse CSV string
    //var data = this.__oUtilityService.ParseCSVStringToStringArray('a,b,c,"d,e"');

    //// Convert back to CSV
    //var csv = this.__oUtilityService.ParseStringArrayToCSVString(data);


    if (e.wfBusinessProcessRuleAction == "Exit") {
      this.RefreshWorkflow("Exit");
      this.__bStateInstanceRightPanelVisisble = false;
      this.__bStateRightPanelVisisble = true;
      this.__oOnClosePopup.emit(e.wfBusinessProcessRuleAction);//FB47642-Pawan Prajapati
    }
    else {
      this.__iExecutedRuleActionId = e.lwfBusinessProcessRuleActionId;
      this.lwfBusinessProcessRuleActionId = e.lwfBusinessProcessRuleActionId;
      let oBPSAE: BusinessProcessStateActionExecute = this.__oBusinessProcessStateActionExecutes.find(x => x.lwfBusinessProcessRuleActionId == e.lwfBusinessProcessRuleActionId);

      //Start FB 13378 Workflow issues.
      let oBusinessProcessInstanceCurrentStateDatas: BusinessProcessInstanceCurrentStateData[] = [];
      this.__oBusinessProcessInstanceCurrentStateDatas.forEach(
        x => {
          let a: BusinessProcessInstanceCurrentStateData = Object.assign({}, x);
          if (a.DataValue && (a.DataType == 'Search Box' || a.DataType == 'Multiline String' || a.DataType == 'Alpha Numeric')) {
            a.DataValue = a.DataValue.trim();
          }
          oBusinessProcessInstanceCurrentStateDatas.push(a);
        }
      );
      //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas) {
      for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas) {
        //End FB 13378, Workflow issues.
        if (oCurrentInstance.DataType == 'Multi Select Combo Box') {
          if (oCurrentInstance.MultiSelectedItems != null && oCurrentInstance.MultiSelectedItems.length > 0) {
            //for (let oArrayItem of oCurrentInstance.MultiSelectedItems) {
            //  if (oCurrentInstance.DataValue == null || oCurrentInstance.DataValue == '') {
            //    oCurrentInstance.DataValue = oArrayItem;
            //  }
            //  else {
            //    oCurrentInstance.DataValue = oCurrentInstance.DataValue + ',' + oArrayItem;
            //  }
            //}
            //oCurrentInstance.DataValue = oCurrentInstance.MultiSelectedItems.join(',');
            // FB 28676 Change of format while saving multi-select dropdown values
            oCurrentInstance.DataValue = this.__oUtilityService.ParseStringArrayToCSVString(oCurrentInstance.MultiSelectedItems);

          }
          else {
            oCurrentInstance.DataValue = '';
          }
        }
        else if (oCurrentInstance.DataType == 'Dependent Data Label') {
          oCurrentInstance.DataValue = oCurrentInstance.ItemSource;
        }
        else if (oCurrentInstance.DataType == 'Due Date Specifier') {
          oCurrentInstance.DataValue = oCurrentInstance.DueDate + ',' + oCurrentInstance.DueDateRule;
        }
      }

      if (oBPSAE != null && oBPSAE.IsSkipMandatoryCheck == 0) {
        //Start FB 13378, Workflow issues.
        //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.IsMandatory == 1)) {
        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.IsMandatory == 1)) {
          //End FB 13378, Workflow issues.
          if (oCurrentInstance.DataType != 'Label' && oCurrentInstance.DataType != 'Dependent Data Label' && oCurrentInstance.DataType != 'Grid' && oCurrentInstance.DataType != 'Data Grid' && oCurrentInstance.DataType != 'Qualitative Grid' && oCurrentInstance.DataType != 'Quantitative Grid' && oCurrentInstance.DataType != 'Score Analysis' && oCurrentInstance.DataType != 'Final Score Analysis') {
            if (oCurrentInstance.DataValue === null || oCurrentInstance.DataValue === '') {
              this.__bIsLoadingVisible = false;
              this.__oConfirmationComponent.show(ConfirmationType.Error,
                Constants.MANDATORY_FIELDS_CHECK,
                "Error", "Ok", "Cancel", false);
              return;

            }
          }
          else if (oCurrentInstance.DataType == 'Data Grid') {
            let y = 0;
            let missingField = false;
            oCurrentInstance.BusinessProcessStateGridData.forEach(x => {
              y++;
              if (x.IsMandatory == 1) {
                oCurrentInstance.ItemSource.forEach(z => {
                  if(z.DataValue[y] == null || z.DataValue[y] == '') {
                    missingField = true;
                  }
                });
              }
            });
            if (missingField) {
              this.__bIsLoadingVisible = false;
              this.__oConfirmationComponent.show(ConfirmationType.Error,
                Constants.MANDATORY_FIELDS_CHECK,
                "Error", "Ok", "Cancel", false);
              return;
            }
          }
          //By passing mandatory check for save action on KAES
          else if (oCurrentInstance.DataType == 'Grid' && e.wfBusinessProcessRuleAction.toLowerCase() != 'save') {
            if (this.__oBusinessProcessStateGridDataContext == null || this.__oBusinessProcessStateGridDataContext.length == 0) {
              this.__oConfirmationComponent.show(ConfirmationType.Error,
                Constants.MANDATORY_FIELDS_CHECK,
                "Error", "Ok", "Cancel", false);
              return;
            }
            else {
              if (this.__lDataGridColumns.filter(x => x.IsMandatory == 1).length > 0) {
                for (var oBusinessProcessStateGridDataContext of this.__oBusinessProcessStateGridDataContext) {
                  for (var oDGColumn of this.__lDataGridColumns.filter(x => x.IsMandatory == 1)) {

                    let oQR = oBusinessProcessStateGridDataContext.QueryResult.find(x => x.ColumnName == oDGColumn.DataField);

                    let iColumnIndex: number = oBusinessProcessStateGridDataContext.QueryResult.indexOf(oQR);

                    //let iColumnIndex: number = oDGColumn.DisplayOrder + 1;
                    let sValue = oBusinessProcessStateGridDataContext.DataValue[iColumnIndex + 1];

                    if (sValue == null || sValue.length === 0) {
                      let message: string;
                      let sCounterpartyName: string;
                      try {
                        sCounterpartyName = oBusinessProcessStateGridDataContext.DataValue[1];
                      } catch (e) {

                      }

                      if (sCounterpartyName) {
                        message = "Please fill the mandatory field(s) (' + oDGColumn.DataField + ') for the counterparty ' + sCounterpartyName";

                      }
                      else {
                        message = "Please fill the mandatory field(s) (' + oDGColumn.DataField + ') in the grid";
                      }

                      this.__bIsLoadingVisible = false;
                      this.__oConfirmationComponent.show(ConfirmationType.Error,
                        message,
                        "Error", "Ok", "Cancel", false);
                      return;
                    }
                  }

                }
              }

            }
          }
        }
      }

      let oBusinessProcessUserAction: BusinessProcessUserAction = new BusinessProcessUserAction();

      let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas[0];

      oBusinessProcessUserAction.lwfBusinessProcessInstanceId = oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessInstanceId;
      oBusinessProcessUserAction.lwfBusinessProcessStateId = oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateId;
      oBusinessProcessUserAction.lwfBusinessProcessRuleActionId = e.lwfBusinessProcessRuleActionId;
      this.lwfBusinessProcessRuleActionId = e.lwfBusinessProcessRuleActionId;
      oBusinessProcessUserAction.swfBusinessProcessRuleAction = e.wfBusinessProcessRuleAction;


      let sJSONCurrentInstanceData: string = "";
      //Start FB 13378, Workflow Issues.
      //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null)) {
      for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null)) {
        //End FB 13378, Workflow issues.
        let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');
        //oCurrentInstance.DataValue = oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote');

        if (oCurrentInstance.DataType != 'Multi Select Combo Box' && oCurrentInstance.DataType != 'Date Picker' && oCurrentInstance.DataType != 'Rich Text Box'
          && oCurrentInstance.DataType != 'File Chooser' && oCurrentInstance.DataType != 'Grid' && oCurrentInstance.DataType != 'Data Grid' && oCurrentInstance.DataType != 'Qualitative Grid'
          && oCurrentInstance.DataType != 'Quantitative Grid' && oCurrentInstance.DataType != 'Score Analysis' && oCurrentInstance.DataType != 'Final Score Analysis' && oCurrentInstance.DataType != 'Check Box' && oCurrentInstance.DataType != 'Numeric/Money' && oCurrentInstance.DataType != "Counterparty Tree View") {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/\\"/g, 'doouubleQuote').replace(/"/g, 'doouubleQuote').replace("\\", "forwardslaaash") : oCurrentInstance.DataValue) + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/\\"/g, 'doouubleQuote').replace(/"/g, 'doouubleQuote').replace("\\", "forwardslaaash") : oCurrentInstance.DataValue) + "\"}";
          }
        }
        else if (oCurrentInstance.DataType == 'Multi Select Combo Box') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
        }
        else if (oCurrentInstance.DataType == 'Date Picker') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + ((this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == 'null' || this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == null)
              ? "" : this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd')) + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + ((this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == 'null' || this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == null)
              ? "" : this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd')) + "\"}";
          }
        }
        
        else if (oCurrentInstance.DataType == 'File Chooser') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"File___" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY) + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"File___" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY) + "\"}";
          }
        }
        else if (oCurrentInstance.DataType == 'Check Box' || oCurrentInstance.DataType == 'Numeric/Money') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
          }
        }


      }
      //Start FB 13378, Workflow issues.
      //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null)) {
      for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null && x.DataType != 'Qualitative Grid' && x.DataType != 'Quantitative Grid' && x.DataType != 'Score Analysis' && x.DataType != 'Final Score Analysis')) {
        //End FB 13378, Workflow issues.
        if (oCurrentInstance.DataCaption != null) {
          let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

          if (oCurrentInstance.DataType == 'Check Box') {
            if (sJSONCurrentInstanceData == "") {
              sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
            }
            else {
              sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
            }
          }
          else {
            if (sJSONCurrentInstanceData == "") {
              sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
            }
            else {
              sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
            }
          }
        }
      }


      sJSONCurrentInstanceData = this.__oUtilityService.EncodeNewLineTabCharacters(sJSONCurrentInstanceData);//fb 37019 Rajendra tab key

      let oJSONData: string = sJSONCurrentInstanceData;

      sJSONCurrentInstanceData = "[" + sJSONCurrentInstanceData + "]";

      //let JSONString: string = JSON.stringify(sJSONCurrentInstanceData);
      //sJSONCurrentInstanceData = JSONString.replace(/\\n/g, "\\n").replace(/\\r/g, "\\r").replace(/\\t/g, "\\t")

      try {
        this.__oInstanceCurrentStateData = JSON.parse(sJSONCurrentInstanceData);
      }
      catch
      {
        console.log(sJSONCurrentInstanceData);
      }

      sJSONCurrentInstanceData = this.replaceAll(sJSONCurrentInstanceData);

      //let sURL: string = this.__sGetApiUrl + "api/WorkflowDashBoard/GetFieldEntryValidationResult/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessInstanceId + "/" + sJSONCurrentInstanceData + "/" + e.lwfBusinessProcessRuleActionId;

      let oBusinessProcessParam = new BusinessProcessParam();
      oBusinessProcessParam.lwfBusinessProcessInstanceId = oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessInstanceId;
      oBusinessProcessParam.sCurrentInstanceData = sJSONCurrentInstanceData;
      oBusinessProcessParam.lwfBusinessProcessRuleActionId = e.lwfBusinessProcessRuleActionId;
      this.lwfBusinessProcessRuleActionId = e.lwfBusinessProcessRuleActionId;
      if (oBPSAE != null && oBPSAE.IsSkipFieldEntryValidation == 0 && oBPSAE.FieldEntryValidationCondition != '' && oBPSAE.FieldEntryValidationCondition != null && oBPSAE.FieldEntryValidationCondition != undefined) {
        this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/FieldEntryValidationResult").then(
          result => this.OnSuccessFieldEntryValidationResult(result, oJSONData, oBusinessProcessUserAction, e.IsSuccessAlert)
        ).
          catch(error => this.OnErrorFieldEntryValidationResult(error))


        //this.service.getDataByPromise(sURL).then((Data) => {

        //  if (Data != null) {

        //    if (Data == "True" || Data == "true") {

        //      for (let oFileDetail of this.__oFileDetails) {
        //        let sContent: string = oFileDetail.FileContent;

        //        let iIndex: number = sContent.indexOf('base64,');

        //        sContent = sContent.substr(iIndex + 7);

        //        let sDataCaption = oFileDetail.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

        //        if (oJSONData == "") {
        //          oJSONData += "{\"DataCaption\":" + "\"" + sDataCaption + "FileContentInBytes" + "\",\"DataValue\":\"" + sContent + "\"}";
        //        }
        //        else {
        //          oJSONData += ",{\"DataCaption\":" + "\"" + sDataCaption + "FileContentInBytes" + "\",\"DataValue\":\"" + sContent + "\"}";
        //        }
        //      }


        //      for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Rich Text Box')) {
        //        let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

        //        let sDataValue: string = oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote');

        //        if (oJSONData == "") {
        //          oJSONData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sDataValue + "\"}";
        //        }
        //        else {
        //          oJSONData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sDataValue + "\"}";
        //        }

        //      }

        //      //let sstring: string = "<p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">g</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">fdf</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">d</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">fgdf</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \"><br fr-original-style=\"\" style=\"box - sizing: border - box; \"></p>\""

        //      for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Grid')) {
        //        if (oCurrentInstance.DataType == 'Grid') {
        //          let gridItems = this.__oBusinessProcessStateGridDataContext;
        //          let xmlString = '';
        //          for (var i = 0; i < gridItems.length; i++) {
        //            let jObject = new BusinessProcessStateGridDataQueryResult();
        //            jObject.RowNumber = gridItems[i].RowNumber;
        //            gridItems[i].QueryResult.forEach(function (val, idx) {
        //              let value = (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null ?
        //                ((gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')) : gridItems[i].DataValue[(idx + 1)])
        //              val.DataValue = value;
        //            });

        //            jObject.QueryResult = gridItems[i].QueryResult;

        //            let JsonObject: any = {};
        //            JsonObject.Row = jObject;
        //            xmlString += this.json2xml(JsonObject, null);
        //          }

        //          xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

        //          if (oJSONData == "") {
        //            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
        //          }
        //          else {
        //            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
        //          }
        //        }

        //      }



        //      oJSONData = "[" + oJSONData + "]";

        //      oJSONData = oJSONData.replace(/\n/g, 'neewwlliine');

        //      try {

        //        this.__oInstanceCurrentStateData = JSON.parse(oJSONData);
        //      }
        //      catch
        //      {
        //        console.log(oJSONData);
        //      }

        //      oJSONData = this.replaceAll(oJSONData);


        //      oBusinessProcessUserAction.sXMLProcessInstanceStateData = oJSONData;
        //      oBusinessProcessUserAction.swfBusinessProcessInstanceComments = this.__sInstanceComment;


        //      this.service.UpdateAllDataByPromise(oBusinessProcessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostUserAction").then(
        //        result => this.OnSuccessSave(result)
        //      ).
        //        catch(error => this.OnError(error))

        //    }
        //    else {
        //      let widgetOptions = {
        //        message: Data,
        //        closeOnClick: true
        //      };
        //      this.__bIsLoadingVisible = false;
        //      notify(widgetOptions, "error", 3000);
        //      return;
        //    }
        //  }

        //});
      }
      else {
        for (let oFileDetail of this.__oFileDetails) {
          let sContent: string = oFileDetail.FileContent;

          let iIndex: number = sContent.indexOf('base64,');

          sContent = sContent.substr(iIndex + 7);

          let sDataCaption = oFileDetail.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + sDataCaption + "FileContentInBytes" + "\",\"DataValue\":\"" + sContent + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + sDataCaption + "FileContentInBytes" + "\",\"DataValue\":\"" + sContent + "\"}";
          }
        }
        //Start FB 13378, Workflow issues.
        //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Rich Text Box')) {
        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Rich Text Box')) {
          //End FB 13378, Workflow issues.
          let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

          let sDataValue: string = oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote');

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sDataValue + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sDataValue + "\"}";
          }
        }
        //Start FB 13378, Workflow issues.
        //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Grid')) {
        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Grid')) {
          //End FB 13378, Workflow issues.
          if (oCurrentInstance.DataType == 'Grid') {
            let gridItems = this.__oBusinessProcessStateGridDataContext;
            let xmlString = '';
            for (var i = 0; i < gridItems.length; i++) {
              let jObject = new BusinessProcessStateGridDataQueryResult();
              jObject.RowNumber = gridItems[i].RowNumber;

              for (var idx = 0; idx < gridItems[i].QueryResult.length; idx++) {
                let value: any;
                if (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null) {
                  value = (gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan').replace('\n', 'neewwlliine')
                  if (gridItems[i].QueryResult[idx].ColumnName == 'NextReviewDate' && value != '') {
                    value = this.datePipe.transform((gridItems[i].DataValue[(idx + 1)]).toString(), 'yyyy-MM-dd');
                  }
                }
                else {
                  value = gridItems[i].DataValue[(idx + 1)]
                }
                gridItems[i].QueryResult[idx].DataValue = value;
              }


              //gridItems[i].QueryResult.forEach(function (val, idx) {
              //  let value: any;
              //  if (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null) {
              //    value = (gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')
              //    if (val.ColumnName == 'NextReviewDate' && value != '') {
              //      let dateValue = new Date(value); // this.datePipe.transform((gridItems[i].DataValue[(idx + 1)]).toString(), 'yyyy-MM-dd');
              //      value = dateValue.toLocaleDateString();
              //    }
              //  }
              //  else {
              //    value = gridItems[i].DataValue[(idx + 1)]
              //  }
              //  val.DataValue = value;
              //});

              jObject.QueryResult = gridItems[i].QueryResult;

              let JsonObject: any = {};
              JsonObject.Row = jObject;
              xmlString += this.json2xml(JsonObject, null);
            }

            xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

            if (oJSONData == "") {
              oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
            else {
              oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
          }

        }

        //Start FB 13378, Handled special character check in the WF name.
        //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Data Grid')) {
        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Data Grid')) {
          //End FB 13378, Handled special character check in the WF name.
          if (oCurrentInstance.DataType == 'Data Grid') {

            let gridItems: BusinessProcessStateGridDataContext[] = oCurrentInstance.ItemSource;
            let BusinessProcessStateGridData: BusinessProcessStateGridData[] = oCurrentInstance.BusinessProcessStateGridData;


            let xmlString = '';
            for (var i = 0; i < gridItems.length; i++) {
              let jObject = new BusinessProcessStateGridDataQueryResult();
              jObject.RowNumber = gridItems[i].RowNumber;
              jObject.RowStatus = gridItems[i].RowStatus;
              jObject.QueryResult = [];


              let dynamicQueryResult: DynamicQueryResult[] = gridItems[i].QueryResult;

              let j: number = 1;

              for (var oSDD of BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder)) {

                let oQueryResult = new DynamicQueryResult();

                let oColumnDetail = dynamicQueryResult.find(x => x.ColumnName == oSDD.DataField);

                oQueryResult.ColumnName = oColumnDetail.ColumnName;
                oQueryResult.ColumnType = oColumnDetail.ColumnType;

                if (oSDD.DataType != 'Multi Select Combo Box' && oSDD.DataType != 'Date Picker') {
                  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                    oQueryResult.DataValue = gridItems[i].DataValue[j];
                  }
                }
                else if (oSDD.DataType == 'Multi Select Combo Box') {
                  if (gridItems[i].MultiSelectedItems[j] != null && gridItems[i].MultiSelectedItems[j] != undefined) {
                    oQueryResult.DataValue = gridItems[i].MultiSelectedItems[j].join(',');
                  }
                }
                else if (oSDD.DataType == 'Date Picker') {
                  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                    oQueryResult.DataValue = this.datePipe.transform((gridItems[i].DataValue[j]).toString(), 'yyyy-MM-dd');
                  }
                }
                if (!this.__oUtilityService.IsNullOrUndefined(oQueryResult.DataValue)) {
                  oQueryResult.DataValue = oQueryResult.DataValue.toString().replace(/"/g, 'doouubleQuote').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, 'neewwlliine');
                }
                jObject.QueryResult.push(oQueryResult);
                j = j + 1;
              }

              for (var oSDD of BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder)) {

                let oQueryResult = new DynamicQueryResult();

                let oColumnDetail: BusinessProcessStateGridData = gridItems[i].BusinessProcessStateGridData.find(x => x.DataField == oSDD.DataField);

                let oRowQueryResult = dynamicQueryResult.find(x => x.ColumnName == oSDD.DataField);

                oQueryResult.ColumnName = oColumnDetail.DataField
                oQueryResult.ColumnType = oRowQueryResult.ColumnType;

                if (oSDD.DataType != 'Multi Select Combo Box' && oSDD.DataType != 'Date Picker') {
                  if (oColumnDetail.DataValue != null && oColumnDetail.DataValue != undefined) {
                    oQueryResult.DataValue = oColumnDetail.DataValue;
                  }
                }
                else if (oSDD.DataType == 'Multi Select Combo Box') {
                  if (oColumnDetail.MultiSelectedItems != null && oColumnDetail.MultiSelectedItems != undefined) {
                    oQueryResult.DataValue = oColumnDetail.MultiSelectedItems.join(',');
                  }
                }
                else if (oSDD.DataType == 'Date Picker') {
                  if (oColumnDetail.DataValue != null && oColumnDetail.DataValue != undefined) {
                    oQueryResult.DataValue = this.datePipe.transform((oColumnDetail.DataValue).toString(), 'yyyy-MM-dd');
                  }
                }
                if (!this.__oUtilityService.IsNullOrUndefined(oQueryResult.DataValue)) {
                  oQueryResult.DataValue = oQueryResult.DataValue.toString().replace(/"/g, 'doouubleQuote').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                jObject.QueryResult.push(oQueryResult);
              }

              for (var oSDD of BusinessProcessStateGridData.filter(x => x.IsVisible == 0).sort(y => y.DisplayOrder)) {

                let oQueryResult = new DynamicQueryResult();

                let oColumnDetail = dynamicQueryResult.find(x => x.ColumnName == oSDD.DataField);

                oQueryResult.ColumnName = oColumnDetail.ColumnName;
                oQueryResult.ColumnType = oColumnDetail.ColumnType;
                oQueryResult.DataValue = oColumnDetail.DataValue;

                //if (oSDD.DataType != 'Multi Select Combo Box' && oSDD.DataType != 'Date Picker') {
                //  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                //    oQueryResult.DataValue = gridItems[i].DataValue[j];
                //  }
                //}
                //else if (oSDD.DataType == 'Multi Select Combo Box') {
                //  if (gridItems[i].MultiSelectedItems[j] != null && gridItems[i].MultiSelectedItems[j] != undefined) {
                //    oQueryResult.DataValue = gridItems[i].MultiSelectedItems[j].join(',');
                //  }
                //}
                //else if (oSDD.DataType == 'Date Picker') {
                //  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                //    oQueryResult.DataValue = this.datePipe.transform((gridItems[i].DataValue[j]).toString(), 'yyyy-MM-dd');
                //  }
                //}
                if (!this.__oUtilityService.IsNullOrUndefined(oQueryResult.DataValue)) {
                  oQueryResult.DataValue = oQueryResult.DataValue.toString().replace(/"/g, 'doouubleQuote').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                jObject.QueryResult.push(oQueryResult);
              }



              //for (var idx = 0; idx < gridItems[i].QueryResult.length; idx++) {
              //  let value: any;
              //  if (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null) {
              //    value = (gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')

              //    if (gridItems[i].QueryResult[idx].ColumnType.toString() == 'Date' && value != '') {
              //      value = this.datePipe.transform((gridItems[i].DataValue[(idx + 1)]).toString(), 'yyyy-MM-dd');
              //    }
              //  }
              //  else if (gridItems[i].MultiSelectedItems[(idx + 1)] != undefined && gridItems[i].MultiSelectedItems[(idx + 1)] != null) {
              //    value = gridItems[i].MultiSelectedItems[(idx + 1)].join(',');
              //  }
              //  else
              //  {
              //    value = gridItems[i].DataValue[(idx + 1)];
              //  }

              //  gridItems[i].QueryResult[idx].DataValue = value;
              //}

              //jObject.QueryResult = gridItems[i].QueryResult;

              let JsonObject: any = {};
              JsonObject.Row = jObject;
              xmlString += this.json2xml(JsonObject, null);
            }

            xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

            if (oJSONData == "") {
              oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
            else {
              oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
          }

        }


        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Qualitative Grid' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();
          else
            oCurrentInstance.DataValue = '';

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Quantitative Grid' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();
          else
            oCurrentInstance.DataValue = '';

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Score Analysis' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);


          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();
          else
            oCurrentInstance.DataValue = '';

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        for (let oCurrentInstance of oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Final Score Analysis' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);


          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();
          else
            oCurrentInstance.DataValue = '';

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        oJSONData = "[" + oJSONData + "]";

        //let JSONString: string = JSON.stringify(oJSONData);
        //oJSONData = JSONString.replace(/\\n/g, "\\n").replace(/\\r/g, "\\r").replace(/\\t/g, "\\t");

        try {
          this.__oInstanceCurrentStateData = JSON.parse(oJSONData);
        } catch
        {
          console.log(oJSONData);
        }
        this.__sXMLProcessStateData = oJSONData;
        oJSONData = this.replaceAll(oJSONData);

        oBusinessProcessUserAction.sXMLProcessInstanceStateData = oJSONData;
        oBusinessProcessUserAction.swfBusinessProcessInstanceComments = this.__sInstanceComment;
        this.swfBusinessProcessRuleAction = oBusinessProcessUserAction.swfBusinessProcessRuleAction;//FB47642-Pawan Prajapati
  
        this.service.UpdateAllDataByPromise(oBusinessProcessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostUserAction").then(
          result => this.OnSuccessSave(result, e.IsSuccessAlert)
        ).
          catch(error => this.OnError(error))
      }

    }


  }


  private OnErrorFieldEntryValidationResult(error: any) {
    console.log(error);
  }
  private OnSuccessFieldEntryValidationResult(response: any, oJSONData: any, oBusinessProcessUserAction: any, isSuccessAlert: boolean) {

    if (response != null) {

      if (response == "True" || response == "true") {

        for (let oFileDetail of this.__oFileDetails) {
          let sContent: string = oFileDetail.FileContent;

          let iIndex: number = sContent.indexOf('base64,');

          sContent = sContent.substr(iIndex + 7);

          let sDataCaption = oFileDetail.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + sDataCaption + "FileContentInBytes" + "\",\"DataValue\":\"" + sContent + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + sDataCaption + "FileContentInBytes" + "\",\"DataValue\":\"" + sContent + "\"}";
          }
        }


        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Rich Text Box')) {
          let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

          let sDataValue: string = oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote');

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sDataValue + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sDataValue + "\"}";
          }

        }

        //let sstring: string = "<p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">g</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">fdf</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">d</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \">fgdf</p><p fr-original-style=\"\" style=\"margin: 0px 0px 10px; box - sizing: border - box; \"><br fr-original-style=\"\" style=\"box - sizing: border - box; \"></p>\""

        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Grid')) {
          if (oCurrentInstance.DataType == 'Grid') {
            let gridItems = this.__oBusinessProcessStateGridDataContext;
            let xmlString = '';
            for (var i = 0; i < gridItems.length; i++) {
              let jObject = new BusinessProcessStateGridDataQueryResult();
              jObject.RowNumber = gridItems[i].RowNumber;
              gridItems[i].QueryResult.forEach(function (val, idx) {
                let value = (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null ?
                  ((gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')) : gridItems[i].DataValue[(idx + 1)])
                val.DataValue = value;
              });

              jObject.QueryResult = gridItems[i].QueryResult;

              let JsonObject: any = {};
              JsonObject.Row = jObject;
              xmlString += this.json2xml(JsonObject, null);
            }

            xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

            if (oJSONData == "") {
              oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
            else {
              oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
          }

        }

        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType == 'Data Grid')) {
          if (oCurrentInstance.DataType == 'Data Grid') {

            let gridItems: BusinessProcessStateGridDataContext[] = oCurrentInstance.ItemSource;
            let BusinessProcessStateGridData: BusinessProcessStateGridData[] = oCurrentInstance.BusinessProcessStateGridData;


            let xmlString = '';
            for (var i = 0; i < gridItems.length; i++) {
              let jObject = new BusinessProcessStateGridDataQueryResult();
              jObject.RowNumber = gridItems[i].RowNumber;
              jObject.RowStatus = gridItems[i].RowStatus;
              jObject.QueryResult = [];


              let dynamicQueryResult: DynamicQueryResult[] = gridItems[i].QueryResult;

              let j: number = 1;

              for (var oSDD of BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder)) {

                let oQueryResult = new DynamicQueryResult();

                let oColumnDetail = dynamicQueryResult.find(x => x.ColumnName == oSDD.DataField);

                oQueryResult.ColumnName = oColumnDetail.ColumnName;
                oQueryResult.ColumnType = oColumnDetail.ColumnType;

                if (oSDD.DataType != 'Multi Select Combo Box' && oSDD.DataType != 'Date Picker') {
                  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                    oQueryResult.DataValue = gridItems[i].DataValue[j];
                  }
                }
                else if (oSDD.DataType == 'Multi Select Combo Box') {
                  if (gridItems[i].MultiSelectedItems[j] != null && gridItems[i].MultiSelectedItems[j] != undefined) {
                    oQueryResult.DataValue = gridItems[i].MultiSelectedItems[j].join(',');
                  }
                }
                else if (oSDD.DataType == 'Date Picker') {
                  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                    oQueryResult.DataValue = this.datePipe.transform((gridItems[i].DataValue[j]).toString(), 'yyyy-MM-dd');
                  }
                }
                if (!this.__oUtilityService.IsNullOrUndefined(oQueryResult.DataValue)) {
                  oQueryResult.DataValue = oQueryResult.DataValue.toString().replace(/"/g, 'doouubleQuote').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                jObject.QueryResult.push(oQueryResult);
                j = j + 1;
              }

              for (var oSDD of BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder)) {

                let oQueryResult = new DynamicQueryResult();

                let oColumnDetail: BusinessProcessStateGridData = gridItems[i].BusinessProcessStateGridData.find(x => x.DataField == oSDD.DataField);

                let oRowQueryResult = dynamicQueryResult.find(x => x.ColumnName == oSDD.DataField);

                oQueryResult.ColumnName = oColumnDetail.DataField
                oQueryResult.ColumnType = oRowQueryResult.ColumnType;

                if (oSDD.DataType != 'Multi Select Combo Box' && oSDD.DataType != 'Date Picker') {
                  if (oColumnDetail.DataValue != null && oColumnDetail.DataValue != undefined) {
                    oQueryResult.DataValue = oColumnDetail.DataValue;
                  }
                }
                else if (oSDD.DataType == 'Multi Select Combo Box') {
                  if (oColumnDetail.MultiSelectedItems != null && oColumnDetail.MultiSelectedItems != undefined) {
                    oQueryResult.DataValue = oColumnDetail.MultiSelectedItems.join(',');
                  }
                }
                else if (oSDD.DataType == 'Date Picker') {
                  if (oColumnDetail.DataValue != null && oColumnDetail.DataValue != undefined) {
                    oQueryResult.DataValue = this.datePipe.transform((oColumnDetail.DataValue).toString(), 'yyyy-MM-dd');
                  }
                }
                if (!this.__oUtilityService.IsNullOrUndefined(oQueryResult.DataValue)) {
                  oQueryResult.DataValue = oQueryResult.DataValue.toString().replace(/"/g, 'doouubleQuote').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                jObject.QueryResult.push(oQueryResult);
              }

              for (var oSDD of BusinessProcessStateGridData.filter(x => x.IsVisible == 0).sort(y => y.DisplayOrder)) {

                let oQueryResult = new DynamicQueryResult();

                let oColumnDetail = dynamicQueryResult.find(x => x.ColumnName == oSDD.DataField);

                oQueryResult.ColumnName = oColumnDetail.ColumnName;
                oQueryResult.ColumnType = oColumnDetail.ColumnType;
                oQueryResult.DataValue = oColumnDetail.DataValue;

                //if (oSDD.DataType != 'Multi Select Combo Box' && oSDD.DataType != 'Date Picker') {
                //  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                //    oQueryResult.DataValue = gridItems[i].DataValue[j];
                //  }
                //}
                //else if (oSDD.DataType == 'Multi Select Combo Box') {
                //  if (gridItems[i].MultiSelectedItems[j] != null && gridItems[i].MultiSelectedItems[j] != undefined) {
                //    oQueryResult.DataValue = gridItems[i].MultiSelectedItems[j].join(',');
                //  }
                //}
                //else if (oSDD.DataType == 'Date Picker') {
                //  if (gridItems[i].DataValue[j] != null && gridItems[i].DataValue[j] != undefined) {
                //    oQueryResult.DataValue = this.datePipe.transform((gridItems[i].DataValue[j]).toString(), 'yyyy-MM-dd');
                //  }
                //}
                if (!this.__oUtilityService.IsNullOrUndefined(oQueryResult.DataValue)) {
                  oQueryResult.DataValue = oQueryResult.DataValue.toString().replace(/"/g, 'doouubleQuote').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                jObject.QueryResult.push(oQueryResult);
                j = j + 1;
              }



              //for (var idx = 0; idx < gridItems[i].QueryResult.length; idx++) {
              //  let value: any;
              //  if (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null) {
              //    value = (gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')

              //    if (gridItems[i].QueryResult[idx].ColumnType.toString() == 'Date' && value != '') {
              //      value = this.datePipe.transform((gridItems[i].DataValue[(idx + 1)]).toString(), 'yyyy-MM-dd');
              //    }
              //  }
              //  else if (gridItems[i].MultiSelectedItems[(idx + 1)] != undefined && gridItems[i].MultiSelectedItems[(idx + 1)] != null) {
              //    value = gridItems[i].MultiSelectedItems[(idx + 1)].join(',');
              //  }
              //  else
              //  {
              //    value = gridItems[i].DataValue[(idx + 1)];
              //  }

              //  gridItems[i].QueryResult[idx].DataValue = value;
              //}

              //jObject.QueryResult = gridItems[i].QueryResult;

              let JsonObject: any = {};
              JsonObject.Row = jObject;
              xmlString += this.json2xml(JsonObject, null);
            }

            xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

            if (oJSONData == "") {
              oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
            else {
              oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
            }
          }

        }

        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Qualitative Grid' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Quantitative Grid' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Score Analysis' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Final Score Analysis' && x.IsStateDataReadOnly == 0)) {

          let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

          if (oControlData != null && oControlData != undefined)
            oCurrentInstance.DataValue = oControlData.Control.GetData();

          if (oJSONData == "") {
            oJSONData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            oJSONData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }

        }

        oJSONData = "[" + oJSONData + "]";

        oJSONData = this.__oUtilityService.EncodeNewLineTabCharacters(oJSONData);//fb 37019 Rajendra tab key

        try {

          this.__oInstanceCurrentStateData = JSON.parse(oJSONData);
        }
        catch
        {
          console.log(oJSONData);
        }

        oJSONData = this.replaceAll(oJSONData);


        oBusinessProcessUserAction.sXMLProcessInstanceStateData = oJSONData;
        oBusinessProcessUserAction.swfBusinessProcessInstanceComments = this.__sInstanceComment;


        this.service.UpdateAllDataByPromise(oBusinessProcessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostUserAction").then(
          result => this.OnSuccessSave(result, isSuccessAlert)
        ).
          catch(error => this.OnError(error))

      }
      else {
        this.__bIsLoadingVisible = false;
        this.__oConfirmationComponent.show(ConfirmationType.Error,
          response,
          "Error", "Ok", "Cancel", false);
        return;
      }
    }

  }


  RefreshWorkflow(e: any) {
    this.__oBusinessProcessFilterViewModels = [];
    this.__WorkFlowInstanseSearchValue = '';
    this.__bStateInstanceRightPanelVisisble = false;
    this.__bStateRightPanelVisisble = true;

    this.__bIsLoadingVisible = true;

    let iSelectedIndex: number = this.__iBusinessProcessAccordionSelectedIndex;
    let oSelectedBusinessProcess: any[] = this.InboxaccordionControl.selectedItems;

    this.__oBusinessProcessViewModels = [];
    this.__oWFBusinessProcessDefinition = null;
    this.__oBusinessProcessStates = [];
    this.__oBusinessProcessInstanceViewModel = null;
    this.__oStateDataSource = [];
    this.__bStartNewProcessButtonVisible = false;
    this.__oBusinessProcessInstanceCurrentStateDatas = [];
    this.__oBusinessProcessStateActions = [];
    this.__oStatecolumns = [];

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcesses").then((Data) => {

      if (Data != null) {
        this.__oBusinessProcessViewModels = Data;
        this.__iBusinessProcessAccordionSelectedIndex = iSelectedIndex;

        let oBusinessProcessViewModel: BusinessProcessViewModel = oSelectedBusinessProcess[0];

        let oSelectedBusinessProcessNew: any = this.__oBusinessProcessViewModels.find(x => x.WorkFlowType.wfBusinessProcessType1 == oBusinessProcessViewModel.WorkFlowType.wfBusinessProcessType1);

        for (var oBPVM of oSelectedBusinessProcessNew.BusinessProcesses) {

          //Start FB 13378, Handled special character check in the WF name.
          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + oBPVM.BusinessProcess.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
            //End FB 13378, Handled special character check in the WF name.
            if (Data != null) {

              try {
                var oCount = JSON.parse(Data);
              }
              catch
              {
                console.log(Data);
              }



              let oBusinessProcessHTML: BusinessProcessHTML = oSelectedBusinessProcessNew.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);

              oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;

              if (oBusinessProcessHTML.ItemCount == null || oBusinessProcessHTML.ItemCount == undefined) {
                oBusinessProcessHTML.ItemCount = 0;
              }

            }
            else {
              this.__bIsLoadingVisible = false;
            }

          });

        }

        oSelectedBusinessProcessNew.GetIsCountFetched = 1;
        if (this.__oBusinessProcessDefinitionName != undefined) {
          //Start FB 13378, Handled special character check in the WF name.
          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetwfBusinessProcessDefinition/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
            //End FB 13378, Handled special character check in the WF name.
            if (Data != null) {
              this.__oWFBusinessProcessDefinition = Data;


              if (this.__oWFBusinessProcessDefinition.wfBusinessProcessModel == 'State') {
                this.__bStatelessWorkflowVisible = false;
                this.__bStateWorkflowVisible = true;

                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStates/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {

                  if (Data != null) {
                    this.__oBusinessProcessStates = Data;
                    if (this.hideDashboardMenu) {
                      $('.pCollapsable').css({ 'top': '4.5rem' });
                      $('.pStateCollapsable').css({ 'top': '4.5rem' });
                      $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
                      $('#statesPane').css({ 'height': 'calc(100vh - 8.5rem)' });
                      $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 8.5rem)' });
                    } else {
                      this.showDashboardMenu();
                    }

                    if (this.__oBusinessProcessStateName != null && this.__oBusinessProcessStateName != undefined && this.__oBusinessProcessStateName != '') {
                      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstances/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash") + "/" + this.__oBusinessProcessStateName.replace("&", "annd").replace("/", "baccckslash").replace('+', 'pluuus').replace("\\", "forwardslaaash")).then((Data) => {

                        if (Data != null) {
                          this.__oBusinessProcessInstanceViewModel = Data;

                          if (this.__oBusinessProcessInstanceViewModel != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != undefined) {
                            this.__oStatecolumns.push({
                              caption: "",
                              cellTemplate: 'cellTemplate',
                              width: '35px',
                              allowEditing: false
                            })

                            for (var oColumn of this.__oBusinessProcessInstanceViewModel.DynamicColumns) {
                              if (oColumn.ColumnName == 'Initialized On' || oColumn.ColumnName == 'Initialized_On') {//FB38211-charles
                                this.__oStatecolumns.push({
                                  dataField: oColumn.ColumnName,
                                  caption: oColumn.ColumnName.replace("_", " "),
                                  allowEditing: false,
                                  allowSorting: true,
                                  allowFiltering: true,
                                  allowReordering: false,
                                  sortOrder: 'desc',
                                  dataType: 'date',
                                  format: 'dd-MMM-yyyy HH:mm'
                                })
                              }
                              else {
                                this.__oStatecolumns.push(this.makeColumn(oColumn));//FB38211-charles
                              }
                            }

                          }

                          try {
                            /* Start FB 19240 VIDYA 11/08/2020*/
                            //let sStateGridData = this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource.replace(/quoootes/g, '\\"').replace(/backslaaash/g, "\\\\");;
                            let sStateGridData = this.replaceAllSpecialCharacters(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource); // FB 25619 - Vidya
                            this.__oStateDataSource = JSON.parse(sStateGridData);
                            /* End FB 19240 VIDYA 11/08/2020*/
                          }
                          catch
                          {
                            console.log(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);
                          }

                        }

                        this.__bIsLoadingVisible = false;

                      });

                    }
                    else
                      this.__bIsLoadingVisible = false;

                  }


                  
                });


                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetPermissionInfo/138/" + this.__oWFBusinessProcessDefinition.lProcessStartUpRuleId).then((Data) => {

                  if (Data != null) {

                    if (Data == 1) {
                      this.__bStartNewProcessButtonVisible = true;
                      this.__sStartNewProcessButtonText = this.__oWFBusinessProcessDefinition.wfBusinessProcessRuleAction;

                      if (this.__sStartNewProcessButtonText == null || this.__sStartNewProcessButtonText.trim() == '') {
                        this.__bStartNewProcessButtonVisible = false;
                      }
                    }
                    else {
                      this.__bStartNewProcessButtonVisible = false;
                    }

                  }

                });

              }
              else {
                this.__bStatelessWorkflowVisible = true;
                this.__bStateWorkflowVisible = false;

                this.RefreshStatelessGrid();

              }





            }



          });
        }
        else {
          this.__bIsLoadingVisible = false;
        }

      }
      else {
        this.__bIsLoadingVisible = false;
      }


    });

  }

  //FB38211-charles
  makeColumn(oColumn: ColumnNameWithDataType) {
    let oColumnItem: any = {
      dataField: oColumn.ColumnName,
      caption: oColumn.ColumnName.replace("_", " "),
      allowEditing: false,
      allowSorting: true,
      allowFiltering: true,
      allowReordering: false,
    }
    switch (oColumn.DataType) {
      case Constants.DATATYPE_Decimal:
        oColumnItem.dataType = 'number';
        oColumnItem.format = '#,##0.##';
        break;
      case Constants.DATATYPE_INT:
        oColumnItem.dataType = 'number';
        oColumnItem.format = '#,##0';
        break;
      case Constants.DATATYPE_DATETIME:
        oColumnItem.dataType = 'date',
          oColumnItem.format = 'dd-MMM-yyyy HH:mm:ss' //FB 25619 - Vidya
        break;
      case Constants.DATATYPE_SYSTEM_DATETIME:
        oColumnItem.dataType = 'date',
          oColumnItem.format = 'dd-MMM-yyyy' //FB 25619 - Vidya
        break;
      default:
        break;
    }
    return oColumnItem;
  }

  private copyMessage(val: string, StateDataId: any) {

    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == StateDataId);

    let sInstance: string = oBusinessProcessInstanceCurrentStateData.DataValue;

    let sWebURL: string = this.__oSwitchPortal.UrlAngular; //UrlSilverLIght;

    //sWebURL = sWebURL.replace('RCPortalFrameWork.aspx', '');

    if (oBusinessProcessInstanceCurrentStateData.DataTypeParameter != null && oBusinessProcessInstanceCurrentStateData.DataTypeParameter.indexOf('EntityGroup') > 0) {

      let sDataTypeParameter: string = oBusinessProcessInstanceCurrentStateData.DataTypeParameter;

      let EntityGroup: string = sDataTypeParameter.substring(sDataTypeParameter.indexOf('<EntityGroup>') + 13, sDataTypeParameter.indexOf('</EntityGroup>'));
      sInstance = this.URLEncode(oBusinessProcessInstanceCurrentStateData.DataValue);
      val = this.OpenEntityGroupInstance(sWebURL, EntityGroup, sInstance);
    }

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  EditReferenceData(e: any) {
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == e);
    oBusinessProcessInstanceCurrentStateData.ReferenceDataTextBoxVisible = 1;
    oBusinessProcessInstanceCurrentStateData.ReferenceDataURLVisible = 0;
  }

  ReferenceTextBoxLostFocus(e: any) {
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == e);
    oBusinessProcessInstanceCurrentStateData.ReferenceDataTextBoxVisible = 0;
    oBusinessProcessInstanceCurrentStateData.ReferenceDataURLVisible = 1;
  }

  OpenReferenceDataURL(e: any) {
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == e);

    let sInstance: string = oBusinessProcessInstanceCurrentStateData.DataValue;

    let sWebURL: string = this.__oSwitchPortal.UrlAngular; //UrlSilverLIght;

    //sWebURL = sWebURL.replace('RCPortalFrameWork.aspx', '');

    if (oBusinessProcessInstanceCurrentStateData.DataTypeParameter != null && oBusinessProcessInstanceCurrentStateData.DataTypeParameter.indexOf('EntityGroup') > 0) {

      let sDataTypeParameter: string = oBusinessProcessInstanceCurrentStateData.DataTypeParameter;

      let EntityGroup: string = sDataTypeParameter.substring(sDataTypeParameter.indexOf('<EntityGroup>') + 13, sDataTypeParameter.indexOf('</EntityGroup>'));
      sInstance = this.URLEncode(oBusinessProcessInstanceCurrentStateData.DataValue);
      let sURL = this.OpenEntityGroupInstance(sWebURL, EntityGroup, sInstance);
      window.open(sURL, "_blank");

    }
    else {
      window.open(sInstance.replace(/%2F/g, ''), "_blank");
    }

  }





  OpenLinkURL(e: any) {

    let sWebURL: string = e;

    for (let oCurrentStateData of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null)) {
      sWebURL = sWebURL.replace(/\[/g, 'oppebrracket');
      sWebURL = sWebURL.replace(/\]/g, 'cllocebrracket');

      sWebURL = sWebURL.replace(/\|/g, 'pipesymbol');

      let sDataCaptionBracket: string = 'oppebrracket' + oCurrentStateData.DataCaption.replace(/\|/g, 'pipesymbol') + 'cllocebrracket';

      if (oCurrentStateData.DataValue != '') {
        var regex: RegExp = new RegExp(sDataCaptionBracket, "g");
        sWebURL = sWebURL.replace(regex, this.URLEncode(oCurrentStateData.DataValue));
      }
    }

    window.open(sWebURL, "_blank");
  }
  //#endregion

  private OnError(error: any) {
    this.__bIsLoadingVisible = false;

    if (error != null) {
      this.__oConfirmationComponent.show(ConfirmationType.Error,
        error,
        "Error", "Ok", "Cancel", false).then(() => {
          this.__oOnClosePopup.emit(null);//FB47642-Pawan Prajapati
        });
    }
  }
  private OnSuccessSave(response: any, isSuccessAlert: boolean) {
    this.__bIsLoadingVisible = false;

    if (response != null) {

      var oResponse: string = response;

      if (oResponse == 'Success' || oResponse.indexOf("Successfully Executed") > -1) {
        var sMessage = oResponse.replace("Successfully Executed", '').replace('Success', '') != '' ? oResponse.replace("Successfully Executed", '').replace('Success', '') : "User action executed successfully";//FB47642-Pawan Prajapati
        if (this.__bHideInboxPageForUserActionThroughURL == true && this.__bIsOpenedThroughURL == true) {
          this.__sUserActionExecuteResult = "User action " + this.__sURLBPRA + " executed successfully";
        }
        else {

          let oStateActionExecutesWithWebURL: BusinessProcessStateActionExecute[] = [];
          let oBusinessProcessCurrentInstance = this.__oBusinessProcessInstanceCurrentStateDatas[0];
          let oBusinessProcessStateActionExecute = this.__oBusinessProcessStateActionExecutes.filter(x => x.lwfBusinessProcessRuleActionId == this.__iExecutedRuleActionId)[0];

          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceAllStateData/" + oBusinessProcessCurrentInstance.lwfBusinessProcessInstanceId).then((Data) => {

            if (Data != null) {

              let sData: string = Data;

              sData = sData.replace(/\\/g, 'backslaaash').replace(/quoootes/g, '\\"').replace(/doouubleQuote/g, '\\"'); //FB 28009 - Vidya
              sData = this.__oUtilityService.EncodeNewLineTabCharacters(sData);//fb 37019 Rajendra tab key

              sData = this.replaceAllSpecialCharacters(sData); //FB 25619 - VIDYA

              try {
                this.__oInstanceAllStateData = JSON.parse(sData);
              }
              catch
              {
                console.log(sData);
              }

              oStateActionExecutesWithWebURL = this.__oBusinessProcessStateActionExecutes.filter(x => x.lwfBusinessProcessRuleActionId == this.__iExecutedRuleActionId && x.OpenFormWebUrl != null && x.OpenFormWebUrl != '');

              for (let oStateActionExecute of oStateActionExecutesWithWebURL) {
                let sWebURL: string = oStateActionExecute.OpenFormWebUrl;

                sWebURL = sWebURL.replace(/\[/g, 'oppebrracket');
                sWebURL = sWebURL.replace(/\]/g, 'cllocebrracket');
                //Start FB 13378, Handled special character pipe conversion in the caption.
                sWebURL = sWebURL.replace(/\|/g, 'pipesymbol');
                //End FB 13378, Handled special character check in the WF name.
                for (let oCurrentStateData of this.__oInstanceAllStateData) {
                  //Start FB 13378, Handled special character check in the WF name.
                  let sDataCaptionBracket: string = 'oppebrracket' + oCurrentStateData.DataCaption.replace(/\|/g, 'pipesymbol') + 'cllocebrracket';
                  //End FB 13378, Handled special character check in the WF name.
                  if (oCurrentStateData.DataValue != '') {
                    var regex: RegExp = new RegExp(sDataCaptionBracket, "g");

                    if(oCurrentStateData.DataValue.startsWith('File___'))
                    {
                      oCurrentStateData.DataValue=this.__oUtilityService.DecryptStringAES(oCurrentStateData.DataValue.replace('File___',''), Constants.EXTERNALSOURCE_AESKEY)
                    }

                    sWebURL = sWebURL.replace(regex, this.URLEncode(oCurrentStateData.DataValue));
                  }
                }

                //sWebURL = sWebURL.replace(/\[/g,'');
                //sWebURL = sWebURL.replace(/\]/g, '');
                if (oStateActionExecute.IsOpenOnNewTab) {
                  this.__oConfirmationComponent.show(ConfirmationType.Information, Constants.OPEN_URL_NEW_TAB_CONFIRMATION, "Confirmation", "Continue", "Cancel")
                    .then(result => {
                      if (result) {
                        window.open(sWebURL, "_blank");
                      }
                    });
                }
                else
                  window.open(sWebURL, "_self");



              }

              if (oBusinessProcessStateActionExecute.IsRemainOpen == 1) {
                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetInstanceCurrentState/" + oBusinessProcessCurrentInstance.lwfBusinessProcessInstanceId).then((Data) => {

                  if (Data != null) {

                    let sStateName: string = Data;

                    if (sStateName != 'null') {
                      this.__oBusinessProcessStateName = sStateName;
                      this.__oBusinessProcessInstanceCurrentStateDatas = [];
                      /* START FB 22061 VIDYA 28/09/2020 */
                      this.__bStateInstanceRightPanelVisisble = false;
                      this.__bStateRightPanelVisisble = true;
                      /* END FB 22061 VIDYA 28/09/2020 */
                      this.GetBusinessProcessInstanceCurrentStateData(oBusinessProcessCurrentInstance.lwfBusinessProcessInstanceId);
                    }
                    else {
                      this.RefreshWorkflow("After Save");
                    }
                  }

                });
              }
              else {
                this.RefreshWorkflow("After Save");
              }

            }



          });
        }
        this.__bIsLoadingVisible = false;
        if (isSuccessAlert) { //PL-529
          this.__oConfirmationComponent.show(ConfirmationType.Success, sMessage, "Success", "Ok", "Cancel", false).then(() => {
            this.__oOnClosePopup.emit(this.swfBusinessProcessRuleAction);//FB47642-Pawan Prajapati
          });
        }
      }
      else
        if (oResponse.indexOf("lDocumentTemplateId") >= 0) {
          this.isDocumentGenerateFroStateAction = true;
          this.__bUploadSharepointFileManagerReady = false;
          this.__sFileSystem = "";
          this.__sDirectory = "";
          let documentTemplateViews: DocumentTemplateView[] = [];
          let results: any = JSON.parse(response);

          if (results != undefined) {
            if (results[0]["Parameters"] != undefined || results[0]["Parameters"] != null) {
              this.documentTemplateFunctionParameter = results[0]["Parameters"];
              let columnName = this.documentTemplateFunctionParameter["Id"].replace(/[[\]']+/g, '').replace(/\s+$/, "");
              for (let rowData of this.__oBusinessProcessInstanceCurrentStateDatas) {
                if (rowData.DataCaption == columnName) {
                  this.documentTemplateFunctionParameter["Id"] = rowData.DataValue;
                }
              }

              //if (this.documentTemplateFunctionParameter["Id"] == "" || this.documentTemplateFunctionParameter["Id"] == undefined || this.documentTemplateFunctionParameter["Id"] == null) {
              //  this.__oConfirmationComponent.showAlert("Document generation need id to be selected", 'auto', 'Error', ConfirmationType.Error);
              //  return;
              //}

            }
            if (results[1]["Table"].length > 0) {
              documentTemplateViews = results[1]["Table"];
              this.__oDocumentTemplateDetails = results[1]["Table"];
            }

            this.__oDocumentCategories = [];
            this.service.getDataByPromise(this.__sGetApiUrl + "api/DocumentManagement/GetAllDocumentCategories/").then((Data) => {

              if (Data != null) {
                Data.sort(function(category1, category2) {
                  if(category1.DocumentCategoryName.toLowerCase() < category2.DocumentCategoryName.toLowerCase()) { return -1; }
                  if(category1.DocumentCategoryName.toLowerCase() > category2.DocumentCategoryName.toLowerCase()) { return 1; }
                  return 0;
                });
                this.__oDocumentCategories = Data;
              }

            });
            this.__bIsDataGridDocumentGeneratePopup = true;

          }
          this.FillDocumentTemplateWithDetail(documentTemplateViews);

          
          if (this.documentTemplateFunctionParameter["TemplateIds"] != null && this.documentTemplateFunctionParameter["TemplateIds"] != undefined) {
            this.hideTemplateDropDown = true;
            let selectedTemplate = this.__oDocumentTemplates.find(x => x.Name == this.documentTemplateFunctionParameter["TemplateIds"]);
            if (selectedTemplate != null) {
              this.LoadDocumentTemplate(selectedTemplate);
            }
          }
          else
            this.hideTemplateDropDown = false;
          if (this.documentTemplateFunctionParameter["Directory"]) {
            this.__sDirectory = this.documentTemplateFunctionParameter["Directory"];
          }
          if (this.documentTemplateFunctionParameter["FileSystem"]) {
            this.__sFileSystem = this.documentTemplateFunctionParameter["FileSystem"];
            this.__bUploadSharepointFileManagerReady = true;
          }

          }
      else {
        let message: string = oResponse;
        let confirmationType: ConfirmationType = ConfirmationType.Error;
        let title: string = "Error";
        if (message.toLowerCase().startsWith("success:")) {
          title = 'Success';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Success;
        } else if (message.toLowerCase().startsWith("error:")) {
          title = 'Error';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Error;
        } else if (message.toLowerCase().startsWith("warning:")) {
          title = 'Warning';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Warning;
        } else if (message.toLowerCase().startsWith("information:")) {
          title = 'Information';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Information;
        }
        this.__oConfirmationComponent.show(confirmationType, message, title, "Ok", "Cancel", false).then(() => {
          this.__oOnClosePopup.emit(null);//FB47642-Pawan Prajapati
        });;

      }

    }

  }

  //#region Get functions

  GetBusinessProcessCount(e: any) {
    if (this.InboxaccordionControl.selectedItems != undefined && this.InboxaccordionControl.selectedItems != null && this.InboxaccordionControl.selectedItems.length > 0) {
      let oBusinessProcessViewModel: BusinessProcessViewModel = this.InboxaccordionControl.selectedItems[0];

      if (oBusinessProcessViewModel.GetIsCountFetched == 0) {
        for (var oBPVM of oBusinessProcessViewModel.BusinessProcesses) {

          //this.__bIsLoadingVisible = true;
          //Start FB 13378, Handled special character check in the WF name.
          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + this.replaceAllExportString(oBPVM.BusinessProcess.replace("&", "annd").replace("+", "pluuuus").replace("/", "backslaaash").replace("\\", "forwardslaaash"))).then((Data) => {
            //End FB 13378, Handled special character check in the WF name.
            if (Data != null) {

              try {
                var oCount = JSON.parse(Data);
              }
              catch {
                console.log(Data);
              }

              let oBusinessProcessHTML: BusinessProcessHTML = oBusinessProcessViewModel.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);

              if (oBusinessProcessHTML.ItemCount == null || oBusinessProcessHTML.ItemCount == undefined) {
                oBusinessProcessHTML.ItemCount = 0;
              }

              oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;

            }

            //this.__bIsLoadingVisible = false;

          });

        }

        oBusinessProcessViewModel.GetIsCountFetched = 1;
      }

    }

  }

  GetBusinessProcesses() {

    this.__bIsLoadingVisible = true;

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcesses").then((Data) => {

      if (Data != null) {
        this.__oBusinessProcessViewModels = Data;

      }
      this.__bIsLoadingVisible = false;

    });
  }

  GetBusinessProcessInstanceCurrentStateData(lwfBusinessProcessInstanceId: number) {
    this.__bIsLoadingVisible = true;
    this.__sInstanceComment = "";
    this.__sAuditInfo = "";
    this.__sInstanceName = "";
    this.__oControlData = [];

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceCurrentStateData/" + lwfBusinessProcessInstanceId).then((Data) => {

      if (Data != null) {
        //Start FB 13378, Workflow issues on displaying XML tag while action click.
        //this.__oBusinessProcessInstanceCurrentStateDatas = Data;
        let oBusinessProcessInstanceCurrentStateDatas: BusinessProcessInstanceCurrentStateData[] = [];
        this.__oStateDataGroup = [];
        oBusinessProcessInstanceCurrentStateDatas = Data;
        this.__oBusinessProcessInstanceCurrentStateDatas = [];

        if (oBusinessProcessInstanceCurrentStateDatas.filter(x => x.GroupName != null).length > 0) {
          oBusinessProcessInstanceCurrentStateDatas.filter(x => x.GroupName != null)
            .forEach(
              x => {

                if (this.__oStateDataGroup.length == 0) {
                  let oStateGroup: StateDataGroup = new StateDataGroup();
                  oStateGroup.GroupName = x.GroupName;
                  oStateGroup.TabName = x.TabName;
                  this.__oStateDataGroup.push(oStateGroup);

                }
                else {
                  if (this.__oStateDataGroup.find(y => y.GroupName === x.GroupName) == null) {
                    let oStateGroup: StateDataGroup = new StateDataGroup();
                    oStateGroup.GroupName = x.GroupName;
                    oStateGroup.TabName = x.TabName;
                    this.__oStateDataGroup.push(oStateGroup);
                  }
                }

              }
            );
        }

        oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'Dependent Data Label')
          .forEach(
            x => {
              x.DataValue = null;
            }
          );
        oBusinessProcessInstanceCurrentStateDatas.filter(x=> x.DataType == 'Content Frame').forEach(x =>{
          x.SafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(x.DataValue);
        })
        this.__oBusinessProcessInstanceCurrentStateDatas = oBusinessProcessInstanceCurrentStateDatas;
        //End FB 13378, Workflow issues on displaying XML tag while action click.
        this.__bStateInstanceRightPanelVisisble = true;
        this.__bStateWorkflowVisible = true;
        this.__bStateRightPanelVisisble = false;
        this.__oFileDetails = [];
        this.GenerateStateTabs();

        let oFirstElement: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas[0];

        //START: Chinna - For data population for the file chooser control
        for (let oBusinessProcessInstanceCurrentStateData of this.__oBusinessProcessInstanceCurrentStateDatas) {
          if (oBusinessProcessInstanceCurrentStateData.DataType == 'File Chooser' && oBusinessProcessInstanceCurrentStateData.DataValue != null) {
            oBusinessProcessInstanceCurrentStateData.FileDetail = [];
            if (oBusinessProcessInstanceCurrentStateData.DataValue != '' && oBusinessProcessInstanceCurrentStateData.DataValue != null) {
              oBusinessProcessInstanceCurrentStateData.DataValue=this.__oUtilityService.DecryptStringAES(oBusinessProcessInstanceCurrentStateData.DataValue, Constants.EXTERNALSOURCE_AESKEY);
                let AllFiles: string[] = oBusinessProcessInstanceCurrentStateData.DataValue.split(",");
                
              for (let FileIndex in AllFiles) {
                let oFileDetail: FileDetail = null;
                oFileDetail = new FileDetail();

                oFileDetail.lBusinessProcessInstanceCurrentStateDataId = oBusinessProcessInstanceCurrentStateData.lBusinessProcessInstanceCurrentStateDataId;
                oFileDetail.FilePath = AllFiles[FileIndex];
                oFileDetail.FileName = AllFiles[FileIndex].split(/[/\\]/).pop();
                oBusinessProcessInstanceCurrentStateData.FileDetail.push(oFileDetail);
              }
            }
          }
          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box') {
            oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = [];
          }
          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Check Box' && oBusinessProcessInstanceCurrentStateData.DataValue != undefined) {
            oBusinessProcessInstanceCurrentStateData.DataValue = oBusinessProcessInstanceCurrentStateData.DataValue.toUpperCase() == 'TRUE' || oBusinessProcessInstanceCurrentStateData.DataValue == '1';
          }
          //if (oBusinessProcessInstanceCurrentStateData.DataType == 'Numeric/Money' && oBusinessProcessInstanceCurrentStateData.DataValue != undefined) {
          //  oBusinessProcessInstanceCurrentStateData.DataValue = Number(oBusinessProcessInstanceCurrentStateData.DataValue);
          //}
          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Numeric/Money' && !this.__oUtilityService.IsNullOrUndefined(oBusinessProcessInstanceCurrentStateData.DataValue) && !this.__oUtilityService.IsNullOrEmpty(oBusinessProcessInstanceCurrentStateData.DataValue)) {
            oBusinessProcessInstanceCurrentStateData.DataValue = Number(oBusinessProcessInstanceCurrentStateData.DataValue);
          }
          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Date Picker' && (this.__oUtilityService.IsNullOrUndefined(oBusinessProcessInstanceCurrentStateData.DataValue) || this.__oUtilityService.IsNullOrEmpty(oBusinessProcessInstanceCurrentStateData.DataValue))) {
                          oBusinessProcessInstanceCurrentStateData.DataValue = null;
            }
                    //if (oBusinessProcessInstanceCurrentStateData.DataType == 'Grid') {
          //  this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDataGridColumns/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId).subscribe((Data) => {

          //    if (Data != null) {
          //      this.createDataContextForStateGrid(oBusinessProcessInstanceCurrentStateData, Data);
          //    }

          //  });
          //}

          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multiline String') {
            oBusinessProcessInstanceCurrentStateData.DataValue = oBusinessProcessInstanceCurrentStateData.DataValue != null ? this.__oUtilityService.ReplaceNewLineTabCharacters(oBusinessProcessInstanceCurrentStateData.DataValue) : null;
          }
          oBusinessProcessInstanceCurrentStateData.AddTodayButton = {
            text: "Today",
            type: "default",
            onClick: (e: any) => {
              this.AddTodayButtonClicked(e, oBusinessProcessInstanceCurrentStateData.DataCaption);
            }
          };


        }
        //END: Chinna - For data population for the file chooser control

        if (oFirstElement.Comments != null && oFirstElement.Comments != '' && oFirstElement.Comments != undefined) {
          this.__sInstanceComment = this.__oUtilityService.ReplaceNewLineTabCharacters(oFirstElement.Comments);//fb 37019 Rajendra tab key
        }
        else {
          this.__sInstanceComment = oFirstElement.Comments;
        }



        this.__sInstanceName = "- " + oFirstElement.wfBusinessProcessInstance.replace(/\\"/g, '"');

        if (oFirstElement.PreviousState != null && oFirstElement.PreviousState != '') {

          this.__sAuditInfo = "Previous state(s) " + oFirstElement.PreviousState + " has been executed by " + oFirstElement.PreviousStateUser + " on " + oFirstElement.PreviousStateExitTime;//this.datePipe.transform(oFirstElement.PreviousStateExitTime, 'dd MMM yyyy') + " " + this.datePipe.transform(oFirstElement.PreviousStateExitTime, 'shortTime');
        }
        else {
          this.__sAuditInfo = '';
        }

        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceCurrentStateDataItemSource/" + lwfBusinessProcessInstanceId).then((Data) => {
          //Start FB 13378, Workflow issues on displaying XML tag while action click.
          try {

            if (Data != null) {
              this.changeStateCollapseIcon(); // PL-629 left pane issue
              for (let oCurrentInstanceWithItemSource of Data) {
                let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

                if (oBusinessProcessInstanceCurrentStateData != null) {
                  if (oBusinessProcessInstanceCurrentStateData.DataType == 'Dropdown' || oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box' ||
                    oBusinessProcessInstanceCurrentStateData.DataType == 'Due Date Specifier') {

                    try {
                      oBusinessProcessInstanceCurrentStateData.ItemSource = JSON.parse(oCurrentInstanceWithItemSource.ItemSource);
                      oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;

                      oBusinessProcessInstanceCurrentStateData.ItemSource.forEach(x => {
                        if (x.DisplayMember) {
                          x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\").replace(/TaaaabbbbKy/g, ' ');//FB 28009 -Vidya
                          x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                        }
                      })

                    }
                    catch
                    {
                      console.log(oCurrentInstanceWithItemSource.ItemSource);
                    }
                    //oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                    oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = [];
                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box' &&
                      oBusinessProcessInstanceCurrentStateData.DataValue != null && oBusinessProcessInstanceCurrentStateData.DataValue != '') {
                      //oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = oBusinessProcessInstanceCurrentStateData.DataValue.split(',');
                      oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = this.__oUtilityService.ParseCSVStringToStringArray(oBusinessProcessInstanceCurrentStateData.DataValue.replace(/\t/g, ' ')); 
                    }
                  }

                  //else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Qualitative Grid') {

                  //  if (oBusinessProcessInstanceCurrentStateData.DataValue == null || oBusinessProcessInstanceCurrentStateData.DataValue == '') {
                  //    oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                  //    let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oBusinessProcessInstanceCurrentStateData.DataCaption);
                  //    if (oControlData != null) {
                  //      oControlData.Control.Refresh();
                  //      console.log('control initialized');
                  //    }
                  //  }

                  //}
                  //else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Quantitative Grid') {

                  //  if (oBusinessProcessInstanceCurrentStateData.DataValue == null || oBusinessProcessInstanceCurrentStateData.DataValue == '') {
                  //    oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                  //    let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oBusinessProcessInstanceCurrentStateData.DataCaption);
                  //    if (oControlData != null) {
                  //      oControlData.Control.Refresh();
                  //      console.log('control initialized');
                  //    }
                  //  }

                  //}
                  //else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Score Analysis') {

                  //  if (oBusinessProcessInstanceCurrentStateData.DataValue == null || oBusinessProcessInstanceCurrentStateData.DataValue == '') {
                  //    oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                  //    let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oBusinessProcessInstanceCurrentStateData.DataCaption);
                  //    if (oControlData != null) {
                  //      oControlData.Control.Refresh();
                  //      console.log('control initialized');
                  //    }
                  //  }

                  //}
                  //else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Final Score Analysis') {

                  //  if (oBusinessProcessInstanceCurrentStateData.DataValue == null || oBusinessProcessInstanceCurrentStateData.DataValue == '') {
                  //    oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                  //    let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oBusinessProcessInstanceCurrentStateData.DataCaption);
                  //    if (oControlData != null) {
                  //      oControlData.Control.Refresh();
                  //      console.log('control initialized');
                  //    }
                  //  }

                  //}

                  else {
                    oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
                    oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Label') {
                      oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                    }
                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multiline String') {
                      oBusinessProcessInstanceCurrentStateData.DataValue = oBusinessProcessInstanceCurrentStateData.DataValue != null ? this.__oUtilityService.ReplaceNewLineTabCharacters(oBusinessProcessInstanceCurrentStateData.DataValue) : null;
                    }
                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Date Picker' && (this.__oUtilityService.IsNullOrUndefined(oBusinessProcessInstanceCurrentStateData.DataValue) || this.__oUtilityService.IsNullOrEmpty(oBusinessProcessInstanceCurrentStateData.DataValue))) {
                      oBusinessProcessInstanceCurrentStateData.DataValue = null;
                    }
                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Check Box') {
                      let sDataValue: string = oCurrentInstanceWithItemSource.DataValue;

                      if (sDataValue.toLowerCase() == 'true' || sDataValue == '1') {
                        oBusinessProcessInstanceCurrentStateData.DataValue = true;
                      }
                      else {
                        oBusinessProcessInstanceCurrentStateData.DataValue = false;
                      }

                      //oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue == 'True';
                    }

                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'File Chooser' && oCurrentInstanceWithItemSource.DataValue != null) {
                      oBusinessProcessInstanceCurrentStateData.FileDetail = [];

                      if(oBusinessProcessInstanceCurrentStateData.DataValue != null && oBusinessProcessInstanceCurrentStateData.DataValue != '')
                        oBusinessProcessInstanceCurrentStateData.DataValue= this.__oUtilityService.DecryptStringAES(oBusinessProcessInstanceCurrentStateData.DataValue, Constants.EXTERNALSOURCE_AESKEY);

                      if(oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != '')
                        oCurrentInstanceWithItemSource.DataValue= this.__oUtilityService.DecryptStringAES(oCurrentInstanceWithItemSource.DataValue, Constants.EXTERNALSOURCE_AESKEY);

                      let AllFiles: string[] = oCurrentInstanceWithItemSource.DataValue.split(",");

                      for (let FileIndex in AllFiles) {
                        let oFileDetail: FileDetail = null;
                        oFileDetail = new FileDetail();

                        oFileDetail.lBusinessProcessInstanceCurrentStateDataId = oBusinessProcessInstanceCurrentStateData.lBusinessProcessInstanceCurrentStateDataId;
                        oFileDetail.FilePath = AllFiles[FileIndex];
                        oFileDetail.FileName = AllFiles[FileIndex].split(/[/\\]/).pop();
                        oBusinessProcessInstanceCurrentStateData.FileDetail.push(oFileDetail);

                      }
                    }

                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Grid') {
                      this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDataGridColumns/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId).subscribe((Data) => {
                        if (Data != null) {
                          this.createDataContextForStateGrid(oBusinessProcessInstanceCurrentStateData, Data);
                        }
                      });
                    }

                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Data Grid') {

                      this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDataGridColumns/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId).subscribe((Data) => {
                        if (Data != null) {

                          let BusinessProcessStateGridData: BusinessProcessStateGridData[] = Data;

                          oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData = [];

                          for (let oStateGridData of BusinessProcessStateGridData) {
                            oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData.push(oStateGridData);
                          }

                          this.createDataContextForGenericStateDataGrid(oBusinessProcessInstanceCurrentStateData, BusinessProcessStateGridData);
                        }
                      });
                    }
                    //if (oBusinessProcessInstanceCurrentStateData.DataType == 'Numeric/Money' && oCurrentInstanceWithItemSource.DataValue != undefined && oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != '') {
                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Numeric/Money'
                      && !this.__oUtilityService.IsNullOrUndefined(oBusinessProcessInstanceCurrentStateData.DataValue)
                      && !this.__oUtilityService.IsNullOrEmpty(oBusinessProcessInstanceCurrentStateData.DataValue)) {
                      oBusinessProcessInstanceCurrentStateData.DataValue = Number(oCurrentInstanceWithItemSource.DataValue);
                    }
                    if (oBusinessProcessInstanceCurrentStateData.DataType == "File Manager") {
                      oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
                      oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
                      this.__bShowFileManager = true;
                    }

                    if (oBusinessProcessInstanceCurrentStateData.DataType == 'Counterparty Tree View' && oCurrentInstanceWithItemSource.DataValue != "") {

                      for (let i = 0; i < oBusinessProcessInstanceCurrentStateData.DataValue.length; i++) {
                        this.normalize(Data[i], null);
                      }

                      oBusinessProcessInstanceCurrentStateData.DataValue = JSON.parse(oBusinessProcessInstanceCurrentStateData.DataValue);
                    }
                  }
                }

              }

              try {
                this.GetStateDataConditionResult(lwfBusinessProcessInstanceId);
              }
              catch { }
            }
          }
          catch { }
          try {
            if (this.__bIsOpenedThroughURL && this.__sParam != null && this.__sParam != undefined && this.__sParam.indexOf(":") == -1) {
              let sParamValueWithDataCaptions: string[] = this.__sParam.split(',');

              for (let oParamValueWithDataCaption of sParamValueWithDataCaptions) {
                let sDataCaption: string = oParamValueWithDataCaption.substring(0, oParamValueWithDataCaption.indexOf(":"));

                let sDataValue: string = oParamValueWithDataCaption.substring(oParamValueWithDataCaption.indexOf(":") + 1);
                if (sDataCaption.toLowerCase() == "hidesidepanel") {
                  if (sDataValue.toLowerCase() == "true") {
                    this.hideSidePanel();
                  } else {
                    this.showSidePanel();
                  }
                  continue;
                }

                sDataValue = sDataValue.replace('commma', ',');

                let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.DataCaption == sDataCaption);

                if (oBusinessProcessInstanceCurrentStateData.DataType == 'Check Box') {
                  if (sDataValue.toLowerCase() == 'true' || sDataValue == '1') {
                    oBusinessProcessInstanceCurrentStateData.DataValue = true;
                  }
                  else {
                    oBusinessProcessInstanceCurrentStateData.DataValue = false;
                  }
                }
                else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box') {
                  let multiselectedItems = this.__oUtilityService.ParseCSVStringToStringArray(sDataValue);
                  multiselectedItems = multiselectedItems.map(function (item) {
                    return item.replace(/commma/g, ',');
                  });
                  oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = multiselectedItems;
                  oBusinessProcessInstanceCurrentStateData.DataValue = sDataValue;
                }
                else {
                  oBusinessProcessInstanceCurrentStateData.DataValue = sDataValue;
                }

              }

            }

            if (this.__bIsOpenedThroughURL && this.__sParam != null && this.__sParam != undefined && this.__sParam.indexOf(":") != -1) {

              let sParamValueWithDataCaptions: string[] = this.__sParam.split('~');

              for (let oParamValueWithDataCaption of sParamValueWithDataCaptions) {
                let sDataCaption: string = oParamValueWithDataCaption.substring(0, oParamValueWithDataCaption.indexOf(":"));

                let sDataValue: string = oParamValueWithDataCaption.substring(oParamValueWithDataCaption.indexOf(":") + 1);
                if (sDataCaption.toLowerCase() == "hidesidepanel") {
                  if (sDataValue.toLowerCase() == "true") {
                    this.hideSidePanel();
                  }
                  continue;
                }

                let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.DataCaption == sDataCaption);
                if (oBusinessProcessInstanceCurrentStateData.DataType == 'Check Box') {
                  if (sDataValue.toLowerCase() == 'true' || sDataValue == '1') {
                    oBusinessProcessInstanceCurrentStateData.DataValue = true;
                  }
                  else {
                    oBusinessProcessInstanceCurrentStateData.DataValue = false;
                  }
                }
                else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box') {
                  let multiselectedItems = this.__oUtilityService.ParseCSVStringToStringArray(sDataValue);
                  multiselectedItems = multiselectedItems.map(function (item) {
                    return item.replace(/commma/g, ',');
                  });
                  oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = multiselectedItems;
                  oBusinessProcessInstanceCurrentStateData.DataValue = sDataValue;
                }
                else {
                  oBusinessProcessInstanceCurrentStateData.DataValue = sDataValue;
                }

              }

            }
          }
          catch { }

          this.__bIsLoadingVisible = false;
          //End FB 13378, Workflow issues on displaying XML tag while action click.
        });

        let lwfBusinessProcessStateId: number = this.__oBusinessProcessInstanceCurrentStateDatas[0].lwfBusinessProcessStateId;

        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateActions/" + lwfBusinessProcessStateId).then((Data) => {

          if (Data != null) {
            let oBPA: BusinessProcessStateAction[] = Data;

            this.__oBusinessProcessStateActions = oBPA.filter(x => x.wfBusinessProcessRuleAction != null);

            let MaxConditionId: number = Math.max.apply(null, this.__oBusinessProcessStateActions.map(function (item) {
              return item.DisplayOrder;
            }));

            let oBusinessProcessStateAction: BusinessProcessStateAction = this.__oBusinessProcessStateActions[0];

            let oBusinessProcessStateActionCancel: BusinessProcessStateAction = Object.assign({}, oBusinessProcessStateAction);
            if (this.__oBusinessProcessInstanceCurrentStateDatas[0].IsDisplayExit == 1) {
              oBusinessProcessStateActionCancel.wfBusinessProcessRuleAction = "Exit";
              oBusinessProcessStateActionCancel.DisplayOrder = MaxConditionId + 1;
              this.__oBusinessProcessStateActions.push(oBusinessProcessStateActionCancel);

            }

            //Start FB48599-Pawan Prajapati
            this.__bIsLoadingVisibleForPermission = true;
            this.service.getDataByObservable2(this.__sGetApiUrl + "api/WorkflowDashBoard/CheckActionPermission/" + lwfBusinessProcessInstanceId + "/" + lwfBusinessProcessStateId)
              .pipe(catchError(oError => {
                this.__bIsLoadingVisibleForPermission = false;
                if (oError.error) {
                  this.__oConfirmationComponent.showAlert(oError.error, 'auto', 'Error', ConfirmationType.Error);
                  this.__oBusinessProcessStateActions.filter(k => k.wfBusinessProcessRuleAction != "Exit").forEach(__oBusinessProcessStateAction => {
                    __oBusinessProcessStateAction.IsDisabled = true;
                  });
                }
                return oError;
              })).subscribe(oPermissions => {
                this.__bIsLoadingVisibleForPermission = false;
                if (oPermissions) {
                  this.__oBusinessProcessStateActions.filter(k => k.wfBusinessProcessRuleAction != "Exit").forEach(__oBusinessProcessStateAction => {
                    var oPermission = oPermissions?.find(y => y.lwfBusinessProcessRuleActionId == __oBusinessProcessStateAction.lwfBusinessProcessRuleActionId);
                    if (oPermission != null) {
                      __oBusinessProcessStateAction.IsDisabled = oPermission.IsDisabled;
                      __oBusinessProcessStateAction.DisabledMessage = oPermission.Message;
                    }
                  });
                }
              });
            //End FB48599-Pawan Prajapati
          }
        });

        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateActionExecutes/" + lwfBusinessProcessStateId).then((Data) => {

          if (Data != null) {
            this.__oBusinessProcessStateActionExecutes = Data;
            setTimeout(() => {
              this.isEditorDisplay = true;
            }, 0);
            if (this.hideDashboardMenu) {
              $('.pCollapsable').css({ 'top': '4.5rem' });
              $('.pStateCollapsable').css({ 'top': '4.5rem' });
              $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
              $('#accordion').css({ 'height': 'calc(100vh - 10.9rem)' });
              $('.dx-multiview-item-content').css({ 'height': 'calc(100vh - 16rem)' });
            } else {
              this.showDashboardMenu();
            }
          }

        });

        //this.__oWFTabs = [];
        //this.__oWFTabs = Object.assign([], this.WFservice.getWorkFlowTabs());

        //if (this.__oWFBusinessProcessDefinition.IsComments == 1)
        //{
        //  let oCommentTab: WorkFlowTab = new WorkFlowTab();

        //  oCommentTab.ID = 2
        //  oCommentTab.Name = "Comment";
        //  oCommentTab.template = "Comment"

        //  this.__oWFTabs.push(oCommentTab);
        //}
        //else
        //{
        //  if (this.__oWFTabs.length > 1)
        //  {
        //    let oCommentTab: WorkFlowTab = this.__oWFTabs.find(x => x.Name == "Comment");
        //    this.__oWFTabs.splice(this.__oWFTabs.indexOf(oCommentTab), 1);
        //  }
        //}

      }

      //this.__bIsLoadingVisible = false;

    }).then(() => {
      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStates/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {

        if (Data != null) {
          this.__oBusinessProcessStates = Data;
          let oBPS = this.__oBusinessProcessStates.find(x => x.wfBusinessProcessState == this.__oBusinessProcessInstanceCurrentStateDatas[0]?.wfBusinessProcessState);
          this.__oBusinessProcessStateName = oBPS?.wfBusinessProcessState;
          this.__oBusinessProcessStateDisplayName = oBPS?.wfBusinessProcessStateDisplayName;
        }
      });
    });
    

  }
  //collapse side panel
  hideSidePanel() {
    $('#accordionPane').removeClass('show');
    $('#accordionPane').addClass('collapse');   
    $($('p.pCollapsable>a')[0]).find('span').removeClass('bluetab_1');
    $($('p.pCollapsable>a')[0]).find('span').addClass('bluetab_2');
    $('p.pCollapsable').css({ 'background': '#FFFFFF', 'width': '1.3rem', 'border-radius': '5px' });
    $('p.pCollapsable>a').css({ 'margin-left': '-0.2rem' });

    $('#statesPane').removeClass('show');
    $('#statesPane').addClass('collapse');
    $($('p.pStateCollapsable>a')[0]).find('span').removeClass('bluetab_1');
    $($('p.pStateCollapsable>a')[0]).find('span').addClass('bluetab_2');
    $('p.pStateCollapsable').css({ 'background': '#FFFFFF', 'width': '1.3rem', 'border-radius': '5px' });
    $('p.pStateCollapsable>a').css({ 'margin-left': '-0.2rem' });

  
    if (this.__bStateWorkflowVisible) {
      $('#divStateWF').css({ 'padding': '0 0 0 2rem' });
      $('#div-state-right-panel').css({ 'padding': '0 0 0 0' });
      $('#div-state-content').css({ 'padding': '0 0 0 2rem' });
    }
    else if (this.__bStatelessWorkflowVisible) {
      $('#divStatelessWF').css({ 'padding': '0 0 0 2rem' });
      $('#div-state-right-panel').css({ 'padding': '0 0 0 2rem' });

    }
  }

  showSidePanel() {
    $('#accordionPane').addClass('show');
    $('#accordionPane').removeClass('collapse');
    $($('p.pCollapsable>a')[0]).find('span').addClass('bluetab_1');
    $($('p.pCollapsable>a')[0]).find('span').removeClass('bluetab_2');
    $('p.pCollapsable').css({ 'background': '#FFFFFF', 'width': '1px', 'border-radius': '5px' });
    $('p.pCollapsable>a').css({ 'margin-left': '-1.1rem' });
    if (this.__bStateWorkflowVisible) {
      $('#divStateWF').css({ 'padding': '0 0 0 1rem' });
    }
    else if (this.__bStatelessWorkflowVisible) {
      $('#divStatelessWF').css({ 'padding': '0 0 0 1rem' });
    }
  }

  showDashboardMenu() {
    $('.pCollapsable').css({ 'top': '7.5rem' });
    $('.pStateCollapsable').css({ 'top': '7.5rem' });
    $('#divStateWF').css({ 'height': 'calc(100vh - 8.2rem)' });
    $('#statesPane').css({ 'height': 'calc(100vh - 11rem)' });
    $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 10.8rem)' });
  }

  //Create a data context for state datagrid
  createDataContextForStateGrid(oBusinessProcessInstanceCurrentStateData: any, Data: any) {
    this.__oGridDatacolumns = [];
    this.__oBusinessProcessStateGridDataContext = [];
    this.__lDataGridColumns = Data;
    this.__oBusinessProcessStateGridDataQueryResult = [];
    //let queryResult = '[[{"RowNumber":"1"},[{"ColumnName":"CounterpartyName","DataValue":"Barclays","ColumnType":"System.String"},{"ColumnName":"CustomerId","DataValue":"Barclays Bank PLC","ColumnType":"System.String"},{"ColumnName":"RatingType","DataValue":"S & P","ColumnType":"System.String"},{"ColumnName":"CreditRating","DataValue":"AAA","ColumnType":"System.String"},{"ColumnName":"Country","DataValue":"Czech Republic","ColumnType":"System.String"},{"ColumnName":"IHSRating","DataValue":"Grade A","ColumnType":"System.String"},{"ColumnName":"CurrentLine","DataValue":"234","ColumnType":"System.String"},{"ColumnName":"ProposedLine","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"Currency","DataValue":"EUR","ColumnType":"System.String"},{"ColumnName":"PaymentTerms","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"DealTenor","DataValue":"2 year","ColumnType":"System.String"}]],[{"RowNumber":"2"},[{"ColumnName":"CounterpartyName","DataValue":"Barclays","ColumnType":"System.String"},{"ColumnName":"CustomerId","DataValue":"Barclays123","ColumnType":"System.String"},{"ColumnName":"RatingType","DataValue":"Financial(S & P)","ColumnType":"System.String"},{"ColumnName":"CreditRating","DataValue":"AA + ","ColumnType":"System.String"},{"ColumnName":"Country","DataValue":"Ireland, North","ColumnType":"System.String"},{"ColumnName":"IHSRating","DataValue":"Grade B","ColumnType":"System.String"},{"ColumnName":"CurrentLine","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"ProposedLine","DataValue":"345","ColumnType":"System.String"},{"ColumnName":"Currency","DataValue":"USD","ColumnType":"System.String"},{"ColumnName":"PaymentTerms","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"DealTenor","DataValue":"1 year","ColumnType":"System.String"}]]]';
    let jObject = (oBusinessProcessInstanceCurrentStateData.DataValue == '' || oBusinessProcessInstanceCurrentStateData.DataValue == null
      ? null : JSON.parse(oBusinessProcessInstanceCurrentStateData.DataValue));
    let jArrObject = (jObject != null ? jObject.Data.Row : "");

    var oDynamicQueryResult = (jArrObject == '' || jArrObject == undefined ? [] : JSON.parse(JSON.stringify(jArrObject)));
    if (!Array.isArray(oDynamicQueryResult)) {
      let oBusinessProcessStateGridDataQueryResult = new BusinessProcessStateGridDataQueryResult();

      let oRowNumber = oDynamicQueryResult.RowNumber;
      let oResult = oDynamicQueryResult.QueryResult;

      oBusinessProcessStateGridDataQueryResult.RowNumber = oRowNumber;
      oBusinessProcessStateGridDataQueryResult.QueryResult = [];
      //for (var oQR of oResult) {
      //  let oDynamicQueryResult = new DynamicQueryResult();
      //  oDynamicQueryResult.ColumnName = oQR.ColumnName;
      //  oDynamicQueryResult.DataValue = oQR.DataValue;
      //  //oDynamicQueryResult.ColumnType = oQR.ColumnType;

      //  oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
      //}

      for (var oSDD of Data.sort(x => x.DisplayOrder)) {
        let oExistQueryResult = oResult.find(x => x.ColumnName == oSDD.DataField);

        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oSDD.DataField;


        if (oExistQueryResult) {
          oDynamicQueryResult.DataValue = oExistQueryResult.DataValue;
        }

        oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);

      }


      this.__oBusinessProcessStateGridDataQueryResult.push(oBusinessProcessStateGridDataQueryResult);
    }
    else {
      for (var oDQR of oDynamicQueryResult) {
        let oBusinessProcessStateGridDataQueryResult = new BusinessProcessStateGridDataQueryResult();

        let oRowNumber = oDQR.RowNumber;
        let oResult = oDQR.QueryResult;

        oBusinessProcessStateGridDataQueryResult.RowNumber = oRowNumber;
        oBusinessProcessStateGridDataQueryResult.QueryResult = [];

        //for (var oQR of oResult) {
        //  let oDynamicQueryResult = new DynamicQueryResult();
        //  oDynamicQueryResult.ColumnName = oQR.ColumnName;
        //  oDynamicQueryResult.DataValue = oQR.DataValue;
        //  //oDynamicQueryResult.ColumnType = oQR.ColumnType;

        //  oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
        //}


        for (var oSDD of Data.sort(x => x.DisplayOrder)) {
          let oExistQueryResult = oResult.find(x => x.ColumnName == oSDD.DataField);

          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oSDD.DataField;


          if (oExistQueryResult) {
            oDynamicQueryResult.DataValue = oExistQueryResult.DataValue;
          }

          oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);

        }

        this.__oBusinessProcessStateGridDataQueryResult.push(oBusinessProcessStateGridDataQueryResult);
      }
    }


    // Generating grid columns
    let iColumnIndex: number = 1;
    //let i: number = 0;
    for (var oSDD of Data.sort(x => x.DisplayOrder)) {
      if (oSDD.DataType == 'Dropdown') {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateComboBox',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      else if (oSDD.DataType == 'Search Box') {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateAutoComplete',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      else if (oSDD.DataType == 'Numeric/Money') {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateAmount',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          format: "#,##0.00",
          dataType: 'number',
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      else if (oSDD.DataType == 'Multiline Text Box') {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateMultiline',
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      else if (oSDD.DataType == 'Date Picker') {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateDate',
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          dataType: 'date',
          format: 'dd-MMM-yyyy',
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      else if (oSDD.DataType == 'Check Box') {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateCheckBox',
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      else {
        this.__oGridDatacolumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateTextBox',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          //width: oSDD.Width,
          //fixed: true,
          sortOrder: 'asc',
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true
        })
      }
      //if (oSDD.IsMandatory == 1) {
      //  this.__oGridDatacolumns[i].validationRules = [{ type: "required" }];
      //}
      iColumnIndex += 1;
      //i++;
    }

    this.__oGridDatacolumns.push({
      caption: 'Action',
      cellTemplate: 'gridCellTemplate',
      width: '30',
      fixed: true,
      fixedPosition: 'right',
      allowFiltering: false,
      allowReordering: false,
      alignment: 'center',
    });

    // Generating data context for grid
    for (var oDC of this.__oBusinessProcessStateGridDataQueryResult.sort((a, b) => b.RowNumber - a.RowNumber)) {
      let oDataCntext = new BusinessProcessStateGridDataContext();

      oDataCntext.RowNumber = oDC.RowNumber;
      oDataCntext.QueryResult = oDC.QueryResult;

      oDataCntext.DataValue = [];
      oDataCntext.ItemSource = [];

      oDataCntext.DataValue.push('');
      oDataCntext.ItemSource.push([]);

      for (var oSDD of Data.sort(x => x.DisplayOrder)) {

        // Adding Datavalue
        let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.DataField);

        let oColumnValue = (oColumn == undefined || oColumn == null ? '' : oColumn.DataValue);

        if (oColumnValue != null && oColumnValue != '') {
          oDataCntext.DataValue.push(oColumnValue);
        }
        else {
          let oEmptyValue = '';
          oDataCntext.DataValue.push(oEmptyValue);
        }

        // Adding Itemsource
        if (oSDD.ItemSource != null && oSDD.ItemSource != '') {        
          oSDD.ItemSource = oSDD.ItemSource.replace(/backslaaash/g, "\\");
          oSDD.ItemSource = this.replaceAllSpecialCharacters(oSDD.ItemSource);  
          let oIS = JSON.parse(oSDD.ItemSource);
          oDataCntext.ItemSource.push(oIS);
        }
        else {

          let oItemSource = [];
          oDataCntext.ItemSource.push(oItemSource);
        }
      }

      this.__oBusinessProcessStateGridDataContext.push(oDataCntext);

    }
  }
  //#endregion


  //Create a data context for state datagrid
  createDataContextForGenericStateDataGrid(oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData, Data: BusinessProcessStateGridData[]) {
    //this.__oGridDatacolumns = [];
    //this.__oBusinessProcessStateGridDataContext = [];
    //this.__lDataGridColumns = Data;
    //this.__oBusinessProcessStateGridDataQueryResult = [];

    oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult = [];

    //let queryResult = '[[{"RowNumber":"1"},[{"ColumnName":"CounterpartyName","DataValue":"Barclays","ColumnType":"System.String"},{"ColumnName":"CustomerId","DataValue":"Barclays Bank PLC","ColumnType":"System.String"},{"ColumnName":"RatingType","DataValue":"S & P","ColumnType":"System.String"},{"ColumnName":"CreditRating","DataValue":"AAA","ColumnType":"System.String"},{"ColumnName":"Country","DataValue":"Czech Republic","ColumnType":"System.String"},{"ColumnName":"IHSRating","DataValue":"Grade A","ColumnType":"System.String"},{"ColumnName":"CurrentLine","DataValue":"234","ColumnType":"System.String"},{"ColumnName":"ProposedLine","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"Currency","DataValue":"EUR","ColumnType":"System.String"},{"ColumnName":"PaymentTerms","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"DealTenor","DataValue":"2 year","ColumnType":"System.String"}]],[{"RowNumber":"2"},[{"ColumnName":"CounterpartyName","DataValue":"Barclays","ColumnType":"System.String"},{"ColumnName":"CustomerId","DataValue":"Barclays123","ColumnType":"System.String"},{"ColumnName":"RatingType","DataValue":"Financial(S & P)","ColumnType":"System.String"},{"ColumnName":"CreditRating","DataValue":"AA + ","ColumnType":"System.String"},{"ColumnName":"Country","DataValue":"Ireland, North","ColumnType":"System.String"},{"ColumnName":"IHSRating","DataValue":"Grade B","ColumnType":"System.String"},{"ColumnName":"CurrentLine","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"ProposedLine","DataValue":"345","ColumnType":"System.String"},{"ColumnName":"Currency","DataValue":"USD","ColumnType":"System.String"},{"ColumnName":"PaymentTerms","DataValue":"123","ColumnType":"System.String"},{"ColumnName":"DealTenor","DataValue":"1 year","ColumnType":"System.String"}]]]';
    let jObject = (oBusinessProcessInstanceCurrentStateData.DataValue == '' || oBusinessProcessInstanceCurrentStateData.DataValue == null
      ? null : JSON.parse(oBusinessProcessInstanceCurrentStateData.DataValue));
    let jArrObject = (jObject != null ? jObject.Data.Row : "");

    var oDynamicQueryResult = (jArrObject == '' || jArrObject == undefined ? [] : JSON.parse(JSON.stringify(jArrObject)));
    if (!Array.isArray(oDynamicQueryResult)) {
      let oBusinessProcessStateGridDataQueryResult = new BusinessProcessStateGridDataQueryResult();

      let oRowNumber = oDynamicQueryResult.RowNumber;
      let oResult = oDynamicQueryResult.QueryResult;

      oBusinessProcessStateGridDataQueryResult.RowNumber = oRowNumber;
      oBusinessProcessStateGridDataQueryResult.RowStatus = "";
      oBusinessProcessStateGridDataQueryResult.QueryResult = [];
      //for (var oQR of oResult) {
      //  let oDynamicQueryResult = new DynamicQueryResult();
      //  oDynamicQueryResult.ColumnName = oQR.ColumnName;
      //  oDynamicQueryResult.DataValue = oQR.DataValue;
      //  //oDynamicQueryResult.ColumnType = oQR.ColumnType;

      //  oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
      //}

      for (var oSDD of Data.sort(x => x.DisplayOrder)) {
        let oExistQueryResult;

        if (Array.isArray(oResult)) { oExistQueryResult = oResult.find(x => x.ColumnName == oSDD.DataField); }
        else { oExistQueryResult = oResult }

        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oSDD.DataField;



        if (oExistQueryResult) {
          oDynamicQueryResult.ColumnType = oExistQueryResult.ColumnType;
          oDynamicQueryResult.DataValue = oExistQueryResult.DataValue;
        }

        oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);

      }


      oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult.push(oBusinessProcessStateGridDataQueryResult);
    }
    else {

      for (var oDQR of oDynamicQueryResult) {
        let oBusinessProcessStateGridDataQueryResult = new BusinessProcessStateGridDataQueryResult();

        let oRowNumber = oDQR.RowNumber;
        let oResult = oDQR.QueryResult;

        oBusinessProcessStateGridDataQueryResult.RowNumber = oRowNumber;
        oBusinessProcessStateGridDataQueryResult.QueryResult = [];

        //for (var oQR of oResult) {
        //  let oDynamicQueryResult = new DynamicQueryResult();
        //  oDynamicQueryResult.ColumnName = oQR.ColumnName;
        //  oDynamicQueryResult.DataValue = oQR.DataValue;
        //  //oDynamicQueryResult.ColumnType = oQR.ColumnType;

        //  oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
        //}


        for (var oSDD of Data.sort(x => x.DisplayOrder)) {
          let oExistQueryResult;

          if (Array.isArray(oResult)) { oExistQueryResult = oResult.find(x => x.ColumnName == oSDD.DataField); }
          else { oExistQueryResult = oResult }



          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oSDD.DataField;


          if (oExistQueryResult) {
            oDynamicQueryResult.ColumnType = oExistQueryResult.ColumnType;
            oDynamicQueryResult.DataValue = oExistQueryResult.DataValue;
          }

          oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
        }

        oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult.push(oBusinessProcessStateGridDataQueryResult);
      }
    }


    oBusinessProcessInstanceCurrentStateData.StateDataGridColumns = [];

    let actionsValue = [];

    if (oBusinessProcessInstanceCurrentStateData.IsViewViaPopup == 1) {
      actionsValue.push({ id: "View", name: "View" });
    }
    oBusinessProcessInstanceCurrentStateData.wfBusinessProcessStateDataGridActions.forEach((action: wfBusinessProcessStateDataGridAction) => {
      let value = { id: action.lwfBusinessProcessStateDataGridActionId, name: action.wfBusinessProcessStateDataGridAction1 };
      actionsValue.push(value);
    });
    if (oBusinessProcessInstanceCurrentStateData.IsDeleteRowEnabled) {
      let value = { id: "Remove", name: "Remove" };
      actionsValue.push(value);
    }
    if (actionsValue.length > 0) {
      let key = oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId;
      this.__oDGStateActionsCog[key] = actionsValue;
    }

    // Generating grid columns
    let iColumnIndex: number = 1;
    //let i: number = 0;
    for (var oSDD of Data.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder)) {
      if (oSDD.DataType == 'DropDown') {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateComboBox',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else if (oSDD.DataType == 'Search Box') {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateAutoComplete',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly ? false : true,
          visible: oSDD.IsVisible ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else if (oSDD.DataType == 'Multi Select Combo Box') {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateMultiSelect',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else if (oSDD.DataType == 'Numeric/Money') {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateAmount',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          format: oSDD.FormatString,
          dataType: 'number',
          allowEditing: oSDD.IsReadOnly == 1 ? false : true,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else if (oSDD.DataType == 'Multiline String') {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateMultiline',
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else if (oSDD.DataType == 'Date Picker') {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateDate',
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          dataType: 'date',
          format: 'dd-MMM-yyyy',
          allowEditing: oSDD.IsReadOnly == 1 ? false : true,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else if (oSDD.DataType == 'Check Box') {
        if (oSDD.IsReadOnly == 0) {
          oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
            dataField: "DataValue[" + iColumnIndex + "]",
            caption: oSDD.ColumnHeader,
            editCellTemplate: 'gridCellTemplateCheckBox',
            //cellTemplate: 'cellTemplateMultilineReadOnly',
            width: oSDD.Width,
            //fixed: true,
            //sortOrder: 'asc',
            allowSorting: true,
            allowFiltering: true,
            allowReordering: false,
            allowHiding: false,
            showInColumnChooser: false,
            allowEditing: true,
            visible: oSDD.IsVisible == 1 ? true : false,
            mandatory: oSDD.IsMandatory == 1 ? true: false
          })
        }
        else {
          oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
            dataField: "DataValue[" + iColumnIndex + "]",
            caption: oSDD.ColumnHeader,
            //editCellTemplate: 'gridCellTemplateCheckBox',
            cellTemplate: 'gridCellTemplateCheckBoxReadOnly',
            width: oSDD.Width,
            //fixed: true,
            //sortOrder: 'asc',
            allowSorting: true,
            allowFiltering: true,
            allowReordering: false,
            allowHiding: false,
            showInColumnChooser: false,
            allowEditing: false,
            visible: oSDD.IsVisible == 1 ? true : false,
            mandatory: oSDD.IsMandatory == 1 ? true: false
          })
        }
      }
      else if (oSDD.DataType == "URL") {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          cellTemplate: 'gridCellTemplateURLReadOnly',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: false,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      else {
        oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
          dataField: "DataValue[" + iColumnIndex + "]",
          caption: oSDD.ColumnHeader,
          editCellTemplate: 'gridCellTemplateTextBox',
          //validationRules: [{ type: required }],
          //cellTemplate: 'cellTemplateMultilineReadOnly',
          width: oSDD.Width,
          //fixed: true,
          //sortOrder: 'asc',
          allowSorting: true,
          allowFiltering: true,
          allowReordering: false,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: oSDD.IsReadOnly == 1 ? false : true,
          visible: oSDD.IsVisible == 1 ? true : false,
          mandatory: oSDD.IsMandatory == 1 ? true: false
        })
      }
      //if (oSDD.IsMandatory == 1) {
      //  this.__oGridDatacolumns[i].validationRules = [{ type: "required" }];
      //}
      iColumnIndex += 1;
      //i++;
    }

    let lActionButtonCount = 0;
    if (oBusinessProcessInstanceCurrentStateData.IsDeleteRowEnabled == 1) lActionButtonCount++;
    if (oBusinessProcessInstanceCurrentStateData.IsViewViaPopup == 1) lActionButtonCount++;
    if (oBusinessProcessInstanceCurrentStateData.wfBusinessProcessStateDataGridActions.length > 0) lActionButtonCount += oBusinessProcessInstanceCurrentStateData.wfBusinessProcessStateDataGridActions.length;

    if (lActionButtonCount == 1) {
      oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
        caption: 'Action',
        cellTemplate: 'gridCellTemplateActionSingle',
        width: 'auto',
        fixed: true,
        fixedPosition: 'right',
        allowFiltering: false,
        allowReordering: false,
        alignment: 'center',
      });
    }
    if (lActionButtonCount > 1) {
      oBusinessProcessInstanceCurrentStateData.StateDataGridColumns.push({
        caption: 'Action',
        cellTemplate: 'gridCellTemplateActionMulti',
        width: 'auto',
        allowEditing: false,
        fixed: true,
        fixedPosition: 'right',
        allowFiltering: false,
        allowReordering: false,
        alignment: 'center',
      });
    }


    oBusinessProcessInstanceCurrentStateData.ItemSource = [];

    // Generating data context for grid
    for (var oDC of oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult) {
      let oDataCntext = new BusinessProcessStateGridDataContext();

      oDataCntext.RowNumber = oDC.RowNumber;
      oDataCntext.RowStatus = "";
      oDataCntext.QueryResult = oDC.QueryResult;

      oDataCntext.DataValue = [];
      oDataCntext.ItemSource = [];
      oDataCntext.MultiSelectedItems = [];
      oDataCntext.Opened = [];
      oDataCntext.NumberFormat = [];
      oDataCntext.MinNum = [];
      oDataCntext.MaxNum = [];
      oDataCntext.TextSize = [];
      oDataCntext.BusinessProcessStateGridData = [];

      oDataCntext.DataValue.push('');
      oDataCntext.ItemSource.push([]);
      oDataCntext.MultiSelectedItems.push([]);
      oDataCntext.Opened.push(false);
      oDataCntext.NumberFormat.push('#,##0.##');
      oDataCntext.MinNum.push(0);
      oDataCntext.MaxNum.push(99);
      oDataCntext.TextSize.push(5000);


      for (var oSDD of Data.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder)) {

        // Adding Datavalue
        let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.DataField);

        if (oColumn.ColumnType.includes('Boolean')) {
          let sValue: string = oColumn.DataValue;
          let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
          oDataCntext.DataValue.push(bValue);

        }
        else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
          let iValue: number = oColumn.DataValue;

          if (oSDD.DataType == 'Check Box') {
            let bValue: boolean = false;

            if (Number(iValue) == 1) {
              bValue = true;
            }

            oDataCntext.DataValue.push(bValue);

          }
          else {
            //oDataCntext.DataValue.push(Number(iValue));
            if (!this.__oUtilityService.IsNullOrUndefined(iValue))
              oDataCntext.DataValue.push(Number(iValue));
            else {
              let oEmptyValue = null;
              oDataCntext.DataValue.push(oEmptyValue);
            }
          }

        }
        else {
          let oColumnValue: string = oColumn.DataValue;

          if (oSDD.DataType == 'Check Box') {
            if (oColumnValue != null && oColumnValue != '') {
              let sValue: string = oColumn.DataValue;
              let bValue: boolean = false;

              if (sValue.toLowerCase() == 'true' || sValue == '1') {
                bValue = true;
              }

              oDataCntext.DataValue.push(bValue);
            }
            else {
              let bValue: boolean = false;
              oDataCntext.DataValue.push(bValue);
            }
          }
          else {
            if (oColumnValue != null && oColumnValue != '') {
              oColumnValue = oColumnValue.toString().replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            }
            if (oColumnValue != null && oColumnValue != '') {
              oColumnValue = this.__oUtilityService.ReplaceNewLineTabCharacters(oColumnValue.toString()); //fb 37019 Rajendra tab key
              oDataCntext.DataValue.push(oColumnValue);
            }
            else {
              let oEmptyValue = '';
              oDataCntext.DataValue.push(oEmptyValue);
            }
          }
        }

        // Adding Itemsource
        if (oSDD.ItemSource != null && oSDD.ItemSource != '') {
          let oIS = JSON.parse(oSDD.ItemSource);
          oDataCntext.ItemSource.push(oIS);
        }
        else {

          let oItemSource = [];
          oDataCntext.ItemSource.push(oItemSource);
        }

        //Adding multiselected items
        if (oSDD.DataType == 'Multi Select Combo Box') {
          let oMultiSelectedKeys = [];

          if (oColumn.DataValue != null && oColumn.DataValue != undefined && oColumn.DataValue != '') {
            oMultiSelectedKeys = oColumn.DataValue.split(",");
          }

          oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);
        }
        else {
          let oMultiSelectedKeys = [];
          oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);
        }

        //Adding opened boolean value

        oDataCntext.Opened.push(false);

        // Adding number format , min , max , Text size

        oDataCntext.NumberFormat.push(oSDD.FormatString);
        oDataCntext.MinNum.push(oSDD.Min);
        oDataCntext.MaxNum.push(oSDD.Max);
        oDataCntext.TextSize.push(oSDD.TextSize);


      }

      for (var oSDD of Data.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder)) {


        let oBusinessProcessStateGridData = Object.assign({}, oSDD);


        // Adding Datavalue
        let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.DataField);

        if (oColumn.ColumnType.includes('Boolean')) {
          let sValue: string = oColumn.DataValue;
          let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
          oBusinessProcessStateGridData.DataValue = bValue;

        }
        else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
          let iValue: number = oColumn.DataValue;

          if (oSDD.DataType == 'Check Box') {
            let bValue: boolean = false;

            if (Number(iValue) == 1) {
              bValue = true;
            }
            oBusinessProcessStateGridData.DataValue = bValue;
          }
          else {
            //oBusinessProcessStateGridData.DataValue = Number(iValue);
            if (!this.__oUtilityService.IsNullOrUndefined(iValue)) {
              oBusinessProcessStateGridData.DataValue = Number(iValue);
            }
            else {
              oBusinessProcessStateGridData.DataValue = null;
            }
          }

        }
        else {
          let oColumnValue: string = oColumn.DataValue;

          if (oSDD.DataType == 'Check Box') {
            if (oColumnValue != null && oColumnValue != '') {
              let sValue: string = oColumn.DataValue;
              let bValue: boolean = false;

              if (sValue.toLowerCase() == 'true' || sValue == '1') {
                bValue = true;
              }

              oBusinessProcessStateGridData.DataValue = bValue;
            }
            else {
              let bValue: boolean = false;
              oBusinessProcessStateGridData.DataValue = bValue;
            }
          }
          else {

            //if (oSDD.DataType == 'Date Picker') {
            //  if (oColumnValue != null && oColumnValue != '') {
            //    let dt = new Date(oColumnValue);
            //    oBusinessProcessStateGridData.DataValue = dt;
            //  }
            //}
            //else {
            if (oColumnValue != null && oColumnValue != '') {
              oColumnValue = this.__oUtilityService.ReplaceNewLineTabCharacters(oColumnValue.toString());//fb 37019 Rajendra tab key
              oColumnValue = oColumnValue.toString().replace(/&lt;/g, '<').replace(/&gt;/g, '>');
              oBusinessProcessStateGridData.DataValue = oColumnValue;
            }
            else {
              let oEmptyValue = '';
              oBusinessProcessStateGridData.DataValue = oEmptyValue;
            }
            //}


          }
        }

        // Adding Itemsource
        if (oSDD.ItemSource != null && oSDD.ItemSource != '') {
          let oIS = JSON.parse(oSDD.ItemSource);
          oBusinessProcessStateGridData.ItemSource = oIS;
        }
        else {

          let oItemSource = [];
          oBusinessProcessStateGridData.ItemSource = oItemSource;
        }

        //Adding multiselected items


        if (oSDD.DataType == 'Multi Select Combo Box') {
          let oMultiSelectedKeys = [];

          if (oColumn.DataValue != null && oColumn.DataValue != undefined && oColumn.DataValue != '') {
            oMultiSelectedKeys = oColumn.DataValue.split(",");
          }

          oBusinessProcessStateGridData.MultiSelectedItems = oMultiSelectedKeys;
        }
        else {
          let oMultiSelectedKeys = [];
          oBusinessProcessStateGridData.MultiSelectedItems = oMultiSelectedKeys;
        }

        //let oMultiSelectedKeys = [];
        //oBusinessProcessStateGridData.MultiSelectedItems = oMultiSelectedKeys;

        //Adding opened boolean value

        oBusinessProcessStateGridData.Opened = false;

        // Adding number format , min , max , Text size

        oBusinessProcessStateGridData.FormatString = oSDD.FormatString;
        oBusinessProcessStateGridData.Min = oSDD.Min;
        oBusinessProcessStateGridData.Max = oSDD.Max;
        oBusinessProcessStateGridData.TextSize = oSDD.TextSize;

        oDataCntext.BusinessProcessStateGridData.push(oBusinessProcessStateGridData);
      }

      oBusinessProcessInstanceCurrentStateData.ItemSource.push(oDataCntext);

    }
  }
  //#endregion
  ExecuteStateDataGridAction(action, event, item, columnIndex, rowIndex, rowNumber, lBusinessProcessInstanceCurrentStateDataId): void {
    if (action == 'Remove') {
      this.RemoveGenericStateDataGridRow(columnIndex, rowIndex, rowNumber, lBusinessProcessInstanceCurrentStateDataId);
    }
    else if (action == 'View') {
      this.DataGridViewPopupToggle(lBusinessProcessInstanceCurrentStateDataId, rowIndex);
    }
    else {
      this.ExecuteStateDataGridUserAction(rowNumber, item, event)
    }
  }
  ExecuteStateDataGridUserAction(e: any, item: any, event: any) {
    this.__sXMLProcessStateData = null;
    this.__bIsLoadingVisible = true;
    this.__oBusinessProcessStateDataGridActionExecuteWebUrls = [];
    let lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    if (event.itemData) {
      this.lwfBusinessProcessStateDataGridActionId = event.itemData.id;
    }
    else {
      this.lwfBusinessProcessStateDataGridActionId = item.wfBusinessProcessStateDataGridActions[0].lwfBusinessProcessStateDataGridActionId;
    }

    let sXMLData: string = '';
    let oBusinessProcessStateDataGridContext: BusinessProcessStateGridDataContext = item.ItemSource.find(x => x.RowNumber == e);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 1;
    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == item.lwfBusinessProcessStateDataId);

    // Creating column array with value
    let businessProcessStateGridData: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder);


    for (let oColumnDetail of businessProcessStateGridData) {
      let oColumnName = oColumnDetail.DataField;
      let oDataValue = oBusinessProcessStateDataGridContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateDataGridContext.QueryResult;
      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateDataGridContext.DataValue[iIndex] != null && oBusinessProcessStateDataGridContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateDataGridContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateDataGridContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }


    for (let oOtherRowData of oBusinessProcessStateDataGridContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string state row data in XML format

    for (let oStateRowData of oRowData) {
      sXMLData += "<" + oStateRowData.ColumnName + ">";

      if (oStateRowData.DataValue != null && oStateRowData.DataValue != undefined && oStateRowData.DataValue != '') {
        let sValue: string = oStateRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStateRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString();
        }
      }
      else {

        sXMLData += oStateRowData.DataValue;
      }


      sXMLData += "</" + oStateRowData.ColumnName + ">";
    }

    if (oBusinessProcessStateDataGridContext.RowStatus == undefined || oBusinessProcessStateDataGridContext.RowStatus == null || oBusinessProcessStateDataGridContext.RowStatus == '')
      sXMLData += '<RowStatus>Updated</RowStatus>';
    else
      sXMLData += '<RowStatus>' + oBusinessProcessStateDataGridContext.RowStatus + '</RowStatus>';

    let oBusinessProcessStateDataGridUserAction = new BusinessProcessStateDataGridUserAction();
    oBusinessProcessStateDataGridUserAction.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStateDataGridUserAction.lwfBusinessProcessStateDataGridActionId = this.lwfBusinessProcessStateDataGridActionId;
    oBusinessProcessStateDataGridUserAction.sXMLProcessStateDataGrid = sXMLData;
    this.__sXMLProcessStateData = sXMLData;

    let bServerCallRequired: boolean = false;
    let stateDataGridAction: wfBusinessProcessStateDataGridAction = oBPICSD.wfBusinessProcessStateDataGridActions.find(x => x.lwfBusinessProcessStateDataGridActionId == this.lwfBusinessProcessStateDataGridActionId);

    for (let owfBusinessProcessStateDataGridActionExecute of stateDataGridAction.wfBusinessProcessStateDataGridActionExecute) {
      if (owfBusinessProcessStateDataGridActionExecute.OpenFormWebUrl != null && owfBusinessProcessStateDataGridActionExecute.OpenFormWebUrl != '') {
        let sWebUrl: string = '';
        sWebUrl = owfBusinessProcessStateDataGridActionExecute.OpenFormWebUrl;

        let i: number = 0;

        while (i == 0) {
          let iLastIndexOpenBrace: number = 0;
          let iLastIndexCloseBrace: number = 0;

          iLastIndexOpenBrace = sWebUrl.lastIndexOf("[");
          iLastIndexCloseBrace = sWebUrl.lastIndexOf("]");

          if (iLastIndexOpenBrace > 0 && iLastIndexCloseBrace > 0) {
            if (iLastIndexOpenBrace < iLastIndexCloseBrace) {
              let sReplaceString: string = sWebUrl.substring(iLastIndexOpenBrace, iLastIndexCloseBrace + 1);

              let oReplaceDataValue = oRowData.find(x => x.ColumnName == sReplaceString.replace("[", "").replace("]", ""));

              if (oReplaceDataValue != undefined) {
                if (sWebUrl.startsWith("mailto:")) {
                  sWebUrl = sWebUrl.replace(sReplaceString, oReplaceDataValue.DataValue);
                }
                else {
                  oReplaceDataValue.DataValue = oReplaceDataValue.DataValue.toString().replace(/\[\]/g, "~SqBrac~");
                  sWebUrl = sWebUrl.replace(sReplaceString, this.URLEncode(oReplaceDataValue.DataValue));
                }
              }
            }
          }
          else {
            i = 1;
          }
        }
        sWebUrl = sWebUrl.replace(/~SqBrac~/g, "[]").replace(/\+/g, '%2B');
        this.__oBusinessProcessStateDataGridActionExecuteWebUrls.push(sWebUrl);



      }
      else {
        bServerCallRequired = true;
      }

    }

    if (bServerCallRequired) {

      this.service.UpdateAllDataByPromise(oBusinessProcessStateDataGridUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostStateDataGridUserAction").then(
        result => this.OnSuccessSaveStateDataGridUserAction(result, oRowData)
      ).catch(error => this.OnErrorStateDataGridUserAction(error))
    }
    else {
      this.__bIsLoadingVisible = false;
      for (let oWebUrl of this.__oBusinessProcessStateDataGridActionExecuteWebUrls) {
        window.open(oWebUrl, "_blank");
      }
    }

  }

  private OnErrorStateDataGridUserAction(error: any) {
    this.__bIsLoadingVisible = false;
    if (error != null) {
      this.__oConfirmationComponent.show(ConfirmationType.Error,
        error,
        "Error", "Ok", "Cancel", false);
    }
  }
  private OnSuccessSaveStateDataGridUserAction(response: any, oRowData: any) {

    if (response != null) {

      let oResponse: string = response;

      if (oResponse == 'Success') {

        for (let oWebUrl of this.__oBusinessProcessStateDataGridActionExecuteWebUrls) {
          window.open(oWebUrl, "_blank");
        }

        let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas[0];
        this.GetBusinessProcessInstanceCurrentStateData(oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessInstanceId);

      }
      else if (oResponse.indexOf("lDocumentTemplateId") >= 0) {
        //getAll categories
        this.__oDocumentCategories = [];
        this.__bUploadSharepointFileManagerReady = false;
        this.__sFileSystem = "";
        this.__sDirectory = "";
        this.service.getDataByPromise(this.__sGetApiUrl + "api/DocumentManagement/GetAllDocumentCategories/").then((Data) => {

          if (Data != null) {
            this.__oDocumentCategories = Data;
          }

        });

        this.hideTemplateDropDown = false;

        this.isDocumentGenerateFroStateAction = false;

        //let documentTemplateViews: DocumentTemplateView[] = [];

        let results: any = JSON.parse(response);

        if (results != undefined) {
          if (results[0]["Parameters"] != undefined || results[0]["Parameters"] != null) {
            this.documentTemplateFunctionParameter = results[0]["Parameters"];
            let columnName = this.documentTemplateFunctionParameter["Id"].replace(/[[\]']+/g, '').replace(/\s+$/, "");
            for (let rowData of oRowData) {
              if (rowData.ColumnName == columnName) {
                this.documentTemplateFunctionParameter["Id"] = rowData.DataValue;
              }
            }



          }
          if (results[1]["Table"].length > 0) {
            //documentTemplateViews = results[1]["Table"];
            this.__oDocumentTemplateDetails = results[1]["Table"];
          }
          this.__oDocumentCategories = [];
          this.service.getDataByPromise(this.__sGetApiUrl + "api/DocumentManagement/GetAllDocumentCategories/").then((Data) => {

            if (Data != null) {
              this.__oDocumentCategories = Data;
            }

          });
          if (this.documentTemplateFunctionParameter["Directory"]) {
            this.__sDirectory = this.documentTemplateFunctionParameter["Directory"];
          }
          if (this.documentTemplateFunctionParameter["FileSystem"]) {
            this.__sFileSystem = this.documentTemplateFunctionParameter["FileSystem"];
            this.__bUploadSharepointFileManagerReady = true;
          }
          this.__bIsDataGridDocumentGeneratePopup = true;
        }


        this.FillDocumentTemplateWithDetail(this.__oDocumentTemplateDetails);
      }
      else {
        this.__oConfirmationComponent.show(ConfirmationType.Error,
          oResponse,
          "Error", "Ok", "Cancel", false);
      }

      this.__bIsLoadingVisible = false;

    }

  }

  FillDocumentTemplateWithDetail(documentTemplateViews: DocumentTemplateView[]) {
    for (let documentTemplate of documentTemplateViews) {

      let oDocumentTemplate: DocumentTemplate = new DocumentTemplate();
      oDocumentTemplate.lDocumentTemplateId = documentTemplate.lDocumentTemplateId;
      oDocumentTemplate.Name = documentTemplate.Name;
      oDocumentTemplate.Content = documentTemplate.Content;
      oDocumentTemplate.DocumentNamePrefix = documentTemplate.DocumentNamePrefix;
      oDocumentTemplate.DocumentNamePostfix = documentTemplate.DocumentNamePostfix;
      oDocumentTemplate.DocumentTag = documentTemplate.DocumentTag;

      let childs: DocumentTemplateView[] = documentTemplateViews.filter(x => x.lDocumentTemplateId == oDocumentTemplate.lDocumentTemplateId);
      oDocumentTemplate.DocumentTemplateDetail = [];

      for (let child of childs) {

        let oDocumentTemplateDetail: DocumentTemplateDetail = new DocumentTemplateDetail();
        oDocumentTemplateDetail.lDocumentTemplateDetailId = child.lDocumentTemplateDetailId;
        oDocumentTemplateDetail.lDocumentTemplateId = child.lDocumentTemplateId;
        oDocumentTemplateDetail.MappingColumnName = child.MappingColumnName;
        oDocumentTemplateDetail.PlaceHolderName = child.PlaceHolderName;

        if (!oDocumentTemplate.DocumentTemplateDetail.find(x => x.lDocumentTemplateDetailId === oDocumentTemplateDetail.lDocumentTemplateDetailId)) {
          oDocumentTemplate.DocumentTemplateDetail.push(oDocumentTemplateDetail);
        }
      }

      const index = this.__oDocumentTemplates.findIndex(x => x.lDocumentTemplateId === oDocumentTemplate.lDocumentTemplateId);

      if (index !== -1) {
        this.__oDocumentTemplates[index] = oDocumentTemplate;
      } else {
        this.__oDocumentTemplates.push(oDocumentTemplate);
      }
    }
    this.__oDocumentTemplates.sort(function(template1, template2) {
      if(template1.Name.toLowerCase() < template2.Name.toLowerCase()) { return -1; }
      if(template1.Name.toLowerCase() > template2.Name.toLowerCase()) { return 1; }
      return 0;
    });
    this.__oTemplatesByCategory = this.__oDocumentTemplates;
    this.documentTemplatesInstance?.instance?.option('dataSource', this.__oTemplatesByCategory);
  }

  //#region State data control data change event
  TextAreaOnChange(lwfBusinessProcessInstanceId: any, DataCaption: any, event?: any, name?: any) {
    if(name) {
      name.DataValue = event.value;
    }
    let sJSONCurrentInstanceData: string = "";
    this.__bStateDataValueChanged = true;
    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null || x.MultiSelectedItems != null)) {

      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      if (oCurrentInstance.DataType != 'Multi Select Combo Box'
        && oCurrentInstance.DataType != 'Date Picker'
        && oCurrentInstance.DataType != 'Rich Text Box'
        && oCurrentInstance.DataType != 'File Chooser'
        && oCurrentInstance.DataType != 'Grid'
        && oCurrentInstance.DataType != 'Data Grid'
        && oCurrentInstance.DataType != 'Qualitative Grid'
        && oCurrentInstance.DataType != 'Quantitative Grid'
        && oCurrentInstance.DataType != 'Score Analysis'
        && oCurrentInstance.DataType != 'Final Score Analysis'
        && oCurrentInstance.DataType != 'Check Box'
        && oCurrentInstance.DataType != 'Numeric/Money'
        && oCurrentInstance.DataType != "Counterparty Tree View"
        && oCurrentInstance.DataValue != null) {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Multi Select Combo Box') {

        if (!this.__oUtilityService.IsNullOrUndefined(oCurrentInstance.MultiSelectedItems) && oCurrentInstance.MultiSelectedItems?.length > 0) {

          let sMSValue: string = this.__oUtilityService.ParseStringArrayToCSVString(oCurrentInstance.MultiSelectedItems);
          sMSValue = sMSValue.replace(/\\/g, "").replace(/\"/g, "bckwrdslsh102");
          //sMSValue = sMSValue.replace(/'/g, "''");
          //sMSValue = "'" + sMSValue.replace(/,/g, "','") + "'";

          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
        }
      }
      else if (oCurrentInstance.DataType == 'Date Picker') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
        }
      }
      // else if (oCurrentInstance.DataType == 'File Chooser' && oCurrentInstance.DataValue != null) {
      //   if (sJSONCurrentInstanceData == "") {
      //     sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101') + "\"}";
      //   }
      //   else {
      //     sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101') + "\"}";
      //   }
      // }
      else if (oCurrentInstance.DataType == 'Check Box' || oCurrentInstance.DataType == 'Numeric/Money') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
      }
      //else if (oCurrentInstance.DataType == 'Grid') {
      //  let gridItems = this.__oBusinessProcessStateGridDataContext;
      //  let xmlString = '';
      //  for (var i = 0; i < gridItems.length; i++) {
      //    let jObject = new BusinessProcessStateGridDataQueryResult();
      //    jObject.RowNumber = gridItems[i].RowNumber;
      //    gridItems[i].QueryResult.forEach(function (val, idx) {
      //      let value = (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null ?
      //        ((gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')) : gridItems[i].DataValue[(idx + 1)])
      //      val.DataValue = value;
      //    });

      //    jObject.QueryResult = gridItems[i].QueryResult;

      //    let JsonObject: any = {};
      //    JsonObject.Row = jObject;
      //    xmlString += this.json2xml(JsonObject, null);
      //  }

      //  xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

      //  if (sJSONCurrentInstanceData == "") {
      //    sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
      //  }
      //  else {
      //    sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
      //  }
      //}

    }


    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null && x.DataType != 'Multi Select Combo Box' && x.DataType != 'Qualitative Grid' && x.DataType != 'Quantitative Grid' && x.DataType != 'Score Analysis' && x.DataType != 'Final Score Analysis')) {
      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      if (oCurrentInstance.DataCaption != null) {

        if (oCurrentInstance.DataType == 'Check Box') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
        }
        else {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
        }
      }
    }

    sJSONCurrentInstanceData = "[" + sJSONCurrentInstanceData + "]";

    sJSONCurrentInstanceData = this.__oUtilityService.EncodeNewLineTabCharacters(sJSONCurrentInstanceData); //fb 37019 Rajendra tab key


    sJSONCurrentInstanceData = this.replaceAll(sJSONCurrentInstanceData);

    let oBusinessProcessParam = new BusinessProcessParam();
    oBusinessProcessParam.lwfBusinessProcessInstanceId = lwfBusinessProcessInstanceId;
    oBusinessProcessParam.sCurrentInstanceData = sJSONCurrentInstanceData;
    oBusinessProcessParam.sDataCaption = DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

    this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/DependedStateDataItemSource").then(
      result => this.OnSuccessDependedStateDataItemSource(result, lwfBusinessProcessInstanceId)
    ).
      catch(error => this.OnErrorDependedStateDataItemSource(error))


    //this.__oCustomPropertyComponent.PopulateCustomProperty(6);

    //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDependedStateDataItemSource/" + lwfBusinessProcessInstanceId + "/" + sJSONCurrentInstanceData + "/" + DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101')).then((Data) => {

    //  if (Data != null) {

    //    for (let oCurrentInstanceWithItemSource of Data) {
    //      let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

    //      if (oBusinessProcessInstanceCurrentStateData != null) {
    //        if (oBusinessProcessInstanceCurrentStateData.DataType == 'Dropdown' || oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box' || oBusinessProcessInstanceCurrentStateData.DataType == 'Search Box') {

    //          try {
    //            oBusinessProcessInstanceCurrentStateData.ItemSource = JSON.parse(oCurrentInstanceWithItemSource.ItemSource);
    //          }
    //          catch{
    //            console.log(oCurrentInstanceWithItemSource.ItemSource);
    //          }

    //          oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
    //        }
    //        else {
    //          oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
    //          oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
    //          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Grid') {
    //            this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDataGridColumns/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId).subscribe((Data) => {
    //              if (Data != null) {
    //                this.createDataContextForStateGrid(oBusinessProcessInstanceCurrentStateData, Data);
    //              }
    //            });
    //          }
    //        }
    //      }

    //    }
    //  }

    //});

    let oBusinessProcessParam1 = new BusinessProcessParam();
    oBusinessProcessParam1.lwfBusinessProcessInstanceId = lwfBusinessProcessInstanceId;
    oBusinessProcessParam1.sCurrentInstanceData = sJSONCurrentInstanceData;


    this.service.UpdateAllDataByPromise(oBusinessProcessParam1, this.__sGetApiUrl + "api/WorkflowDashBoard/StateDataConditionResult").then(
      result => this.OnSuccessStateDataConditionResult(result)
    ).
      catch(error => this.OnErrorStateDataConditionResult(error))


    this.RefreshPowerBIReport(sJSONCurrentInstanceData, DataCaption);


    //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStateDataConditionResult/" + lwfBusinessProcessInstanceId + "/" + sJSONCurrentInstanceData).then((Data) => {

    //  if (Data != null) {

    //    for (let oCurrentInstanceWithItemSource of Data) {
    //      let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

    //      if (oBusinessProcessInstanceCurrentStateData != null) {

    //        oBusinessProcessInstanceCurrentStateData.IsEnabled = oCurrentInstanceWithItemSource.IsEnabled;
    //        oBusinessProcessInstanceCurrentStateData.IsVisible = oCurrentInstanceWithItemSource.IsVisible;
    //      }

    //    }
    //  }

    //});


  }

  TextAreaOnChangeACB(lwfBusinessProcessInstanceId: any, DataCaption: any, Item: any, event: any) {

    if (event.selectedItem) {
      Item.DataValue = event.selectedItem.DisplayMember;
    }
    else {
      this.TextAreaOnChange(lwfBusinessProcessInstanceId, DataCaption);
    }

    if (Item.DataValue != '' && Item.DataValue != null && Item.DataValue != undefined) {
      let oItemSource: ItemSource[] = Item.ItemSource;

      if (oItemSource != null && oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == Item.DataValue) != null) {
          this.TextAreaOnChange(lwfBusinessProcessInstanceId, DataCaption);
        }
      }
    }

  }

  private OnErrorDependedStateDataItemSource(error: any) {
    console.log(error);
  }
  private OnSuccessDependedStateDataItemSource(response: any, lwfBusinessProcessInstanceId: any) {

    if (response != null) {

      for (let oCurrentInstanceWithItemSource of response) {
        let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

        if (oBusinessProcessInstanceCurrentStateData != null) {
          if (oBusinessProcessInstanceCurrentStateData.DataType == 'Dropdown' || oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box' || oBusinessProcessInstanceCurrentStateData.DataType == 'Search Box') {

            try {
              oBusinessProcessInstanceCurrentStateData.ItemSource = JSON.parse(oCurrentInstanceWithItemSource.ItemSource);
              oBusinessProcessInstanceCurrentStateData.ItemSource.forEach(x => {
                if (x.DisplayMember) {
                  x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString().replace(/bckwrdslsh101/gi, "\\"));
                }
              })
            }
            catch {
              console.log(oCurrentInstanceWithItemSource.ItemSource);
            }

            if (oBusinessProcessInstanceCurrentStateData.DataType == 'Multi Select Combo Box') {
              let sDataValue = "";
              const regex = /(?!\B'[^']*),(?![^']*'\B)/g;
              let items = (oCurrentInstanceWithItemSource.DataValue == null) ? "" : oCurrentInstanceWithItemSource.DataValue.split(regex);
              let allSingleQuoted = (items == "") ? false : items.every(item => /^'.+'$/.test(item.trim()));
              if (allSingleQuoted) {
                sDataValue = oCurrentInstanceWithItemSource.DataValue
              }
              else {
                let containsSingleQuote = (items == "") ? false : items.some(item => item.includes("'"));

                if (containsSingleQuote) {
                  sDataValue = items.map(item => {
                    let unquotedItem = item.replace(/^'(.+)'$/, '$1');
                    return `'${unquotedItem.trim()}'`;
                  }).join(', ');
                }
                else {
                  sDataValue = oCurrentInstanceWithItemSource.DataValue
                }
              }

              if (sDataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
                oBusinessProcessInstanceCurrentStateData.DataValue = sDataValue;
                if (this.__oUtilityService.IsNullOrEmpty(sDataValue)) {
                  oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = [];
                } else {
                  oBusinessProcessInstanceCurrentStateData.MultiSelectedItems = this.__oUtilityService.ParseCSVStringToStringArray(sDataValue);
                }

              }
            }
            else if (oCurrentInstanceWithItemSource.DataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
              oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
            }
          }
          else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Grid') {
            if (oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
              oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
            }
            this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDataGridColumns/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId).subscribe((Data) => {
              if (Data != null) {
                this.createDataContextForStateGrid(oBusinessProcessInstanceCurrentStateData, Data);
              }
            });
          }

          else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Data Grid') {
            if (oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
              oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
            }
            if (oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData == undefined || oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData == null || oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData.length == 0) {

              this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDataGridColumns/" + oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId).subscribe((Data) => {
                if (Data != null) {

                  let BusinessProcessStateGridData: BusinessProcessStateGridData[] = Data;

                  oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData = [];

                  for (let oStateGridData of BusinessProcessStateGridData) {
                    oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData.push(oStateGridData);
                  }

                  this.createDataContextForGenericStateDataGrid(oBusinessProcessInstanceCurrentStateData, BusinessProcessStateGridData);
                }
              });


            }
            else {
              this.createDataContextForGenericStateDataGrid(oBusinessProcessInstanceCurrentStateData, oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData);
            }

          }
          else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Counterparty Tree View') {

            if (oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
              let result = "";
              if (oCurrentInstanceWithItemSource.DataValue != "") {
                try {
                  let obj = JSON.parse(oCurrentInstanceWithItemSource.DataValue);
                  for (const element of obj.TradingCounterpartyLegalHierarchyOwnership) {
                    this.normalize(element, obj.lTradingCounterpartyId);
                  }
                  result = obj.TradingCounterpartyLegalHierarchyOwnership;
                } catch (e) {
                  result = e;
                  console.log(e);
                }

              }
              else {
                result = "No Data to Display"
              }
              oBusinessProcessInstanceCurrentStateData.DataValue = result;
            }
          }
          else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Check Box') {
            oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
            if (oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
              oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue == 'true';
            }
          }
          else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Numeric/Money') {
            oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
            if (oCurrentInstanceWithItemSource.DataValue != null && oCurrentInstanceWithItemSource.DataValue != "") {
              oBusinessProcessInstanceCurrentStateData.DataValue = +oCurrentInstanceWithItemSource.DataValue;
            } else {
              oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
            }
          }
          else if (oBusinessProcessInstanceCurrentStateData.DataType == 'Content Frame') {  
            if (oCurrentInstanceWithItemSource.DataValue != oBusinessProcessInstanceCurrentStateData.DataValue) {
              oBusinessProcessInstanceCurrentStateData.SafeUrl = null;
               oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
               oBusinessProcessInstanceCurrentStateData.SafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(oCurrentInstanceWithItemSource.DataValue);
            }
          }
          else if (oBusinessProcessInstanceCurrentStateData.DataType == "File Manager") {
            oBusinessProcessInstanceCurrentStateData.DataValue = oCurrentInstanceWithItemSource.DataValue;
            oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
            this.__bShowFileManager = true;
          }   
          else {
            oBusinessProcessInstanceCurrentStateData.ItemSource = oCurrentInstanceWithItemSource.ItemSource;
            if (oCurrentInstanceWithItemSource.DataValue != null && this.replaceAllSpecialCharacters(oCurrentInstanceWithItemSource.DataValue) != oBusinessProcessInstanceCurrentStateData.DataValue) {
              oBusinessProcessInstanceCurrentStateData.DataValue = this.replaceAllSpecialCharacters(oCurrentInstanceWithItemSource.DataValue);            
            }
            else if (oCurrentInstanceWithItemSource.DataValue == null){
              oBusinessProcessInstanceCurrentStateData.DataValue = '';
            }
          }
        }
      }

    }

    this.GetStateDataConditionResult(lwfBusinessProcessInstanceId);
  }

  GetStateDataConditionResult(lwfBusinessProcessInstanceId: any) {
    let sJSONCurrentInstanceData: string = "";

    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null || x.MultiSelectedItems != null)) {

      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      if (oCurrentInstance.DataType != 'Multi Select Combo Box' && oCurrentInstance.DataType != 'Date Picker' && oCurrentInstance.DataType != 'Rich Text Box'
        && oCurrentInstance.DataType != 'File Chooser' && oCurrentInstance.DataType != 'Grid' && oCurrentInstance.DataType != 'Data Grid' && oCurrentInstance.DataType != 'Qualitative Grid' && oCurrentInstance.DataType != 'Quantitative Grid' && oCurrentInstance.DataType != 'Score Analysis' && oCurrentInstance.DataType != 'Final Score Analysis' && oCurrentInstance.DataType != 'Check Box' && oCurrentInstance.DataType != 'Numeric/Money' && oCurrentInstance.DataType != 'Counterparty Tree View' && oCurrentInstance.DataValue != null) {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Multi Select Combo Box') {

        if (!this.__oUtilityService.IsNullOrUndefined(oCurrentInstance.MultiSelectedItems) && oCurrentInstance.MultiSelectedItems && oCurrentInstance.MultiSelectedItems.length > 0) {


          let sMSValue: string = this.__oUtilityService.ParseStringArrayToCSVString(oCurrentInstance.MultiSelectedItems);

          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue + "\"}";
          }
        }

      }
      else if (oCurrentInstance.DataType == 'Date Picker') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
        }
      }
      // else if (oCurrentInstance.DataType == 'File Chooser' && oCurrentInstance.DataValue != null) {
      //   if (sJSONCurrentInstanceData == "") {
      //     sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101') + "\"}";
      //   }
      //   else {
      //     sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101') + "\"}";
      //   }
      // }
      else if (oCurrentInstance.DataType == 'Check Box' || oCurrentInstance.DataType == 'Numeric/Money') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
      }


    }


    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null && x.DataType != 'Multi Select Combo Box' && x.DataType != 'Qualitative Grid' && x.DataType != 'Quantitative Grid' && x.DataType != 'Score Analysis' && x.DataType != 'Final Score Analysis')) {
      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      if (oCurrentInstance.DataCaption != null) {

        if (oCurrentInstance.DataType == 'Check Box') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
        }
        else {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
        }
      }
    }

    sJSONCurrentInstanceData = "[" + sJSONCurrentInstanceData + "]";

    sJSONCurrentInstanceData = this.__oUtilityService.EncodeNewLineTabCharacters(sJSONCurrentInstanceData);//fb 37019 Rajendra tab key


    sJSONCurrentInstanceData = this.replaceAll(sJSONCurrentInstanceData);


    let oBusinessProcessParam = new BusinessProcessParam();
    oBusinessProcessParam.lwfBusinessProcessInstanceId = lwfBusinessProcessInstanceId;
    oBusinessProcessParam.sCurrentInstanceData = sJSONCurrentInstanceData;


    this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/StateDataConditionResult").then(
      result => this.OnSuccessStateDataConditionResult(result)
    ).
      catch(error => this.OnErrorStateDataConditionResult(error))


    //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStateDataConditionResult/" + lwfBusinessProcessInstanceId + "/" + sJSONCurrentInstanceData).then((Data) => {

    //  if (Data != null) {

    //    for (let oCurrentInstanceWithItemSource of Data) {
    //      let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

    //      if (oBusinessProcessInstanceCurrentStateData != null) {

    //        oBusinessProcessInstanceCurrentStateData.IsEnabled = oCurrentInstanceWithItemSource.IsEnabled;
    //        oBusinessProcessInstanceCurrentStateData.IsVisible = oCurrentInstanceWithItemSource.IsVisible;
    //      }

    //    }
    //  }

    //});

  }

  private OnErrorStateDataConditionResult(error: any) {
    console.log(error);
  }
  private OnSuccessStateDataConditionResult(response: any) {

    if (response != null) {

      for (let oCurrentInstanceWithItemSource of response) {
        let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

        if (oBusinessProcessInstanceCurrentStateData != null) {

          oBusinessProcessInstanceCurrentStateData.IsEnabled = oCurrentInstanceWithItemSource.IsEnabled;

          if (oBusinessProcessInstanceCurrentStateData.IsStateDataVisible == 1) {
            oBusinessProcessInstanceCurrentStateData.IsVisible = oCurrentInstanceWithItemSource.IsVisible;
            //oBusinessProcessInstanceCurrentStateData.IsStateDataVisible = oCurrentInstanceWithItemSource.IsVisible;
          }
        }

      }
    }

  }




  GetDataForACB(lwfBusinessProcessInstanceId: any, lwfBusinessProcessStateDataId: any, Item: any) {
    let sJSONCurrentInstanceData: string = "";


    if (Item.DataValue != '' && Item.DataValue != null && Item.DataValue != undefined) {
      let oItemSource: ItemSource[] = Item.ItemSource;

      if (oItemSource != null && oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == Item.DataValue) != null) {
          return;
        }
      }

      for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null || x.MultiSelectedItems != null)) {

        let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

        if (oCurrentInstance.DataType != 'Multi Select Combo Box' && oCurrentInstance.DataType != 'Date Picker' && oCurrentInstance.DataType != 'Rich Text Box'
          && oCurrentInstance.DataType != 'File Chooser' && oCurrentInstance.DataType != 'Grid' && oCurrentInstance.DataType != 'Data Grid' && oCurrentInstance.DataType != 'Qualitative Grid' && oCurrentInstance.DataType != 'Quantitative Grid' && oCurrentInstance.DataType != 'Score Analysis' && oCurrentInstance.DataType != 'Final Score Analysis' && oCurrentInstance.DataType != 'Check Box' && oCurrentInstance.DataType != 'Numeric/Money'
          && oCurrentInstance.DataValue != null && oCurrentInstance.DataType != "Counterparty Tree View") {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/\\"/g, 'doouubleQuote').replace(/"/g, 'doouubleQuote').replace("\\", "forwardslaaash") : oCurrentInstance.DataValue) + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/\\"/g, 'doouubleQuote').replace(/"/g, 'doouubleQuote').replace("\\", "forwardslaaash") : oCurrentInstance.DataValue) + "\"}";
          }
        }
        else if (oCurrentInstance.DataType == 'Multi Select Combo Box') {

          if (oCurrentInstance.MultiSelectedItems.length > 0) {


            let sMSValue: string = this.__oUtilityService.ParseStringArrayToCSVString(oCurrentInstance.MultiSelectedItems);
            sMSValue = sMSValue.replace(/\\/g, "").replace(/\"/g, "bckwrdslsh102");
            //sMSValue = sMSValue.replace(/'/g, "''");
            //sMSValue = "'" + sMSValue.replace(/,/g, "','") + "'";



            if (sJSONCurrentInstanceData == "") {
              sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue + "\"}";
            }
            else {
              sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue + "\"}";
            }
          }

        }
        else if (oCurrentInstance.DataType == 'Date Picker') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
          }
        }
        else if (oCurrentInstance.DataType == 'File Chooser' && oCurrentInstance.DataValue != null) {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY)  + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY)  + "\"}";
          }
        }
        else if (oCurrentInstance.DataType == 'Check Box' || oCurrentInstance.DataType == 'Numeric/Money') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
          }
        }

      }


      for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null && x.DataType != 'Multi Select Combo Box' && x.DataType != 'Qualitative Grid' && x.DataType != 'Quantitative Grid' && x.DataType != 'Score Analysis' && x.DataType != 'Final Score Analysis')) {
        let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

        if (oCurrentInstance.DataCaption != null) {

          if (oCurrentInstance.DataType == 'Check Box') {
            if (sJSONCurrentInstanceData == "") {
              sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
            }
            else {
              sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
            }
          }
          else {
            if (sJSONCurrentInstanceData == "") {
              sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
            }
            else {
              sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
            }
          }
        }
      }

      //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null && x.DataType != 'Rich Text Box' && x.DataType != 'Grid' && x.DataType != 'File Chooser')) {

      //  let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      //  if (sJSONCurrentInstanceData == "") {
      //    sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
      //  }
      //  else {
      //    sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
      //  }

      //}

      sJSONCurrentInstanceData = "[" + sJSONCurrentInstanceData + "]";

      sJSONCurrentInstanceData = this.__oUtilityService.EncodeNewLineTabCharacters(sJSONCurrentInstanceData);  //fb 37019 Rajendra tab key

      sJSONCurrentInstanceData = this.replaceAll(sJSONCurrentInstanceData);


      let oBusinessProcessParam = new BusinessProcessParam();
      oBusinessProcessParam.lwfBusinessProcessInstanceId = lwfBusinessProcessInstanceId;
      oBusinessProcessParam.sCurrentInstanceData = sJSONCurrentInstanceData;
      oBusinessProcessParam.lwfBusinessProcessStateDataId = lwfBusinessProcessStateDataId;

      this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/ItemSourceForAutoCompleteBox").then(
        result => this.OnSuccessItemSourceForAutoCompleteBox(result)
      ).
        catch(error => this.OnErrorItemSourceForAutoCompleteBox(error))


      //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetItemSourceForAutoCompleteBox/" + lwfBusinessProcessInstanceId + "/" + lwfBusinessProcessStateDataId + "/" + sJSONCurrentInstanceData).then((Data) => {

      //  if (Data != null) {

      //    for (let oCurrentInstanceWithItemSource of Data) {
      //      let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

      //      if (oBusinessProcessInstanceCurrentStateData != null) {

      //        try {
      //          oBusinessProcessInstanceCurrentStateData.ItemSource = JSON.parse(oCurrentInstanceWithItemSource.ItemSource);
      //        }
      //        catch
      //        {
      //          console.log(oCurrentInstanceWithItemSource.ItemSource);
      //        }

      //        if (oBusinessProcessInstanceCurrentStateData.ItemSource != undefined && oBusinessProcessInstanceCurrentStateData.ItemSource.length > 0) { oBusinessProcessInstanceCurrentStateData.opened = true; }


      //      }

      //    }
      //  }

      //});
    }


  }


  private OnErrorItemSourceForAutoCompleteBox(error: any) {
    console.log(error);
  }
  private OnSuccessItemSourceForAutoCompleteBox(response: any) {

    if (response != null) {

      for (let oCurrentInstanceWithItemSource of response) {
        let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == oCurrentInstanceWithItemSource.lBusinessProcessInstanceCurrentStateDataId);

        if (oBusinessProcessInstanceCurrentStateData != null) {

          try {
            oCurrentInstanceWithItemSource.ItemSource = oCurrentInstanceWithItemSource.ItemSource.replace(/quoootes/g, '\\"'); //FB 28009 - Vidya
            oCurrentInstanceWithItemSource.ItemSource = this.replaceAllSpecialCharacters(oCurrentInstanceWithItemSource.ItemSource); //FB 27348 - Vidya
            oBusinessProcessInstanceCurrentStateData.ItemSource = JSON.parse(oCurrentInstanceWithItemSource.ItemSource);
          }
          catch
          {
            console.log(oCurrentInstanceWithItemSource.ItemSource);
          }

          if (oBusinessProcessInstanceCurrentStateData.ItemSource != undefined && oBusinessProcessInstanceCurrentStateData.ItemSource.length > 0) { oBusinessProcessInstanceCurrentStateData.opened = (oBusinessProcessInstanceCurrentStateData.DataType == "Search Box") ? false : true; }


        }

      }
    }

  }

  onKeyPressNumberBoxState(e: any, BusinessProcessInstanceCurrentStateData: any) {

    //e.component.focus();
    //alert(e.event.key);
    //alert(e.event.target.value.toString());
    //alert(BusinessProcessInstanceCurrentStateData.DataValue);
    //console.log('inside');
    //console.log(e.event.target.value.toString());
    //console.log(BusinessProcessInstanceCurrentStateData.DataValue);

    //if (BusinessProcessInstanceCurrentStateData.DataValue != null && BusinessProcessInstanceCurrentStateData.DataValue != undefined) {
    if (e.event.key == 'm' || e.event.key == "M") {
      BusinessProcessInstanceCurrentStateData.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
    }
    else if (e.event.key == "b" || e.event.key == "B") {
      BusinessProcessInstanceCurrentStateData.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
    }
    else if (e.event.key == "k" || e.event.key == "K") {
      BusinessProcessInstanceCurrentStateData.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
    }
    else if (e.event.key == "h" || e.event.key == "H") {
      BusinessProcessInstanceCurrentStateData.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
    }
    else if (e.event.key == "t" || e.event.key == "T") {
      BusinessProcessInstanceCurrentStateData.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
    }

    if ((e.event.key == 'Delete' || e.event.key == "Backspace") && !this.__oUtilityService.IsNullOrUndefined(e.event.target.value) && e.event.target.value.toString() == "0") {
      BusinessProcessInstanceCurrentStateData.DataValue = null;
    }
  }

  //#endregion

  //#region file events

  fileChange(event: any, lBusinessProcessInstanceCurrentStateDataId: any, DataCaption: any) {

    let fileList: FileList = event.target.files;
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == lBusinessProcessInstanceCurrentStateDataId);
    let oWorkflowDashBoardcomponent: any = this;

    if (fileList.length > 0) {

      //for (let fileIndex in fileList) {
      //if (fileIndex.toUpperCase() != 'LENGTH' && fileIndex.toUpperCase() != 'ITEM') {

      let file: File = fileList[0];

      if (file.name.includes(",")) {
        alert("File name with ',' is restricted.");
        return;
      }

      oBusinessProcessInstanceCurrentStateData.DataValue = file.name;

      var reader = new FileReader();

      reader.onloadend = function (e) {
        let oFileDetail: FileDetail = new FileDetail();
        oFileDetail.DataCaption = DataCaption;
        oFileDetail.lBusinessProcessInstanceCurrentStateDataId = lBusinessProcessInstanceCurrentStateDataId;
        oFileDetail.FileName = file.name;
        oFileDetail.FileContent = this.result;
        oWorkflowDashBoardcomponent.__oFileDetails.push(oFileDetail);
      }

      //reader.addEventListener("load", function () {
      //  that.__sFileContent = this.result;
      //}, false);

      if (file) {
        reader.readAsDataURL(file);
      }

      //}
      //}
    }

  }


  fileUpload(event: any, lBusinessProcessInstanceCurrentStateDataId: any, DataCaption: any) {

    let fileList: FileList = event.target.files;
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == lBusinessProcessInstanceCurrentStateDataId);
    let oWorkflowDashBoardcomponent: any = this;

    if (fileList.length > 0) {

      let formData: FormData = new FormData();

      for (let fileIndex in fileList) {
        if (fileIndex.toUpperCase() != 'LENGTH' && fileIndex.toUpperCase() != 'ITEM') {

          let file: File = fileList[fileIndex];

          if (file.name.includes(",")) {
            alert("File name with ',' is restricted.");
            return;
          }

          if (this.__oBusinessProcessConfig != null && this.__oBusinessProcessConfig.AllowedFileTypes != null) {

            let AllowedFileTypes: string[] = this.__oBusinessProcessConfig.AllowedFileTypes.toUpperCase().split(",");
            let sFileExtension: string = file.name.substring(file.name.lastIndexOf(".") + 1);

            if (AllowedFileTypes.indexOf(sFileExtension.toUpperCase(), 0) == -1) {
              alert("File type " + sFileExtension + " is restricted.");
              return;
            }
            else {
              formData.append('Files', file, file.name);
            }

          }
          else {
            alert("Restricted file types are not configured.");
            return;
          }
        }
      }

      let sFilePaths: string[] = [];

      formData.append('lBusinessProcessInstanceCurrentStateDataId', lBusinessProcessInstanceCurrentStateDataId.toString());
      let headers = new Headers()
      let options = new Object({ headers: headers, withCredentials: true });
      //FB 6060 SSO Integration
      //if (environment.SSOEnabled) {
      //  options = null;
      //  options = new Object({ headers: headers });
      //}
      let apiUrl1 = this.__sGetApiUrl + "api/WorkflowDashBoard/UploadFile";

      this.http.post(apiUrl1, formData, options)
        .pipe(map(res => JSON.parse(JSON.stringify(res)), catchError(error => throwError(error))))
        .subscribe(
          data =>{ 
            let result=this.__oUtilityService.DecryptStringAES(data, Constants.EXTERNALSOURCE_AESKEY);
            sFilePaths = result!=null && result!=''?result.split(','): [];
          },
          error => {
            let errorMessage: string = error?.error;
            if (errorMessage) {
            if(!errorMessage.includes('Please see the event logs for more information'))
            {
              errorMessage = errorMessage.replace(/\./, '<br/><br/>');
              errorMessage = errorMessage.replace(/,/g, '<br/>');
              errorMessage += "<br/></br>Please re-upload all other files.";
            }
              this.__oConfirmationComponent.show(ConfirmationType.Error, errorMessage, "File upload error", "Ok", "", false);
            }
          },
          () => {

            for (let fileIndex in sFilePaths) {
              if (oBusinessProcessInstanceCurrentStateData.DataValue == null || oBusinessProcessInstanceCurrentStateData.DataValue == '') {
                oBusinessProcessInstanceCurrentStateData.DataValue = sFilePaths[fileIndex];
              }
              else {
                oBusinessProcessInstanceCurrentStateData.DataValue = oBusinessProcessInstanceCurrentStateData.DataValue + "," + sFilePaths[fileIndex];
              }

            }


            oBusinessProcessInstanceCurrentStateData.FileDetail = [];

            let AllFiles: string[] = oBusinessProcessInstanceCurrentStateData.DataValue.split(",");

            for (let FileIndex in AllFiles) {
              let oFileDetail: FileDetail = null;
              oFileDetail = new FileDetail();

              oFileDetail.lBusinessProcessInstanceCurrentStateDataId = oBusinessProcessInstanceCurrentStateData.lBusinessProcessInstanceCurrentStateDataId;
              oFileDetail.FilePath = AllFiles[FileIndex];
              oFileDetail.FileName = AllFiles[FileIndex].split(/[/\\]/).pop();
              oBusinessProcessInstanceCurrentStateData.FileDetail.push(oFileDetail);

            }

          }
        )
    }

  }


   DownLoad(lBusinessProcessInstanceCurrentStateDataId: any,e: any) {
    let sRelativeFilePath = e.replace(this.__oBusinessProcessConfig?.FilePath,'');
    let filePath = this.__oUtilityService.ReplaceSpecialCharacters(this.__oUtilityService.EncryptStringAES(sRelativeFilePath, Constants.EXTERNALSOURCE_AESKEY));

    window.location.href = this.__sGetApiUrl + "api/WorkflowDashBoard/DownloadFile/"+ filePath;
  }

  DeleteFile(lBusinessProcessInstanceCurrentStateDataId: any, e: any) {

    let sRelativeFilePath = e.replace(this.__oBusinessProcessConfig?.FilePath,'');
    let filePath = this.__oUtilityService.ReplaceSpecialCharacters(this.__oUtilityService.EncryptStringAES(sRelativeFilePath, Constants.EXTERNALSOURCE_AESKEY));

    try {
      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDeleteFile/"+filePath).then((Data) => {

        if (Data != null) {
        }
      });
    }
    catch { }

    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == lBusinessProcessInstanceCurrentStateDataId);

    if(oBusinessProcessInstanceCurrentStateData.DataValue!=null && oBusinessProcessInstanceCurrentStateData.DataValue!='')
    {
      let oFileDetail: FileDetail = oBusinessProcessInstanceCurrentStateData.FileDetail.find(x => x.FilePath == e);
      oBusinessProcessInstanceCurrentStateData.FileDetail.splice(oBusinessProcessInstanceCurrentStateData.FileDetail.indexOf(oFileDetail), 1);

      oBusinessProcessInstanceCurrentStateData.FileDetail.forEach(element => {
        if(oBusinessProcessInstanceCurrentStateData.FileDetail.indexOf(element)==0)
        {
          oBusinessProcessInstanceCurrentStateData.DataValue= element.FilePath;
        }else
        {
          oBusinessProcessInstanceCurrentStateData.DataValue= oBusinessProcessInstanceCurrentStateData.DataValue+','+element.FilePath;
        }

      });

      if (oBusinessProcessInstanceCurrentStateData.DataValue.trim() == "" || oBusinessProcessInstanceCurrentStateData.FileDetail.length==0) {
        oBusinessProcessInstanceCurrentStateData.DataValue = null;
        oBusinessProcessInstanceCurrentStateData.FileDetail = [];
      }
    }
  }

  //#endregion
  OpenStateWorkflowInstancesForSelectedState() {
      this.service.getAuthenticate().subscribe(
        data => {
          this.__sUserName = data
          if (!this.service.VerifyGetAuthenticate(this.__sUserName, this.router)) {
            return;
          }
          let sWFName: string;

          if (this.__sWFNameInQueryString != null) {
            sWFName = this.__sWFNameInQueryString;
          }
          else {
            sWFName = this.__sURLBPDId.toString();
          }
          this.__bStateWorkflowVisible = true;
          this.__bStatelessWorkflowVisible = false;
          if (this.__sParam != null) {
            let hideParam: string = this.__sParam.substring(0, this.__sParam.indexOf(":"));
            let hideParamValue: string = this.__sParam.substring(this.__sParam.indexOf(":") + 1);
            if (hideParam != null && hideParamValue != null) {
              if (hideParam.toLowerCase() == "hidesidepanel") {
                if (hideParamValue.toLowerCase() == "true") {
                  this.hideSidePanel();
                } else {
                  this.showSidePanel();
                }
              }
            }
          }
          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetwfBusinessProcessDefinition/" + sWFName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
            if (Data != null) {
              this.__oWFBusinessProcessDefinition = Data;
              this.__oBusinessProcessDefinitionName = this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition;

              if (this.__oWFBusinessProcessDefinition.wfBusinessProcessModel == 'State') {
                this.__bStatelessWorkflowVisible = false;
                this.__bStateWorkflowVisible = true;

                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcesses").then((Data) => {

                  if (Data != null) {
                    this.__oBusinessProcessViewModels = Data;

                    if (this.__sURLBPI != null && this.__sURLBPI != undefined && this.__sURLBPI > 0)
                      this.GetBusinessProcessInstanceCurrentStateData(this.__sURLBPI);
                    else {
                      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetPermissionInfo/138/" + this.__oWFBusinessProcessDefinition.lProcessStartUpRuleId).then((Data) => {

                        if (Data != null) {

                          if (Data == 1) {
                            this.__bStartNewProcessButtonVisible = true;
                            this.__sStartNewProcessButtonText = this.__oWFBusinessProcessDefinition.wfBusinessProcessRuleAction;

                            if (this.__sStartNewProcessButtonText == null || this.__sStartNewProcessButtonText.trim() == '') {
                              this.__bStartNewProcessButtonVisible = false;
                            }

                          }
                          else {
                            this.__bStartNewProcessButtonVisible = false;
                          }
                        }
                        this.__bIsLoadingVisible = false;
                      });
                    }
                    for (let oBPVM of this.__oBusinessProcessViewModels) {
                      let oBP: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition);
                      if (oBP != null) {
                        let iIndex = this.__oBusinessProcessViewModels.indexOf(oBPVM);
                        this.__iBusinessProcessAccordionSelectedIndex = iIndex;
                        for (var oBPS of oBPVM.BusinessProcesses) {
                          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + oBPS.BusinessProcess.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                            if (Data != null) {

                              try {
                                var oCount = JSON.parse(Data);
                                if (this.__sParam != null) {
                                  let hideParam: string = this.__sParam.substring(0, this.__sParam.indexOf(":"));
                                  let hideParamValue: string = this.__sParam.substring(this.__sParam.indexOf(":") + 1);
                                  if (hideParam != null && hideParamValue != null) {
                                    if (hideParam.toLowerCase() == "hidesidepanel") {
                                      if (hideParamValue.toLowerCase() == "true") {
                                        this.hideSidePanel();
                                      } else {
                                        this.showSidePanel();
                                      }
                                    }
                                  }
                                }
                              }
                              catch {
                                console.log(Data);
                              }
                              let oBusinessProcessHTML: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);
                              oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;
                            }
                          });
                        }
                        oBPVM.GetIsCountFetched = 1;
                        return;
                      }
                    }
                  }

                });
                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStates/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                  if (Data != null) {
                    this.__oBusinessProcessStates = Data;
                    if (this.hideDashboardMenu) {
                      $('.pCollapsable').css({ 'top': '4.5rem' });
                      $('.pStateCollapsable').css({ 'top': '4.5rem' });
                      $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
                      $('#statesPane').css({ 'height': 'calc(100vh - 8.5rem)' });
                      $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 8.5rem)' });
                    } else {
                      this.showDashboardMenu();
                    }

                    let oBPS = this.__oBusinessProcessStates.find(x => x.lwfBusinessProcessStateId == this.__sURLBPS);
                    this.__oBusinessProcessStateName = oBPS.wfBusinessProcessState;
                    
                    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstances/" + this.__oBusinessProcessDefinitionName.replace("&", "annd") + "/" + this.__oBusinessProcessStateName.replace("&", "annd")).then((Data) => {
                      if (Data != null) {
                        this.__oBusinessProcessInstanceViewModel = Data;
                        this.__oStatecolumns = [];
                        if (this.__oBusinessProcessInstanceViewModel != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != undefined) {
                          this.__oStatecolumns.push({
                            caption: "",
                            cellTemplate: 'cellTemplate',
                            width: '35px',
                            allowEditing: false
                          })

                          for (var oColumn of this.__oBusinessProcessInstanceViewModel.DynamicColumns) {

                            if (oColumn.ColumnName == 'Initialized On' || oColumn.ColumnName == 'Initialized_On') {
                              this.__oStatecolumns.push({
                                dataField: oColumn.ColumnName,
                                caption: oColumn.ColumnName.replace("_", " "),
                                allowEditing: false,
                                allowSorting: true,
                                allowFiltering: true,
                                allowReordering: false,
                                sortOrder: 'desc',
                                dataType: 'date',
                                format: 'dd-MMM-yyyy HH:mm:ss'
                              })
                            }
                            else {
                              this.__oStatecolumns.push(this.makeColumn(oColumn));
                            }
                          }

                        }

                        try {

                          let sStateGridInstance = this.__oUtilityService.EscapeCharacters(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);
                          sStateGridInstance = this.replaceAllSpecialCharacters(sStateGridInstance);
                          this.__oStateDataSource = JSON.parse(sStateGridInstance);
                        }
                        catch
                        {
                          console.log(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);
                        }

                      }

                      this.__bIsLoadingVisible = false;

                    });

                  }
                });
              }
              else {
                this.__bStatelessWorkflowVisible = true;
                this.__bStateWorkflowVisible = false;
              }
            }

          });
        }
      );
  }
  OpenStateWorkflowInstance() {
    //#region Authenticate checking

    this.service.getAuthenticate().subscribe(
      data => {
        this.__sUserName = data
        //START Rajendra -- FB 20697 -- SSO Message
        if (!this.service.VerifyGetAuthenticate(this.__sUserName, this.router)) {
          return;
        }
        //END Rajendra -- FB 20697 -- SSO Message
        let sWFName: string;

        if (this.__sWFNameInQueryString != null) {
          sWFName = this.__sWFNameInQueryString;
        }
        else {
          sWFName = this.__sURLBPDId.toString();
        }
        //Start FB 13378, Workflow issues on displaying XML tag while action click.
        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetwfBusinessProcessDefinition/" + sWFName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
          //End FB 13378, Workflow issues on displaying XML tag while action click.
          if (Data != null) {
            this.__oWFBusinessProcessDefinition = Data;
            this.__oBusinessProcessDefinitionName = this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition;

            if (this.__oWFBusinessProcessDefinition.wfBusinessProcessModel == 'State') {
              this.__bStatelessWorkflowVisible = false;
              this.__bStateWorkflowVisible = true;

              this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcesses").then((Data) => {

                if (Data != null) {
                  if (this.__sParam != null) {
                    let hideParam: string = this.__sParam.substring(0, this.__sParam.indexOf(":"));
                    let hideParamValue: string = this.__sParam.substring(this.__sParam.indexOf(":") + 1);
                    if (hideParam != null && hideParamValue != null) {
                      if (hideParam.toLowerCase() == "hidesidepanel") {
                        if (hideParamValue.toLowerCase() == "true") {
                          this.hideSidePanel();
                        } else {
                          this.showSidePanel();
                        }
                      }
                    }
                  }
                  this.__oBusinessProcessViewModels = Data;

                  if (this.__sURLBPI != null && this.__sURLBPI != undefined && this.__sURLBPI > 0)
                    this.GetBusinessProcessInstanceCurrentStateData(this.__sURLBPI);
                  else {
                    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetPermissionInfo/138/" + this.__oWFBusinessProcessDefinition.lProcessStartUpRuleId).then((Data) => {

                      if (Data != null) {

                        if (Data == 1) {
                          this.__bStartNewProcessButtonVisible = true;
                          this.__sStartNewProcessButtonText = this.__oWFBusinessProcessDefinition.wfBusinessProcessRuleAction;

                          if (this.__sStartNewProcessButtonText == null || this.__sStartNewProcessButtonText.trim() == '') {
                            this.__bStartNewProcessButtonVisible = false;
                          }

                        }
                        else {
                          this.__bStartNewProcessButtonVisible = false;
                        }

                      }

                      this.__bIsLoadingVisible = false;
                    });
                  }



                  for (let oBPVM of this.__oBusinessProcessViewModels) {
                    let oBP: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition);

                    if (oBP != null) {
                      let iIndex = this.__oBusinessProcessViewModels.indexOf(oBPVM);
                      this.__iBusinessProcessAccordionSelectedIndex = iIndex;

                      for (var oBPS of oBPVM.BusinessProcesses) {
                        //Start FB 13378, Workflow issues on displaying XML tag while action click.
                        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + oBPS.BusinessProcess.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                          //End FB 13378, Workflow issues on displaying XML tag while action click.
                          if (Data != null) {

                            try {
                              var oCount = JSON.parse(Data);
                            }
                            catch {
                              console.log(Data);
                            }

                            let oBusinessProcessHTML: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);

                            oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;

                          }

                        });

                      }

                      oBPVM.GetIsCountFetched = 1;
                      return;
                    }
                  }

                }

              });
              //Start FB 13378, Workflow issues on displaying XML tag while action click.
              this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStates/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                //End FB 13378, Workflow issues on displaying XML tag while action click.
                if (Data != null) {
                  this.__oBusinessProcessStates = Data;
                  if (this.hideDashboardMenu) {
                    $('.pCollapsable').css({ 'top': '4.5rem' });
                    $('.pStateCollapsable').css({ 'top': '4.5rem' });
                    $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
                    $('#statesPane').css({ 'height': 'calc(100vh - 8.5rem)' });
                    $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 8.5rem)' });
                  } else {
                      this.showDashboardMenu();
                  }

                  let oBPS = this.__oBusinessProcessStates.find(x => x.lwfBusinessProcessStateId == this.__sURLBPS);
                  this.__oBusinessProcessStateName = oBPS?.wfBusinessProcessState;
                  this.__oBusinessProcessStateDisplayName = oBPS?.wfBusinessProcessStateDisplayName;

                  //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstances/" + this.__oBusinessProcessDefinitionName.replace("&", "annd") + "/" + this.__oBusinessProcessStateName.replace("&", "annd")).then((Data) => {

                  //  if (Data != null) {
                  //    this.__oBusinessProcessInstanceViewModel = Data;

                  //    if (this.__oBusinessProcessInstanceViewModel != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != undefined) {
                  //      this.__oStatecolumns.push({
                  //        caption: "",
                  //        cellTemplate: 'cellTemplate'
                  //      })

                  //      for (var oColumn of this.__oBusinessProcessInstanceViewModel.DynamicColumns) {
                  //        this.__oStatecolumns.push({
                  //          dataField: oColumn,
                  //          caption: oColumn.replace("_", "")
                  //        })
                  //      }

                  //    }

                  //    this.__oStateDataSource = JSON.parse(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);

                  //  }

                  //  this.__bIsLoadingVisible = false;

                  //});


                }



              });


            }
            else {
              this.__bStatelessWorkflowVisible = true;
              this.__bStateWorkflowVisible = false;


            }



            //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetPermissionInfo/138/" + this.__oWFBusinessProcessDefinition.lProcessStartUpRuleId).then((Data) => {

            //  if (Data != null) {

            //    if (Data == 1) {
            //      this.__bStartNewProcessButtonVisible = true;
            //      this.__sStartNewProcessButtonText = this.__oWFBusinessProcessDefinition.wfBusinessProcessRuleAction;
            //    }
            //    else {
            //      this.__bStartNewProcessButtonVisible = false;
            //    }

            //  }

            //});



          }

        });



      }
    );
    //#endregion

    //this.__oWFTabs = Object.assign([], this.WFservice.getWorkFlowTabs());
  }

  OpenStateWOrkflowNewInstance() {
    this.service.getAuthenticate().subscribe(
      data => {
        this.__sUserName = data
        //START Rajendra -- FB 20697 -- SSO Message
        if (!this.service.VerifyGetAuthenticate(this.__sUserName, this.router)) {
          return;
        }
        //END Rajendra -- FB 20697 -- SSO Message

        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetwfBusinessProcessDefinition/" + this.__sURLBPDId).then((Data) => {

          if (Data != null) {
            this.__oWFBusinessProcessDefinition = Data;
            this.__oBusinessProcessDefinitionName = this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition;

            this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcesses").then((Data) => {

              if (Data != null) {
                this.__oBusinessProcessViewModels = Data;
                //Start FB 13378, Handling special characters in WF Name.
                this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStartNewBusinessProcess/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId + "/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                  //End FB 13378, Handling special characters in WF Name.
                  if (Data != null) {
                    let InstanceId: number = Data;
                    this.__oBusinessProcessInstanceCurrentStateDatas = [];
                    this.GetBusinessProcessInstanceCurrentStateData(InstanceId);

                  }

                  this.__bIsLoadingVisible = false;

                });

                for (let oBPVM of this.__oBusinessProcessViewModels) {
                  let oBP: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition);

                  if (oBP != null) {
                    let iIndex = this.__oBusinessProcessViewModels.indexOf(oBPVM);
                    this.__iBusinessProcessAccordionSelectedIndex = iIndex;

                    for (var oBPS of oBPVM.BusinessProcesses) {
                      //Start FB 13378, Handling special characters in WF Name.
                      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + oBPS.BusinessProcess.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
                        //End FB 13378, Handling special characters in WF Name.
                        if (Data != null) {
                          try {
                            var oCount = JSON.parse(Data);
                          }
                          catch {
                            console.log(Data);
                          }

                          let oBusinessProcessHTML: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);

                          oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;

                        }

                      });

                    }

                    oBPVM.GetIsCountFetched = 1;
                    return;
                  }
                }

              }

            });

            this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStates/" + this.__oBusinessProcessDefinitionName.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {

              if (Data != null) {
                this.__oBusinessProcessStates = Data;

                let oBPS = this.__oBusinessProcessStates.find(x => x.lwfBusinessProcessStateId == this.__sURLBPS);
                this.__oBusinessProcessStateName = oBPS.wfBusinessProcessState;
                this.__oBusinessProcessStateDisplayName = oBPS.wfBusinessProcessStateDisplayName;
                if (this.hideDashboardMenu) {
                  $('.pCollapsable').css({ 'top': '4.5rem' });
                  $('.pStateCollapsable').css({ 'top': '4.5rem' });
                  $('#divStateWF').css({ 'height': 'calc(100vh - 5.3rem)' });
                  $('#statesPane').css({ 'height': 'calc(100vh - 8.5rem)' });
                  $('#div-StateInstances-grid').css({ 'height': 'calc(100vh - 8.5rem)' });
                } else {
                  this.showDashboardMenu();
                }

                this.__oBusinessProcessStateName = this.__oBusinessProcessStates[0].wfBusinessProcessState;


                //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstances/" + this.__oBusinessProcessDefinitionName.replace("&", "annd") + "/" + this.__oBusinessProcessStateName.replace("&", "annd")).then((Data) => {

                //  if (Data != null) {
                //    this.__oBusinessProcessInstanceViewModel = Data;

                //    if (this.__oBusinessProcessInstanceViewModel != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != null && this.__oBusinessProcessInstanceViewModel.DynamicColumns != undefined) {
                //      this.__oStatecolumns.push({
                //        caption: "",
                //        cellTemplate: 'cellTemplate'
                //      })

                //      for (var oColumn of this.__oBusinessProcessInstanceViewModel.DynamicColumns) {
                //        this.__oStatecolumns.push({
                //          dataField: oColumn,
                //          caption: oColumn.replace("_", "")
                //        })
                //      }

                //    }

                //    this.__oStateDataSource = JSON.parse(this.__oBusinessProcessInstanceViewModel.DynamicInstanceDataSource);

                //  }

                //  this.__bIsLoadingVisible = false;

                //});


              }



            });

            //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetPermissionInfo/138/" + this.__oWFBusinessProcessDefinition.lProcessStartUpRuleId).then((Data) => {

            //  if (Data != null) {

            //    if (Data == 1) {
            //      this.__bStartNewProcessButtonVisible = true;
            //      this.__sStartNewProcessButtonText = this.__oWFBusinessProcessDefinition.wfBusinessProcessRuleAction;
            //    }
            //    else {
            //      this.__bStartNewProcessButtonVisible = false;
            //    }

            //  }

            //});



          }

        });



      }
    );
    //#endregion
  }

  GetDataForStateGridACB(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any) {


    let ColumnName = this.__lDataGridColumns[ColumnIndex - 1];
    let oBusinessProcessStateGridDataContext = this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
      let oItemSource: ItemSource[] = oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex];

      FilterValue = this.replaceAll(FilterValue);

      if (oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
          return;
        }
      }

      this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));

      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStateGridItemSourceForAutoCompleteBox/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + ColumnName.DataField + "/" + FilterValue + "/" + lwfBusinessProcessStateDataId).then((Data) => {

        if (Data != null) {

          let oIS;

          try {
            oIS = JSON.parse(Data);
          }
          catch {
            console.log(Data);
          }
          oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex] = oIS;

          let oItemSource: ItemSource[] = oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex];
          if (oItemSource != undefined && oItemSource.length > 0) { this.__bAutoCompleteOpened = true; }
          this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
        }

      });
    }
    else {
      this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
    }


    //let oBusinessProcessStateGridDataContext = this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    //let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    //if (FilterValue != '' && FilterValue != null || FilterValue != undefined) {
    //  let oItemSource: ItemSource[] = JSON.parse(this.__lDataGridColumns[(ColumnIndex - 1)].ItemSource);

    //  FilterValue = this.replaceAll(FilterValue);

    //  if (oItemSource != undefined && oItemSource.length > 0) {
    //    let oIS = oItemSource.filter(x => x.DisplayMember.toLowerCase().indexOf(FilterValue.toLowerCase()) !== -1);

    //    oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex] = oIS;

    //    let oItemSrc: ItemSource[] = oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex];
    //    if (oItemSrc != undefined && oItemSrc.length > 0) {
    //      this.__bAutoCompleteOpened = true;
    //    }
    //    else {
    //      this.__bAutoCompleteOpened = false;
    //    }
    //    this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
    //  }
    //}
  }





  //Get dependent data(Country/IHS Rating) on selection of countrperty auto complete
  GetDependentDataForStateGridACB(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, sCaption: string) {
    let oBusinessProcessStateGridDataContext = this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null || FilterValue != undefined) {
      //Get country & IHS Rating values for KAES
      let strToReplace = FilterValue;
      let dot = /\./gi, and = /&/gi, hash = /#/gi, colon = /:/gi, backSlash = /\\/gi, percent = /%/gi, plus = /\+/gi, star = /\*/gi,
        fwdslash = /\//gi, Greaterthaaan = /\>/gi, Questionmaaark = /\?/gi;
      let sCounterparty = strToReplace.replace(dot, 'd0t').replace(and, 'annd').replace(hash, 'haaash').replace(colon, 'cln100')
        .replace(backSlash, 'bckwrdslsh101').replace(percent, 'peeercennt').replace(plus, 'pluuus').replace(star, 'staaar')
        .replace(fwdslash, 'fwdslash').replace(Greaterthaaan, 'Greaterthaaan').replace(Questionmaaark, 'Questionmaaark');

      this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/BusinessProcessStateGridDependentData/" + lwfBusinessProcessStateDataId + "/" + sCaption + "/" + sCounterparty).subscribe(res => {
        if (res != null && res.length > 0) {
          oBusinessProcessStateGridDataContext.DataValue[ColumnIndex + 1] = res[1].DataValue; //For Customer code
          oBusinessProcessStateGridDataContext.DataValue[ColumnIndex + 4] = res[4].DataValue; //For Country column
          oBusinessProcessStateGridDataContext.DataValue[ColumnIndex + 5] = res[5].DataValue; //For IHS Rating
          // this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
        }
      });
    }
  }

  //Populate a datasource for cascade dropdowns inside a state datagrid
  PopulateDependentDataForStateGrid(ColumnIndex: any, RowIndex: any, RowNumber: any, Info: any) {
    let oBusinessProcessStateGridDataContext = this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null || FilterValue != undefined) {
      let oItemSource: ItemSource[] = JSON.parse(this.__lDataGridColumns[(ColumnIndex - 1)].ItemSource);

      FilterValue = this.replaceAll(FilterValue);

      if (oItemSource != undefined && oItemSource.length > 0) {
        let oIS = oItemSource.filter(x => x.DisplayMember.indexOf(FilterValue) !== -1);

        oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex] = oIS;

        let oItemSrc: ItemSource[] = oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex];
        if (oItemSrc != undefined && oItemSrc.length > 0) {
          this.__bAutoCompleteOpened = true;
        }
        else {
          this.__bAutoCompleteOpened = false;
        }
        this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
      }
    }
  }

  addStateGridNewRow() {
    //Adding  a new row to the grid
    //let queryResult = '[[{"RowNumber":"' + (this.__oBusinessProcessStateGridDataQueryResult.length + 1) + '"},[{"ColumnName":"CounterpartyName","DataValue":"","ColumnType":"System.String"},{"ColumnName":"CustomerId","DataValue":"","ColumnType":"System.String"},{"ColumnName":"RatingType","DataValue":"","ColumnType":"System.String"},{"ColumnName":"CreditRating","DataValue":"","ColumnType":"System.String"},{"ColumnName":"Country","DataValue":"","ColumnType":"System.String"},{"ColumnName":"IHSRating","DataValue":"","ColumnType":"System.String"},{"ColumnName":"CurrentLine","DataValue":"","ColumnType":"System.String"},{"ColumnName":"ProposedLine","DataValue":"","ColumnType":"System.String"},{"ColumnName":"Currency","DataValue":"","ColumnType":"System.String"},{"ColumnName":"PaymentTerms","DataValue":"","ColumnType":"System.String"},{"ColumnName":"DealTenor","DataValue":"","ColumnType":"System.String"}]]]'
    //var oDynamicQueryResult = JSON.parse(queryResult);

    let oBusinessProcessStateGridDataQueryResult = new BusinessProcessStateGridDataQueryResult();

    oBusinessProcessStateGridDataQueryResult.RowNumber = (this.__oBusinessProcessStateGridDataQueryResult.length + 1);
    oBusinessProcessStateGridDataQueryResult.QueryResult = [];

    for (var oQR of this.__lDataGridColumns.sort(x => x.DisplayOrder)) {
      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oQR.DataField;
      oDynamicQueryResult.DataValue = "";
      //oDynamicQueryResult.ColumnType = oQR.ColumnType;
      oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
    }
    this.__oBusinessProcessStateGridDataQueryResult.push(oBusinessProcessStateGridDataQueryResult);

    let oDataCntext = new BusinessProcessStateGridDataContext();
    oDataCntext.RowNumber = oBusinessProcessStateGridDataQueryResult.RowNumber;
    oDataCntext.QueryResult = oBusinessProcessStateGridDataQueryResult.QueryResult;

    oDataCntext.DataValue = [];
    oDataCntext.ItemSource = [];

    oDataCntext.DataValue.push('');
    oDataCntext.ItemSource.push([]);

    for (var oSDD of this.__lDataGridColumns.sort(x => x.DisplayOrder)) {
      // Adding Datavalue
      let oColumn = oBusinessProcessStateGridDataQueryResult.QueryResult.find(x => x.ColumnName == oSDD.DataField);

      let oColumnValue = (oColumn == null || oColumn == undefined ? '' : oColumn.DataValue);

      if (oColumnValue != null && oColumnValue != '') {
        oDataCntext.DataValue.push(oColumnValue);
      }
      else {
        let oEmptyValue = '';
        oDataCntext.DataValue.push(oEmptyValue);
      }

      // Adding Itemsource
      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {
        let oIS = JSON.parse(oSDD.ItemSource);
        oDataCntext.ItemSource.push(oIS);
      }
      else {

        let oItemSource = [];
        oDataCntext.ItemSource.push(oItemSource);
      }
    }

    this.__oBusinessProcessStateGridDataContext.push(oDataCntext);
    this.stateDataGrid.instance.refresh();
  }

  removeStateGridRow(ColumnIndex: any, RowIndex: any, RowNumber: any) {
    //let Value = this.__oStateDataGridSelectedKeys;
    const index: number = this.__oBusinessProcessStateGridDataQueryResult.findIndex(x => x.RowNumber == RowNumber);
    if (index) {
      this.__oBusinessProcessStateGridDataQueryResult.splice(index, 1);
    }
    this.stateDataGrid.instance.deleteRow(RowIndex);
    this.stateDataGrid.instance.refresh();
  }

  //Convert Object to XML
  json2xml(o: any, tab: any): string {
    var toXml = function (v, name, ind) {
      var xml = "";
      if (v instanceof Array) {
        for (var i = 0, n = v.length; i < n; i++)
          xml += ind + toXml(v[i], name, ind + "\t") + "\n";
      }
      else if (typeof (v) == "object") {
        var hasChild = false;
        xml += ind + "<" + name;
        for (var m in v) {
          if (m.charAt(0) == "@")
            xml += " " + m.substr(1) + "=\"" + v[m].toString() + "\"";
          else
            hasChild = true;
        }
        xml += hasChild ? ">" : "/>";
        if (hasChild) {
          for (var m in v) {
            if (m == "#text")
              xml += v[m];
            else if (m == "#cdata")
              xml += "<![CDATA[" + v[m] + "]]>";
            else if (m.charAt(0) != "@")
              xml += toXml(v[m], m, ind + "\t");
          }
          xml += (xml.charAt(xml.length - 1) == "\n" ? ind : "") + "</" + name + ">";
        }
      }
      else {
        xml += ind + "<" + name + ">" + v.toString() + "</" + name + ">";
      }
      return xml;
    }, xml = "";
    for (var m in o)
      xml += toXml(o[m], m, "");
    return tab ? xml.replace(/\t/g, tab).replace('/\&/g', 'annnd') : xml.replace(/\t|\n/g, "").replace('/\&/g', 'annnd');
  }

  safeXMLValue(value: any): string {
    var s = value.toString();
    s = s.replace('/\&/g', 'annnd');
    s = s.replace('/\"/g', '&quot;');
    s = s.replace('/</g', 'leeesthan');
    s = s.replace('/>/g', 'greeeterthan');
    return s;
  }

  StateGridACBonFocusIn(ColumnIndex: any, RowIndex: any, RowNumber: any, element: any) {

    let oBusinessProcessStateGridDataContext = this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);
    let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined && FilterValue.length > 0) {
      if (element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange) {
        element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange(FilterValue.length, FilterValue.length);
      }
      else if (element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange) {
        var range = element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange();
        range.collapse(true);
        range.moveEnd('character', FilterValue.length);
        range.moveStart('character', FilterValue.length);
        range.select();
      }

    }


  }


  StateGenericDataGridACBonFocusIn(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, element: any) {

    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    //let ColumnName = oBPICSD.BusinessProcessStateGridDataQueryResult[ColumnIndex]; //this.__lDataGridColumns[ColumnIndex - 1];

    let oBusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber); //this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined && FilterValue.length > 0) {
      if (element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange) {
        element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange(FilterValue.length, FilterValue.length);
      }
      else if (element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange) {
        var range = element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange();
        range.collapse(true);
        range.moveEnd('character', FilterValue.length);
        range.moveStart('character', FilterValue.length);
        range.select();
      }

    }


  }

  GetDataForStateDataGridDetailACB(RowNumber: any, Column: any, lwfBusinessProcessStateDataId: any, element: any) {
    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder); //[ColumnIndex]; //this.__lDataGridColumns[ColumnIndex - 1];
    let DataField = Column;


    let oBusinessProcessStateGridDataContext: BusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber); //this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == DataField).DataValue;

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
      let oItemSource: ItemSource[] = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == DataField).ItemSource;

      FilterValue = this.replaceAll(FilterValue);

      if (oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
          return;
        }
      }

      let sXMLData: string = this.GetGenericStateDataGridRowDataXMl(0, 0, RowNumber, lwfBusinessProcessStateDataId, element.value);
      sXMLData = this.replaceAll(sXMLData);
      sXMLData = sXMLData.replace(/\*/g, 'staaar')

      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStateGenericGridItemSourceForAutoCompleteBox/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + DataField + "/" + FilterValue + "/" + lwfBusinessProcessStateDataId + "/" + sXMLData).then((Data) => {

        if (Data != null) {

          let oIS;

          try {
            oIS = JSON.parse(Data);
          }
          catch {
            console.log(Data);
          }


          let oDataGridDetail: BusinessProcessStateGridData = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == DataField);
          oDataGridDetail.ItemSource = oIS;

          let oItemSource: ItemSource[] = oDataGridDetail.ItemSource;
          if (oItemSource != undefined && oItemSource.length > 0) {
            oDataGridDetail.Opened = true;
          }



        }

      });
    }

  }

  /* Start FB 29535 - WorkflowStateDataGridChanges */

  GetDataForStateGenericDataGridACB(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, element: any) {

    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder); //[ColumnIndex]; //this.__lDataGridColumns[ColumnIndex - 1];
    let DataField = ColumnName[ColumnIndex - 1].DataField;

    
    let oBusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber); //this.__oBusinessProcessStateGridDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStateGridDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
      let oItemSource: ItemSource[] = oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex];

      FilterValue = this.replaceAll(FilterValue);

      if (oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
          //return;
        }
      }

      let sXMLData: string = this.GetGenericStateDataGridRowDataXMl(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element.value);
      sXMLData = this.replaceAll(sXMLData);
      sXMLData = sXMLData.replace(/\*/g, 'staaar')

      let oBusinessProcessParam = new BusinessProcessParam();
      oBusinessProcessParam.lwfBusinessProcessInstanceId = this.__oBusinessProcessInstanceCurrentStateDatas[0].lwfBusinessProcessInstanceId;;
      oBusinessProcessParam.sRowXML = sXMLData;
      oBusinessProcessParam.sCurrentInstanceData = this.GetStateDataValuesInJSONFormat();
      oBusinessProcessParam.sDataCaption = DataField;
      oBusinessProcessParam.lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
      oBusinessProcessParam.lwfBusinessProcessStateDataId = lwfBusinessProcessStateDataId;
      oBusinessProcessParam.sFilterValue = FilterValue;

      let _oStateDynamicGrid = this.__oStateDataGridWidgetInstances.find(x => x.StateDataId == oBPICSD.lBusinessProcessInstanceCurrentStateDataId).WidgetInstance;
      _oStateDynamicGrid.option("columns", oBPICSD.StateDataGridColumns);
      _oStateDynamicGrid.focus(_oStateDynamicGrid.getCellElement(RowIndex, ColumnIndex));
  
      this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/StateGenericGridItemSourceForAutoCompleteBox").then(
        result => {
          if (result != null) {

            let oIS;

            try {
              oIS = JSON.parse(result);
              oIS.forEach(x => {
                if (x.DisplayMember) {
                  x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                  x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                }
              })


              oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex] = oIS;

              let oItemSource: ItemSource[] = oBusinessProcessStateGridDataContext.ItemSource[ColumnIndex];
              if (oItemSource != undefined && oItemSource.length > 0) {
                oBusinessProcessStateGridDataContext.Opened[ColumnIndex] = true;
              }
              this.StateGenericDataGridColumnValueChanged(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element);
              let StateDynamicGrid = this.__oStateDataGridWidgetInstances.find(x => x.StateDataId == oBPICSD.lBusinessProcessInstanceCurrentStateDataId).WidgetInstance;
              StateDynamicGrid.focus(StateDynamicGrid.getCellElement(RowIndex, ColumnIndex))


            }
            catch {
              console.log(result);
            }

          }
        }
      ).
        catch(error => this.OnErrorGenericDataGridDependantData(error))


    }
    else {
      let StateDynamicGrid = this.__oStateDataGridWidgetInstances.find(x => x.StateDataId == oBPICSD.lBusinessProcessInstanceCurrentStateDataId).WidgetInstance;
      StateDynamicGrid.focus(StateDynamicGrid.getCellElement(RowIndex, ColumnIndex));
      this.StateGenericDataGridColumnValueChanged(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element);
      //this.stateDataGrid.instance.focus(this.stateDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
    }
  }

  StateGenericDataGridColumnValueChangedTB(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, element: any) {
    const previousValues = element.previousValue;
    const newValues = element.value;
    var isSame = (previousValues.length == newValues.length) && previousValues.every(function (element, index) {
      return element === newValues[index];
    });
    if (!isSame) {
      this.StateGenericDataGridColumnValueChanged(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element);
    }
  }
  StateGenericDataGridColumnValueChanged(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, element: any, name?: any) {
    if(name) {
      name[ColumnIndex] = element.value;
    }
    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder);
    let ColumnNameDetail: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder);
    let DataField = ColumnName[ColumnIndex - 1].DataField;


    let oBusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber);

    if (oBusinessProcessStateGridDataContext.RowStatus == undefined || oBusinessProcessStateGridDataContext.RowStatus == null || oBusinessProcessStateGridDataContext.RowStatus == "")
      oBusinessProcessStateGridDataContext.RowStatus = "Updated";

    let sXMLData: string = this.GetGenericStateDataGridRowDataXMl(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element.value);
    sXMLData = this.replaceAll(sXMLData);
    sXMLData = sXMLData.replace(/\*/g, 'staaar');

    let oBusinessProcessParam = new BusinessProcessParam();
    oBusinessProcessParam.lwfBusinessProcessInstanceId = this.__oBusinessProcessInstanceCurrentStateDatas[0].lwfBusinessProcessInstanceId;;
    oBusinessProcessParam.sRowXML = sXMLData;
    oBusinessProcessParam.sCurrentInstanceData = this.GetStateDataValuesInJSONFormat();
    oBusinessProcessParam.sDataCaption = DataField;
    oBusinessProcessParam.lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    oBusinessProcessParam.lwfBusinessProcessStateDataId = lwfBusinessProcessStateDataId;

    this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/GenericDataGridDependantData").then(
      result => {
        if (result != null) {

          let iIndex: number = 1;

          let oBusinessProcessStateGridData: BusinessProcessStateGridData[] = result;

          if (oBusinessProcessStateGridData.length > 0) {

            ColumnName.forEach((oColumnDetail) => {
              let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);

              if (oExistBusinessProcessStateGridData != null) {
                oBusinessProcessStateGridDataContext.ItemSource[iIndex] = [];
                if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {

                  let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                  oIS.forEach(x => {
                    if (x.DisplayMember) {
                      x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                      x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                    }
                  })
                  if(oIS.length > 0){
                    oBusinessProcessStateGridDataContext.ItemSource[iIndex] = oIS;
                  }
                }
                let sDataValueArray = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);

                if (sDataValueArray != null && sDataValueArray != undefined && sDataValueArray.length === 1) {
                  if (sDataValueArray[0] == "seeeleccct") {
                    sDataValueArray[0] = sDataValueArray[0].replace(/seeeleccct/g, "");
                  }
                  if (oColumnDetail.DataType === "Multi Select Combo Box") {
                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = sDataValueArray[0];
                    oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(sDataValueArray[0]);
                  }
                  else if (oColumnDetail.DataType == "Check Box") {
                    let sDataValue = sDataValueArray[0];
                    let bValue = false;
                    if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                      bValue = true;
                    }

                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue;
                  }
                  else {
                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = sDataValueArray[0];
                  }

                }
                else {

                  if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                    if (oColumnDetail.DataType == "Check Box") {
                      let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                      let bValue = false;
                      if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                        bValue = true;
                      }
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue
                    }
                    else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                      oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                    }
                    else{
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = oExistBusinessProcessStateGridData.DataValue;
                    }
                  }
                }
              }

              iIndex += 1;

            }
            );

            for (let oColumnDetail of ColumnNameDetail) {

              let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


              if (oExistBusinessProcessStateGridData != null) {

                let oBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


                if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {
                  let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                  oIS.forEach(x => {
                    if (x.DisplayMember) {
                      x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                      x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                    }
                  })
                  oBusinessProcessStateGridData.ItemSource = oIS;
                }
                else {
                  oBusinessProcessStateGridData.ItemSource = [];

                  if (oColumnDetail.ItemSource != null && oColumnDetail.ItemSource != '') {
                    let oIS: any = JSON.parse(oColumnDetail.ItemSource);

                    oIS.forEach(x => {
                      if (x.DisplayMember) {
                        x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                        x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                      }
                    })
                    oBusinessProcessStateGridData.ItemSource = oIS;
                  }
                }



                if (oColumnDetail.DataType == 'Multi Select Combo Box') {
                  if (oBusinessProcessStateGridData.DataValue != null && oBusinessProcessStateGridData.DataValue != undefined) {
                    oBusinessProcessStateGridData.DataValue = '';
                    oBusinessProcessStateGridData.MultiSelectedItems = [];
                  }
                }

                if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                  if (oColumnDetail.DataType == "Check Box") {
                    let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                    let bValue = false;
                    if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                      bValue = true;
                    }
                    oBusinessProcessStateGridData.DataValue = bValue
                  }
                  else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                    oBusinessProcessStateGridData.MultiSelectedItems = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                  }
                  else {
                    oBusinessProcessStateGridData.DataValue = oExistBusinessProcessStateGridData.DataValue;
                  }
                }

              }



            }


          }

        }
      }
    ).
      catch(error => this.OnErrorGenericDataGridDependantData(error))


    //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetGenericDataGridDependantData/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + DataField + "/" + lwfBusinessProcessStateDataId + "/" + sXMLData).then((Data) => {



    //});

  }

  StateGenericDataGridColumnValueChangedACB(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, element: any) {

    if (element.selectedItem.DisplayMember != undefined && element.selectedItem.DisplayMember != null) {

      let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

      let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder);
      let ColumnNameDetail: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder);
      let DataField = ColumnName[ColumnIndex - 1].DataField;


      let oBusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber);

      if (oBusinessProcessStateGridDataContext.RowStatus == undefined || oBusinessProcessStateGridDataContext.RowStatus == null || oBusinessProcessStateGridDataContext.RowStatus == "")
        oBusinessProcessStateGridDataContext.RowStatus = "Updated";

      let sXMLData: string = this.GetGenericStateDataGridRowDataXMl(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element.value);
      sXMLData = this.replaceAll(sXMLData);
      sXMLData = sXMLData.replace(/\*/g, 'staaar');

      let oBusinessProcessParam = new BusinessProcessParam();
      oBusinessProcessParam.lwfBusinessProcessInstanceId = this.__oBusinessProcessInstanceCurrentStateDatas[0].lwfBusinessProcessInstanceId;
      oBusinessProcessParam.sRowXML = sXMLData;
      oBusinessProcessParam.sCurrentInstanceData = this.GetStateDataValuesInJSONFormat();
      oBusinessProcessParam.sDataCaption = DataField;
      oBusinessProcessParam.lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
      oBusinessProcessParam.lwfBusinessProcessStateDataId = lwfBusinessProcessStateDataId;

      this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/GenericDataGridDependantData").then(
        result => {
          if (result != null) {

            let iIndex: number = 1;

            let oBusinessProcessStateGridData: BusinessProcessStateGridData[] = result;

            if (oBusinessProcessStateGridData.length > 0) {
              for (var oColumnDetail of ColumnName) {

                let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);

                if (oExistBusinessProcessStateGridData != null) {
                  if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {
                    let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                    oIS.forEach(x => {
                      if (x.DisplayMember) {
                        x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                        x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                      }
                    })
                    oBusinessProcessStateGridDataContext.ItemSource[iIndex] = oIS;
                  }
                  else {
                    oBusinessProcessStateGridDataContext.ItemSource[iIndex] = [];
                  }



                  if (oColumnDetail.DataType == 'Multi Select Combo Box') {
                    if (oBusinessProcessStateGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateGridDataContext.DataValue[iIndex] != undefined) {
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = '';
                      oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = [];
                    }
                  }

                  if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                    if (oColumnDetail.DataType == "Check Box") {
                      let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                      let bValue = false;
                      if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                        bValue = true;
                      }
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue
                    }
                    else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                      oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                    }
                    else {
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = oExistBusinessProcessStateGridData.DataValue;
                    }
                  }

                }

                iIndex += 1;

              }

              for (var oColumnDetail of ColumnNameDetail) {

                let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


                if (oExistBusinessProcessStateGridData != null) {

                  let oBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


                  if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {

                    let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                    oIS.forEach(x => {
                      if (x.DisplayMember) {
                        x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                        x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                      }
                    })
                    oBusinessProcessStateGridData.ItemSource = oIS;
                  }
                  else {
                    oBusinessProcessStateGridData.ItemSource = [];
                  }



                  if (oColumnDetail.DataType == 'Multi Select Combo Box') {
                    if (oBusinessProcessStateGridData.DataValue != null && oBusinessProcessStateGridData.DataValue != undefined) {
                      oBusinessProcessStateGridData.DataValue = '';
                      oBusinessProcessStateGridData.MultiSelectedItems = [];
                    }
                  }

                  if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                    if (oColumnDetail.DataType == "Check Box") {
                      let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                      let bValue = false;
                      if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                        bValue = true;
                      }
                      oBusinessProcessStateGridData.DataValue = bValue
                    }
                    else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                      oBusinessProcessStateGridData.MultiSelectedItems = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                    }
                    else {
                      oBusinessProcessStateGridData.DataValue = oExistBusinessProcessStateGridData.DataValue;
                    }
                  }

                }



              }


            }

          }
        }
      ).
        catch(error => this.OnErrorGenericDataGridDependantData(error))


      //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetGenericDataGridDependantData/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + DataField + "/" + lwfBusinessProcessStateDataId + "/" + sXMLData).then((Data) => {



      //});
    }
  }

  StateDataGridDetailColumnValueChanged(RowNumber: any, Column: any, ColumnHeader: any, lwfBusinessProcessStateDataId: any, element: any, event?: any, name?: any) {
    if(name) {
      name = event.value;
    }
    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder);
    let ColumnNameDetail: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder);
    let DataField = Column;


    let oBusinessProcessStateGridDataContext: BusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber);

    if (oBusinessProcessStateGridDataContext.RowStatus == undefined || oBusinessProcessStateGridDataContext.RowStatus == null || oBusinessProcessStateGridDataContext.RowStatus == "")
      oBusinessProcessStateGridDataContext.RowStatus = "Updated";


    let sXMLData: string = this.GetGenericStateDataGridRowDataXMl(0, 0, RowNumber, lwfBusinessProcessStateDataId, element.value);
    sXMLData = this.replaceAll(sXMLData);
    sXMLData = sXMLData.replace(/\*/g, 'staaar');

    let oBusinessProcessParam = new BusinessProcessParam();
    oBusinessProcessParam.lwfBusinessProcessInstanceId = this.__oBusinessProcessInstanceCurrentStateDatas[0].lwfBusinessProcessInstanceId;;
    oBusinessProcessParam.sRowXML = sXMLData;
    oBusinessProcessParam.sCurrentInstanceData = this.GetStateDataValuesInJSONFormat();
    oBusinessProcessParam.sDataCaption = DataField;
    oBusinessProcessParam.lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    oBusinessProcessParam.lwfBusinessProcessStateDataId = lwfBusinessProcessStateDataId;

    this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/GenericDataGridDependantData").then(
      result => {
        if (result != null) {

          let iIndex: number = 1;

          let oBusinessProcessStateGridData: BusinessProcessStateGridData[] = result;

          if (oBusinessProcessStateGridData.length > 0) {
            for (var oColumnDetail of ColumnName) {

              let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);

              if (oExistBusinessProcessStateGridData != null) {
                if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {

                  let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                  oIS.forEach(x => {
                    if (x.DisplayMember) {
                      x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                      x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                    }
                  })
                  oBusinessProcessStateGridDataContext.ItemSource[iIndex] = oIS;
                }
                else {
                  oBusinessProcessStateGridDataContext.ItemSource[iIndex] = [];
                }



                if (oColumnDetail.DataType == 'Multi Select Combo Box') {
                  if (oBusinessProcessStateGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateGridDataContext.DataValue[iIndex] != undefined) {
                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = '';
                    oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(oBusinessProcessStateGridDataContext.DataValue[iIndex]);;
                  }
                }

                if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                  if (oColumnDetail.DataType == "Check Box") {
                    let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                    let bValue = false;
                    if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                      bValue = true;
                    }
                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue
                  }
                  else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                    oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                  }
                  else {
                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = oExistBusinessProcessStateGridData.DataValue;
                  }
                }

              }

              iIndex += 1;

            }


            for (var oColumnDetail of ColumnNameDetail) {

              let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


              if (oExistBusinessProcessStateGridData != null) {

                let oBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


                if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {
                  let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                  oIS.forEach(x => {
                    if (x.DisplayMember) {
                      x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                      x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                    }
                  })
                  oBusinessProcessStateGridData.ItemSource = oIS;
                }
                else {
                  oBusinessProcessStateGridData.ItemSource = [];
                }



                if (oColumnDetail.DataType == 'Multi Select Combo Box') {
                  if (oBusinessProcessStateGridData.DataValue != null && oBusinessProcessStateGridData.DataValue != undefined) {
                    oBusinessProcessStateGridData.DataValue = '';
                    oBusinessProcessStateGridData.MultiSelectedItems = [];
                  }
                }

                if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                  if (oColumnDetail.DataType == "Check Box") {
                    let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                    let bValue = false;
                    if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                      bValue = true;
                    }
                    oBusinessProcessStateGridData.DataValue = bValue
                  }
                  else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                    oBusinessProcessStateGridData.MultiSelectedItems = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                  }
                  else {
                    oBusinessProcessStateGridData.DataValue = oExistBusinessProcessStateGridData.DataValue;
                  }
                }

              }



            }

          }

        }
      }
    ).
      catch(error => this.OnErrorGenericDataGridDependantData(error))

    //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetGenericDataGridDependantData/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + DataField + "/" + lwfBusinessProcessStateDataId + "/" + sXMLData).then((Data) => {



    //});

  }

  StateGenericDataGridColumnValueStaticChanged(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, element: any) {
    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder);
    let ColumnNameDetail: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder);
    let DataField = 'Static';


    let oBusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber);
    if (oBusinessProcessStateGridDataContext.RowStatus == undefined || oBusinessProcessStateGridDataContext.RowStatus == null || oBusinessProcessStateGridDataContext.RowStatus == "")
      oBusinessProcessStateGridDataContext.RowStatus = "Updated";

    let sXMLData: string = this.GetGenericStateDataGridRowDataXMl(ColumnIndex, RowIndex, RowNumber, lwfBusinessProcessStateDataId, element.value);
    sXMLData = this.replaceAll(sXMLData);
    sXMLData = sXMLData.replace(/\*/g, 'staaar');

    let oBusinessProcessParam = new BusinessProcessParam();
    oBusinessProcessParam.lwfBusinessProcessInstanceId = this.__oBusinessProcessInstanceCurrentStateDatas[0].lwfBusinessProcessInstanceId;
    oBusinessProcessParam.sRowXML = sXMLData;
    oBusinessProcessParam.sCurrentInstanceData = this.GetStateDataValuesInJSONFormat();
    oBusinessProcessParam.sDataCaption = DataField;
    oBusinessProcessParam.lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    oBusinessProcessParam.lwfBusinessProcessStateDataId = lwfBusinessProcessStateDataId;

    this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__sGetApiUrl + "api/WorkflowDashBoard/GenericDataGridDependantData").then(
      result => {
        if (result != null) {

          let iIndex: number = 1;

          let oBusinessProcessStateGridData: BusinessProcessStateGridData[] = result;

          if (oBusinessProcessStateGridData.length > 0) {
            for (var oColumnDetail of ColumnName) {

              let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);

              if (oExistBusinessProcessStateGridData != null) {
                if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {
                  let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                  oIS.forEach(x => {
                    if (x.DisplayMember) {
                      x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                      x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                    }
                  });

                  if (oColumnDetail.DataType != "Check Box") {
                    if (oColumnDetail.DataType == "Multi Select Combo Box") {
                      oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.__oUtilityService.ParseCSVStringToStringArray(oBusinessProcessStateGridDataContext.DataValue[iIndex]);
                    }
                    oBusinessProcessStateGridDataContext.ItemSource[iIndex] = oIS;

                  }
                  else {
                    let sDataValue = oIS[0]?.DisplayMember;
                    let bValue = false;
                    if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                      bValue = true;
                    }

                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue
                  }
                }
                else {
                  oBusinessProcessStateGridDataContext.ItemSource[iIndex] = [];

                  if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                    if (oColumnDetail.DataType == "Check Box") {
                      let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                      let bValue = false;
                      if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                        bValue = true;
                      }
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue
                    }
                    else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                      oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                    }
                    else {
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = oExistBusinessProcessStateGridData.DataValue;
                    }
                  }

                }

                if (this.__oUtilityService.IsNullOrUndefined(oBusinessProcessStateGridDataContext.DataValue[iIndex]) || this.__oUtilityService.IsNullOrEmpty(oBusinessProcessStateGridDataContext.DataValue[iIndex])
                  || oColumnDetail.DataType === "Check Box") {

                  let sDataValueArray = this.__oUtilityService.ParseCSVStringToStringArray(oExistBusinessProcessStateGridData.DataValue);
                  

                  if (sDataValueArray != null && sDataValueArray != undefined && sDataValueArray.length === 1) {
                    if (sDataValueArray[0] == "seeeleccct") {
                      sDataValueArray[0] = sDataValueArray[0].replace(/seeeleccct/g, "");
                    }
                    if (oColumnDetail.DataType === "Multi Select Combo Box") {

                      oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex] = sDataValueArray;
                      oBusinessProcessStateGridDataContext.DataValue[iIndex] = sDataValueArray[0];


                    } else {
                      if (oColumnDetail.DataType != "Check Box") {
                        oBusinessProcessStateGridDataContext.DataValue[iIndex] = sDataValueArray[0];
                      }
                      else if (oColumnDetail.DataType == "Check Box") {
                        let sDataValue = sDataValueArray[0];
                        let bValue = false;
                        if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                          bValue = true;
                        }

                        oBusinessProcessStateGridDataContext.DataValue[iIndex] = bValue;
                      }
                    }

                  }
                  else {
                    oBusinessProcessStateGridDataContext.DataValue[iIndex] = oExistBusinessProcessStateGridData.DataValue;
                  }
                }
              }
              iIndex += 1;

            }
            for (let oColumnDetail of ColumnNameDetail) {

              let oExistBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


              if (oExistBusinessProcessStateGridData != null) {

                let oBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == oColumnDetail.DataField);


                if (oExistBusinessProcessStateGridData.ItemSource != null && oExistBusinessProcessStateGridData.ItemSource != '') {
                  let oIS: any = JSON.parse(oExistBusinessProcessStateGridData.ItemSource);

                  oIS.forEach(x => {
                    if (x.DisplayMember) {
                      x.DisplayMember = x.DisplayMember.replace(/backslaaash/g, "\\");
                      x.DisplayMember = this.replaceAllSpecialCharacters(x.DisplayMember.toString());
                    }
                  })
                  oBusinessProcessStateGridData.ItemSource = oIS;
                }
                else {
                  oBusinessProcessStateGridData.ItemSource = [];
                }

                if (oExistBusinessProcessStateGridData.DataValue != null && oExistBusinessProcessStateGridData.DataValue != '') {
                  if (oColumnDetail.DataType == "Check Box") {
                    let sDataValue = oExistBusinessProcessStateGridData.DataValue;
                    let bValue = false;
                    if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                      bValue = true;
                    }
                    oBusinessProcessStateGridData.DataValue = bValue
                  }
                  else if (oColumnDetail.DataType == "Multi Select Combo Box") {
                    oBusinessProcessStateGridData.MultiSelectedItems = this.ParseCSVArrayWithStringLiteralHandling(oExistBusinessProcessStateGridData.DataValue);
                  }
                  else {
                    oBusinessProcessStateGridData.DataValue = oExistBusinessProcessStateGridData.DataValue;
                  }
                }

              }

            }


          }

        }
      }
    ).
      catch(error => this.OnErrorGenericDataGridDependantData(error))

    //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetGenericDataGridDependantData/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + DataField + "/" + lwfBusinessProcessStateDataId + "/" + sXMLData).then((Data) => {



    //  });

  }


  GetStateDataValuesInJSONFormat() {
    let sJSONCurrentInstanceData: string = "";

    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null || x.MultiSelectedItems != null)) {

      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      if (oCurrentInstance.DataType != 'Multi Select Combo Box' && oCurrentInstance.DataType != 'Date Picker' && oCurrentInstance.DataType != 'Rich Text Box'
        && oCurrentInstance.DataType != 'File Chooser' && oCurrentInstance.DataType != 'Grid' && oCurrentInstance.DataType != 'Data Grid'
        && oCurrentInstance.DataType != 'Qualitative Grid' && oCurrentInstance.DataType != 'Quantitative Grid'
        && oCurrentInstance.DataType != 'Score Analysis' && oCurrentInstance.DataType != 'Final Score Analysis'
        && oCurrentInstance.DataType != 'Check Box' && oCurrentInstance.DataType != 'Numeric/Money'
        && oCurrentInstance.DataType != "Counterparty Tree View"
        && oCurrentInstance.DataValue != null) {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Multi Select Combo Box') {

        if (oCurrentInstance?.MultiSelectedItems?.length > 0) {


          let sMSValue: string = this.__oUtilityService.ParseStringArrayToCSVString(oCurrentInstance.MultiSelectedItems);
          sMSValue = sMSValue.replace(/'/g, "''");
          sMSValue = "'" + sMSValue.replace(/,/g, "','") + "'";



          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + sMSValue.replace(/"/g, 'doouubleQuote') + "\"}";
          }
        }
      }
      else if (oCurrentInstance.DataType == 'Date Picker') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'File Chooser' && oCurrentInstance.DataValue != null) {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY)  + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY)  + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Check Box' || oCurrentInstance.DataType == 'Numeric/Money') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
      }
      //else if (oCurrentInstance.DataType == 'Grid') {
      //  let gridItems = this.__oBusinessProcessStateGridDataContext;
      //  let xmlString = '';
      //  for (var i = 0; i < gridItems.length; i++) {
      //    let jObject = new BusinessProcessStateGridDataQueryResult();
      //    jObject.RowNumber = gridItems[i].RowNumber;
      //    gridItems[i].QueryResult.forEach(function (val, idx) {
      //      let value = (gridItems[i].DataValue[(idx + 1)] != undefined && gridItems[i].DataValue[(idx + 1)] != null ?
      //        ((gridItems[i].DataValue[(idx + 1)]).toString().replace('&', 'annnd').replace('<', 'leeesthan').replace('>', 'greeeterthan')) : gridItems[i].DataValue[(idx + 1)])
      //      val.DataValue = value;
      //    });

      //    jObject.QueryResult = gridItems[i].QueryResult;

      //    let JsonObject: any = {};
      //    JsonObject.Row = jObject;
      //    xmlString += this.json2xml(JsonObject, null);
      //  }

      //  xmlString = (xmlString != '' ? '<Data>' + xmlString + '</Data>' : xmlString);

      //  if (sJSONCurrentInstanceData == "") {
      //    sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
      //  }
      //  else {
      //    sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + oCurrentInstance.DataCaption + "\",\"DataValue\":\"" + xmlString + "\"}";
      //  }
      //}

    }


    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null && x.DataType != 'Multi Select Combo Box' && x.DataType != 'Qualitative Grid' && x.DataType != 'Quantitative Grid' && x.DataType != 'Score Analysis' && x.DataType != 'Final Score Analysis')) {
      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

      if (oCurrentInstance.DataCaption != null) {

        if (oCurrentInstance.DataType == 'Check Box') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
        }
        else {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
        }
      }
    }

    sJSONCurrentInstanceData = "[" + sJSONCurrentInstanceData + "]";

    sJSONCurrentInstanceData = sJSONCurrentInstanceData.replace(/\n/g, 'neewwlliine').replace(/\r/g, 'neewwlliine');


    sJSONCurrentInstanceData = this.replaceAll(sJSONCurrentInstanceData);

    return sJSONCurrentInstanceData;

  }


  private OnErrorGenericDataGridDependantData(error: any) {
    console.log(error);
  }

  onGenericDataGridCellClick(e: any, Id: number) {
    if (this.__bStateDataValueChanged == true) {
      this.__oBusinessProcessInstanceCurrentStateDatas.forEach(x => {
        if (x.DataType == "Data Grid" && x.IsVisible == 1 && !this.__oUtilityService.IsNullOrUndefined(x.ItemSource)) {
          x.ItemSource.forEach(y => {
            y.IsStaticDataLoaded = null;     
          })
        }
      })
    }
    if ((e.rowType === "data" && e.data && e.columnIndex >= 0 && (e.data.IsStaticDataLoaded == undefined || e.data.IsStaticDataLoaded == null)) || this.__bStateDataValueChanged == true) {
      e.data.IsStaticDataLoaded = true;
      this.__bStateDataValueChanged = false;
      this.StateGenericDataGridColumnValueStaticChanged(e.columnIndex, e.rowIndex, e.data.RowNumber, Id, e);
    }
  }


  /* End FB 29535 - WorkflowStateDataGridChanges */

  onRowPrepared(e: any, lwfBusinessProcessStateDataId: any) {

    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    if (e.rowType == "data" && oBPICSD.BusinessProcessStateGridData?.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').length == 0) {
      if (e.rowElement.querySelector(".dx-command-expand").firstChild.classList != undefined) {
        e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-closed");
        e.rowElement.querySelector(".dx-command-expand").classList.remove("dx-datagrid-expand");
      }
    }
  }

  GetStateDataGridWidgetInstance(e: any) {
    let oStateGenericDataGridWidgetInstance = new StateGenericDataGridWidgetInstance();
    oStateGenericDataGridWidgetInstance.StateDataId = e.element.id;
    oStateGenericDataGridWidgetInstance.WidgetInstance = e.component;
    this.__oStateDataGridWidgetInstances.push(oStateGenericDataGridWidgetInstance);
  }

  GetGenericStateDataGridRowDataXMl(ColumnIndex: any, RowIndex: any, RowNumber: any, lwfBusinessProcessStateDataId: any, columnValue: any): string {
    let sXMLData: string = '';
    let oRowData: DynamicQueryResult[] = [];
    let iIndex: number = 1;

    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lwfBusinessProcessStateDataId == lwfBusinessProcessStateDataId);

    let ColumnName: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder);

    let oBusinessProcessStateGridDataContext: BusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber);

    let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateGridDataContext.QueryResult;

    for (var oColumnDetail of ColumnName) {
      let oColumnName = oColumnDetail;
      let oDataValue: any;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName.DataField);

      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateGridDataContext.DataValue[iIndex] != undefined  && oBusinessProcessStateGridDataContext.DataValue[iIndex] != 'null' && oBusinessProcessStateGridDataContext.DataValue[iIndex] != 'undefined' && oBusinessProcessStateGridDataContext.DataValue[iIndex] != '') {
          oDataValue = this.datePipe.transform(oBusinessProcessStateGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        } else if (oBusinessProcessStateGridDataContext.DataValue == 'null') {
          oBusinessProcessStateGridDataContext.DataValue[iIndex] = oDataValue = null;
        } else if (oBusinessProcessStateGridDataContext.DataValue[iIndex] == 'undefined') {
          oBusinessProcessStateGridDataContext.DataValue[iIndex] = oDataValue = undefined;
        }
      }
      else if (oColumnDetail.DataType === "Multi Select Combo Box") { //Multiselect combo box
        oDataValue = oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex];
      }
      else if (oColumnDetail.DataType == "Check Box") {
        oDataValue = false;
        if (oBusinessProcessStateGridDataContext.DataValue[iIndex] != undefined && oBusinessProcessStateGridDataContext.DataValue[iIndex] == true) {
          oDataValue = true;
        }
      }
      else {
        oDataValue = oBusinessProcessStateGridDataContext.DataValue[iIndex];
      }

      let oTempDataValue = [];
      if (oDataValue instanceof Array) {
        oDataValue.forEach((item, index) => {
          oTempDataValue[index] = item?.toString().replace(/,/g, "cooommaaa");
        });
      }
      else {
        oTempDataValue = oDataValue?.toString().replace(/,/g, "cooommaaa");
      }


      if (columnValue != undefined) { // not multi select combo box
        if (iIndex == ColumnIndex && columnValue.length == 0) {
          oDataValue = "";  
          if (oTempDataValue && oTempDataValue.length > 0) {
            oTempDataValue[0] = "";
          }        
          oBusinessProcessStateGridDataContext.DataValue[iIndex] = oDataValue;
        }
        else if (iIndex == ColumnIndex && columnValue.length > 0) {
          let dataValue = oQueryResult.find(x => x.DataValue == columnValue);
          if (dataValue != null || dataValue != undefined) {
            oDataValue = dataValue.DataValue;
          }
          else {
            if (Array.isArray(columnValue)) {
              oDataValue = columnValue.join(",");
            }
            else {
              oDataValue = columnValue
            }
            
          }

          oBusinessProcessStateGridDataContext.DataValue[iIndex] = oDataValue;
        }
      }


      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName.DataField;
      oDynamicQueryResult.DataValue = oTempDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    let ColumnNameDetail: BusinessProcessStateGridData[] = oBPICSD.BusinessProcessStateGridData.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder);


    for (var oColumnDetail of ColumnNameDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue: any;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName.DataField);

      let oBusinessProcessStateGridData: BusinessProcessStateGridData = oBusinessProcessStateGridDataContext.BusinessProcessStateGridData.find(x => x.DataField == oColumnName.DataField);

      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateGridData.DataValue != null && oBusinessProcessStateGridData.DataValue != undefined && oBusinessProcessStateGridData.DataValue != 'null' && oBusinessProcessStateGridData.DataValue != 'undefined' && oBusinessProcessStateGridData.DataValue != '') {
          oDataValue = this.datePipe.transform(oBusinessProcessStateGridData.DataValue, 'yyyy-MM-dd');
        } else if (oBusinessProcessStateGridData.DataValue == 'null') {
          oBusinessProcessStateGridData.DataValue = oDataValue = null;
        } else if (oBusinessProcessStateGridData.DataValue == 'undefined') {
          oBusinessProcessStateGridData.DataValue = oDataValue = undefined;
        }
      }
      else if (oBusinessProcessStateGridData.MultiSelectedItems[iIndex]?.length > 0) { //Multiselect combo box
        oDataValue = oBusinessProcessStateGridData.MultiSelectedItems[iIndex];
      }
      else if (oColumnDetail.DataType == "Check Box") {
        oDataValue = false;
        if (oBusinessProcessStateGridData.DataValue != undefined && oBusinessProcessStateGridData.DataValue == true) {
          oDataValue = true;
        }
      }
      else {
        oDataValue = oBusinessProcessStateGridData.DataValue;
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName.DataField;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);



    }

    for (var oOtherRowData of oBusinessProcessStateGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');//.replace(/,/g, 'cooommaaa');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    return sXMLData;

  }

  AddRowForStateGenericDataGrid(e: any, lStateDataId: any) {
    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == lStateDataId);
    let Data = oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData;

    if (oBusinessProcessInstanceCurrentStateData.ItemSource == null || oBusinessProcessInstanceCurrentStateData.ItemSource == undefined) {
      oBusinessProcessInstanceCurrentStateData.ItemSource = [];
    }

    if (oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult == null || oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult == undefined) {
      oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult = [];
    }


    let oBusinessProcessStateGridDataQueryResult = new BusinessProcessStateGridDataQueryResult();

    let oRowNumber = oBusinessProcessInstanceCurrentStateData.ItemSource.length + 1;


    oBusinessProcessStateGridDataQueryResult.RowNumber = oRowNumber;
    oBusinessProcessStateGridDataQueryResult.RowStatus = "New";
    oBusinessProcessStateGridDataQueryResult.QueryResult = [];

    if (oBusinessProcessInstanceCurrentStateData.ItemSource.length > 0) {
      for (let oExistQueryResult of oBusinessProcessInstanceCurrentStateData.ItemSource[0].QueryResult) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oExistQueryResult.ColumnName;
        oDynamicQueryResult.ColumnType = oExistQueryResult?.ColumnType??'System.String';

        if (oExistQueryResult?.ColumnType?.includes('Boolean')) {
          oDynamicQueryResult.DataValue = 'false';
        }
        else {
          oDynamicQueryResult.DataValue = '';
        }
        oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);
      }
      let i = 0;
      for(var oSDD of Data.sort(x => x.DisplayOrder)){
        if(oSDD.DataValue != null && oSDD.DataValue != undefined && oSDD.DataValue != ''){
          oBusinessProcessStateGridDataQueryResult.QueryResult[i].DataValue = oSDD.DataValue;
        }
        i++;
      }
    }
    else {
      for (var oSDD of Data.sort(x => x.DisplayOrder)) {

        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oSDD.DataField;

        if (oSDD.DataType == 'Check Box') {
          oDynamicQueryResult.ColumnType = 'Boolean';
          oDynamicQueryResult.DataValue = 'false';
        }
        else if (oSDD.DataType == 'Date Picker') {
          oDynamicQueryResult.ColumnType = 'DateTime';
          oDynamicQueryResult.DataValue = '';
        }
        else if (oSDD.DataType == 'Numeric/Money') {
          oDynamicQueryResult.ColumnType = 'Decimal';
          oDynamicQueryResult.DataValue = '';
        }
        else {
          oDynamicQueryResult.ColumnType = 'string';
          oDynamicQueryResult.DataValue = '';
        }
        if(oSDD.DataValue != null && oSDD.DataValue != undefined && oSDD.DataValue != ''){
          oDynamicQueryResult.DataValue = oSDD.DataValue;
        }

        oBusinessProcessStateGridDataQueryResult.QueryResult.push(oDynamicQueryResult);

      }
    }


    oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridDataQueryResult.push(oBusinessProcessStateGridDataQueryResult);


    let oDataCntext = new BusinessProcessStateGridDataContext();

    oDataCntext.RowNumber = oBusinessProcessStateGridDataQueryResult.RowNumber;
    oDataCntext.RowStatus = "New";
    oDataCntext.QueryResult = oBusinessProcessStateGridDataQueryResult.QueryResult;

    oDataCntext.DataValue = [];
    oDataCntext.ItemSource = [];
    oDataCntext.MultiSelectedItems = [];
    oDataCntext.Opened = [];
    oDataCntext.NumberFormat = [];
    oDataCntext.MinNum = [];
    oDataCntext.MaxNum = [];
    oDataCntext.TextSize = [];
    oDataCntext.BusinessProcessStateGridData = [];

    oDataCntext.DataValue.push('');
    oDataCntext.ItemSource.push([]);
    oDataCntext.MultiSelectedItems.push([]);
    oDataCntext.Opened.push(false);
    oDataCntext.NumberFormat.push('#,##0.##');
    oDataCntext.MinNum.push(0);
    oDataCntext.MaxNum.push(99);
    oDataCntext.TextSize.push(5000);

    //oDataCntext.DataValue.push('');
    //oDataCntext.ItemSource.push([]);

    for (var oSDD of Data.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As DataGrid Column').sort(y => y.DisplayOrder)) {

      // Adding Datavalue
      let oColumn = oBusinessProcessStateGridDataQueryResult.QueryResult.find(x => x.ColumnName == oSDD.DataField);

      if (oColumn.ColumnType.includes('Boolean')) {
        let sValue: string = oColumn.DataValue;
        let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
        oDataCntext.DataValue.push(bValue);

      }
      else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
        let iValue: number = oColumn.DataValue;

        if (oSDD.DataType == 'Check Box') {
          let bValue: boolean = false;

          if (Number(iValue) == 1) {
            bValue = true;
          }

          oDataCntext.DataValue.push(bValue);

        }
        else {
          //oDataCntext.DataValue.push(Number(iValue));
          if (!this.__oUtilityService.IsNullOrUndefined(iValue) && !this.__oUtilityService.IsNullOrEmpty(iValue.toString())) {
            oDataCntext.DataValue.push(Number(iValue));
          }
          else if(oSDD.DataType == 'Date Picker'){
            oDataCntext.DataValue.push(null);
          }
          else {
            let oEmptyValue = null; oDataCntext.DataValue.push(oEmptyValue);
          }
        }
      }
      else {
        let oColumnValue: string = oColumn.DataValue;

        if (oSDD.DataType == 'Check Box') {
          if (oColumnValue != null && oColumnValue != '') {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = false;

            if (sValue.toLowerCase() == 'true' || sValue == '1') {
              bValue = true;
            }

            oDataCntext.DataValue.push(bValue);
          }
          else {
            let bValue: boolean = false;
            oDataCntext.DataValue.push(bValue);
          }
        }
        else {

          if (oColumnValue != null && oColumnValue != '') {
            oColumnValue = this.__oUtilityService.ReplaceNewLineTabCharacters(oColumnValue.toString()); //fb 37019 Rajendra tab key
            oDataCntext.DataValue.push(oColumnValue);
          }
          else if(oSDD.DataType == 'Date Picker'){
            oDataCntext.DataValue.push(null);
          }
          else {
            let oEmptyValue = '';
            oDataCntext.DataValue.push(oEmptyValue);
          }
        }
      }

      // Adding Itemsource
      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {
        let oIS = JSON.parse(oSDD.ItemSource);
        oDataCntext.ItemSource.push(oIS);
      }
      else {

        let oItemSource = [];
        oDataCntext.ItemSource.push(oItemSource);
      }

      //Adding multiselected items

      let oMultiSelectedKeys = [];
      oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

      //Adding opened boolean value

      oDataCntext.Opened.push(false);

      // Adding number format , min , max , Text size

      oDataCntext.NumberFormat.push(oSDD.FormatString);
      oDataCntext.MinNum.push(oSDD.Min);
      oDataCntext.MaxNum.push(oSDD.Max);
      oDataCntext.TextSize.push(oSDD.TextSize);


    }


    for (var oSDD of Data.filter(x => x.IsVisible == 1 && x.DisplayArea == 'As Details').sort(y => y.DisplayOrder)) {


      let oBusinessProcessStateGridData = Object.assign({}, oSDD);
      let oColumn = oBusinessProcessStateGridDataQueryResult.QueryResult.find(x => x.ColumnName == oSDD.DataField);



      if (oColumn.ColumnType.includes('Boolean')) {
        let sValue: string = oColumn.DataValue;
        let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
        oBusinessProcessStateGridData.DataValue = bValue;

      }
      else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
        let iValue: number = oColumn.DataValue;

        if (oSDD.DataType == 'Check Box') {
          let bValue: boolean = false;

          if (Number(iValue) == 1) {
            bValue = true;
          }

          oBusinessProcessStateGridData.DataValue = bValue;

        }
        else {
          //oBusinessProcessStateGridData.DataValue = Number(iValue);
          if (!this.__oUtilityService.IsNullOrUndefined(iValue) && !this.__oUtilityService.IsNullOrEmpty(iValue.toString())) {
            oBusinessProcessStateGridData.DataValue = Number(iValue);
          }
          else if(oSDD.DataType == 'Date Picker'){
            oDataCntext.DataValue.push(null);
          }
          else {
            oBusinessProcessStateGridData.DataValue = null;
          }
        }

      }
      else {
        let oColumnValue: string = oColumn.DataValue;

        if (oSDD.DataType == 'Check Box') {
          if (oColumnValue != null && oColumnValue != '') {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = false;

            if (sValue.toLowerCase() == 'true' || sValue == '1') {
              bValue = true;
            }

            oBusinessProcessStateGridData.DataValue = bValue;
          }
          else {
            let bValue: boolean = false;
            oBusinessProcessStateGridData.DataValue = bValue;
          }
        }
        else {

          //if (oSDD.DataType == 'Date Picker') {
          //  if (oColumnValue != null && oColumnValue != '') {
          //    let dt = new Date(oColumnValue);
          //    oBusinessProcessStateGridData.DataValue = dt;
          //  }
          //}
          //else {
          if (oColumnValue != null && oColumnValue != '') {
            oColumnValue = this.__oUtilityService.ReplaceNewLineTabCharacters(oColumnValue.toString());//fb 37019 Rajendra tab key
            oBusinessProcessStateGridData.DataValue = oColumnValue;
          }
          else if(oSDD.DataType == 'Date Picker'){
            oDataCntext.DataValue.push(null);
          }
          else {
            let oEmptyValue = '';
            oBusinessProcessStateGridData.DataValue = oEmptyValue;
          }
          //}


        }
      }

      // Adding Itemsource
      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {
        let oIS = JSON.parse(oSDD.ItemSource);
        oBusinessProcessStateGridData.ItemSource = oIS;
      }
      else {

        let oItemSource = [];
        oBusinessProcessStateGridData.ItemSource = oItemSource;
      }

      //Adding multiselected items

      let oMultiSelectedKeys = [];
      oBusinessProcessStateGridData.MultiSelectedItems = oMultiSelectedKeys;

      //Adding opened boolean value

      oBusinessProcessStateGridData.Opened = false;

      // Adding number format , min , max , Text size

      oBusinessProcessStateGridData.FormatString = oSDD.FormatString;
      oBusinessProcessStateGridData.Min = oSDD.Min;
      oBusinessProcessStateGridData.Max = oSDD.Max;
      oBusinessProcessStateGridData.TextSize = oSDD.TextSize;

      oDataCntext.BusinessProcessStateGridData.push(oBusinessProcessStateGridData);
    }
    oBusinessProcessInstanceCurrentStateData.ItemSource.unshift(oDataCntext);

    this.oDataGridAddRowPopupDataContext = oBusinessProcessInstanceCurrentStateData;
    this.oDataGridAddRowPopupItemSource = oDataCntext;
    if (oBusinessProcessInstanceCurrentStateData.IsAddRowViaPopup == 1) {
      this.__bIsDataGridAddRowViaPopup = true;
      this.__bIsClickOkOrCancelButtonOnPopup = false;
    }

    this.StateGenericDataGridColumnValueStaticChanged(1,1,oDataCntext.RowNumber,oBusinessProcessInstanceCurrentStateData.lwfBusinessProcessStateDataId,{value:oDataCntext.DataValue[1]})
  }
  public getDataGridPopupVisibleItems() {
    return this.oDataGridAddRowPopupDataContext?.StateDataGridColumns.filter(item => item.visible == true);
  }
  public ResetDataGridPopup() {
    if (!this.__bIsClickOkOrCancelButtonOnPopup) {
      this.RemoveLastRow();
    }
    this.__bIsClickOkOrCancelButtonOnPopup = false;
    this.__bIsDataGridAddRowViaPopup = false;
    this.__bIsDataGridViewViaPopup = false;
  }

  private RemoveLastRow() {
    let x: [] = this.oDataGridAddRowPopupDataContext.ItemSource;
    this.oDataGridAddRowPopupDataContext.ItemSource = x.slice(1);
  }

  public DataGridAddPopupToggle() {
    this.__bIsDataGridAddRowViaPopup = !this.__bIsDataGridAddRowViaPopup;
  }
  public DataGridViewPopupToggle(lBusinessProcessInstanceCurrentStateDataId, rowIndex) {
    this.oDataGridAddRowPopupDataContext = this.__oBusinessProcessInstanceCurrentStateDatas.find((x) => {
      return x.lBusinessProcessInstanceCurrentStateDataId == lBusinessProcessInstanceCurrentStateDataId || x.lwfBusinessProcessStateDataId == lBusinessProcessInstanceCurrentStateDataId;
    });
    this.oDataGridAddRowPopupItemSource = this.oDataGridAddRowPopupDataContext.ItemSource[rowIndex];
    this.__bIsDataGridViewViaPopup = !this.__bIsDataGridViewViaPopup;
    this.__bIsClickOkOrCancelButtonOnPopup = true;
  }

  public DataGridAddPopupOK() {
    this.__bIsClickOkOrCancelButtonOnPopup = true;
    this.__bIsDataGridAddRowViaPopup = false;
    this.__bIsDataGridViewViaPopup = false;
  }

  public DataGridAddPopupCancel() {
    this.__bIsClickOkOrCancelButtonOnPopup = true;
    this.RemoveLastRow();
    this.DataGridAddPopupToggle();
  }

  OnDataGridAddRowPopupClose(e: any) {
    //oBusinessProcessInstanceCurrentStateData.ItemSource.unshift(oDataCntext);
  }
  RemoveGenericStateDataGridRow(ColumnIndex: any, RowIndex: any, RowNumber: any, lStateDataId: any) {

    let oBPICSD: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == lStateDataId);

    let oBusinessProcessStateGridDataContext = oBPICSD.ItemSource.find(x => x.RowNumber == RowNumber);

    oBPICSD.ItemSource.splice(oBPICSD.ItemSource.indexOf(oBusinessProcessStateGridDataContext), 1);

    let StateDynamicGrid = this.__oStateDataGridWidgetInstances.find(x => x.StateDataId == oBPICSD.lBusinessProcessInstanceCurrentStateDataId).WidgetInstance;
    StateDynamicGrid.deleteRow(RowIndex);
    StateDynamicGrid.refresh();
  }

  onKeyPressNumberBoxStateGenericDataGrid(e: any, RowNumber: any, ColumnIndex: any, rowIndex: any, lStateDataId: string) {

    let StateDynamicGrid = this.__oStateDataGridWidgetInstances.find(x => x.StateDataId == lStateDataId).WidgetInstance;

    if (e.event.key.toString().toUpperCase() == "M" || e.event.key.toString().toUpperCase() == "B" || e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "H" || e.event.key.toString().toUpperCase() == "T") {
      StateDynamicGrid.focus(StateDynamicGrid.getCellElement(rowIndex, ColumnIndex));
      if (e.event.key.toString().toUpperCase() == "M") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);
        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
      }
      else if (e.event.key.toString().toUpperCase() == "B") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
      }
      else if (e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "T") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
      }
      else if (e.event.key.toString().toUpperCase() == "H") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
      }
    }
    if ((e.event.key == 'Delete' || e.event.key == "Backspace") && !this.__oUtilityService.IsNullOrUndefined(e.event.target.value) && e.event.target.value.toString() == "0") {
      RowNumber.DataValue[ColumnIndex] = null;
    }
  }

  onKeyPressNumberBoxStateDataGridDetail(e: any, DataContext: any, RowNumber: any, lwfBusinessProcessStateDataId: any) {
    if (e.event.key.toString().toUpperCase() == "M" || e.event.key.toString().toUpperCase() == "B" || e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "H" || e.event.key.toString().toUpperCase() == "T") {

      if (e.event.key.toString().toUpperCase() == "M") {

        DataContext.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
      }
      else if (e.event.key.toString().toUpperCase() == "B") {


        DataContext.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
      }
      else if (e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "T") {


        DataContext.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
      }
      else if (e.event.key.toString().toUpperCase() == "H") {


        DataContext.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
      }
    }
    if ((e.event.key == 'Delete' || e.event.key == "Backspace") && !this.__oUtilityService.IsNullOrUndefined(e.event.target.value) && e.event.target.value.toString() == "0") {
      DataContext.DataValue = null;
    }
  }

  CheckLink(e: string) {
    if (e != null && (e.includes("Add") || e.includes("New"))) {
      return true;
    }
    else {
      return false;
    }
  }


  InitializeControl(e: any, DataCaption: string) {

    let oControlData: ControlData = new ControlData();

    oControlData.DataCaption = DataCaption;
    oControlData.Control = e;

    this.__oControlData.push(oControlData);

    e.Refresh();
  }

  InitializePowerBIReport(e: any, DataCaption: string) {

    let oControlData: ControlData = new ControlData();

    oControlData.DataCaption = DataCaption;
    oControlData.Control = e;

    this.__oControlData.push(oControlData);

    let sCurrentInstanceStateData: string = this.GetCurrentInstanceStateData();

    e.Refresh(sCurrentInstanceStateData);
  }


  RefreshPowerBIReport(sCurrentInstanceStateData: string, sDataCaption: string) {
    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == 'PowerBI Report')) {

      if (!this.__oUtilityService.IsNullOrEmpty(oCurrentInstance.DataTypeParameter) && oCurrentInstance.DataTypeParameter.includes('{' + sDataCaption + '}')) {
        let oControlData: ControlData = this.__oControlData.find(x => x.DataCaption == oCurrentInstance.DataCaption);

        if (oControlData != null && oControlData != undefined) {
          oControlData.Control.RefreshSilent(sCurrentInstanceStateData);
        }
      }

    }
  }

  GetCurrentInstanceStateData(): string {

    let sJSONCurrentInstanceData: string = "";
    //Start FB 13378, Workflow Issues.
    //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null)) {
    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue != null)) {
      //End FB 13378, Workflow issues.
      let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');
      //oCurrentInstance.DataValue = oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote');

      if (oCurrentInstance.DataType != 'Multi Select Combo Box' && oCurrentInstance.DataType != 'Date Picker' && oCurrentInstance.DataType != 'Rich Text Box'
        && oCurrentInstance.DataType != 'File Chooser' && oCurrentInstance.DataType != 'Grid' && oCurrentInstance.DataType != 'Data Grid'
        && oCurrentInstance.DataType != 'Qualitative Grid' && oCurrentInstance.DataType != 'Quantitative Grid'
        && oCurrentInstance.DataType != 'Score Analysis' && oCurrentInstance.DataType != 'Final Score Analysis'
        && oCurrentInstance.DataType != 'Check Box' && oCurrentInstance.DataType != 'Numeric/Money' && oCurrentInstance.DataType != "Counterparty Tree View") {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + (typeof oCurrentInstance.DataValue !== "boolean" ? oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') : oCurrentInstance.DataValue) + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Multi Select Combo Box') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue.replace(/"/g, 'doouubleQuote') + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Date Picker') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + ((this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == 'null' || this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == null)
            ? "" : this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd')) + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + ((this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == 'null' || this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd') == null)
            ? "" : this.datePipe.transform(oCurrentInstance.DataValue, 'yyyy-MM-dd')) + "\"}";
        }
      }

      else if (oCurrentInstance.DataType == 'File Chooser') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY)  + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + this.__oUtilityService.EncryptStringAES(oCurrentInstance.DataValue, Constants.EXTERNALSOURCE_AESKEY)  + "\"}";
        }
      }
      else if (oCurrentInstance.DataType == 'Check Box' || oCurrentInstance.DataType == 'Numeric/Money') {
        if (sJSONCurrentInstanceData == "") {
          sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
        else {
          sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"" + oCurrentInstance.DataValue + "\"}";
        }
      }







    }
    //Start FB 13378, Workflow issues.
    //for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null)) {
    for (let oCurrentInstance of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataValue == null && x.DataType != 'Qualitative Grid' && x.DataType != 'Quantitative Grid' && x.DataType != 'Score Analysis' && x.DataType != 'Final Score Analysis')) {
      //End FB 13378, Workflow issues.
      if (oCurrentInstance.DataCaption != null) {
        let sDataCaption = oCurrentInstance.DataCaption.replace('&', 'annnd').replace('/', 'frtwrdslsh101');

        if (oCurrentInstance.DataType == 'Check Box') {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"false\"}";
          }
        }
        else {
          if (sJSONCurrentInstanceData == "") {
            sJSONCurrentInstanceData += "{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
          else {
            sJSONCurrentInstanceData += ",{\"DataCaption\":" + "\"" + sDataCaption + "\",\"DataValue\":\"\"}";
          }
        }
      }
    }


    sJSONCurrentInstanceData = this.__oUtilityService.EncodeNewLineTabCharacters(sJSONCurrentInstanceData);//fb 37019 Rajendra tab key

    let oJSONData: string = sJSONCurrentInstanceData;

    sJSONCurrentInstanceData = "[" + sJSONCurrentInstanceData + "]";

    sJSONCurrentInstanceData = this.replaceAll(sJSONCurrentInstanceData);

    return sJSONCurrentInstanceData;

  }

  //#region stateless events

  RefreshStatelessGrid() {
    this.__bStatelessWorkflowVisible = true;
    this.__bStateWorkflowVisible = false;
    this.__oStatelesscolumns = [];
    //this.__bIsLoadingVisible = false;
    this.__oBusinessProcessStateLessDefinitionDetails = [];
    this.__oBusinessProcessStatelessQueryResult = [];
    this.__oBusinessProcessStatelessDataContext = [];
    this.__oMultiSelectControlColumnIndex = [];
    this.__oStatelessColumnDetail = [];
    this.__oStatelessGridSelectedKeys = [];
    this.__oBusinessProcessStateLessActionDetail = [];
    this.__oBusinessProcessStateLessCommonAction = [];
    this.__oBusinessProcessStateLessActionExecuteWebUrls = [];
    this.__bStateLessGridAddRowButtonVisible = false;

    if (this.dataGrid != null && this.dataGrid != undefined) {
      this.dataGrid.instance.clearFilter();
      this.dataGrid.instance.clearSorting();
    }

    //START: Stateless tabs implementation
    if (this.__oWFBusinessProcessDefinition.IsStateLessParentContainer == 1) {
      this.__bIsLoadingVisible = true;
      this.__bStatelessParentContainer = true;
      this.__lStatelessWorkflowTabs = [];
      this.oStatelessworkflowComponentNonParent = null;
      this.service.getDataByObservable(this.__sGetApiUrl + 'api/WorkflowDashBoard/BusinessProcessStatelessTabs/' + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId).subscribe(
        res => {
          this.__bIsLoadingVisible = false;
          if (res) {
            this.__lStatelessWorkflowTabs = res;

            for (var tab of this.__lStatelessWorkflowTabs) {
              //this.__bIsLoadingVisible = true;
              this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/BusinessProcessStatelessTabCount/" + tab.lwfBusinessProcessStatelessTabId).then((Data) => {
                if (Data != null) {
                  try {
                    var oCount = JSON.parse(Data);
                  }
                  catch {
                    console.log(Data);
                  }
                  let oBusinessProcessTabs: any = this.__lStatelessWorkflowTabs.find(x => x.lwfBusinessProcessStatelessTabId == oCount[0].lwfBusinessProcessStatelessTabId);

                  if (oBusinessProcessTabs.ItemCount == null || oBusinessProcessTabs.ItemCount == undefined || oCount[0].ItemCount == -1) {
                    oBusinessProcessTabs.ItemCount = 0;
                  }
                  else
                    oBusinessProcessTabs.ItemCount = oCount[0].ItemCount;
                }
                //this.__bIsLoadingVisible = false;
              });
            }

          }
        }, error => {
          console.log(error);
          this.OnErrorStateless(error);
        });
    }
    //END: Stateless tabs implementation
    else {
      this.__bIsLoadingVisible = false;
      this.__bStatelessParentContainer = false;

      if (this.oStatelessworkflowComponentNonParent != null) {
        this.oStatelessworkflowComponentNonParent.__iWfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
        this.oStatelessworkflowComponentNonParent.RefreshGrid();
                this.__sIsFilterApplied='false';
                this.location.replaceState('/Inbox/10');
      }


      //this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateLessDefinitionDetail/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId).then((Data) => {

      //  if (Data != null) {
      //    this.__oBusinessProcessStateLessDefinitionDetails = Data;

      //    if (this.__oBusinessProcessStateLessDefinitionDetails[0].IsAddRowEnabled == 1) {
      //      this.__bStateLessGridAddRowButtonVisible = true;
      //    }

      //    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStateLessDataItemSource/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId).then((Data) => {

      //      if (Data != null) {

      //        for (var oStatelessDefinitionWithItemsource of Data) {
      //          let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = this.__oBusinessProcessStateLessDefinitionDetails.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oStatelessDefinitionWithItemsource.lBusinessProcessStateLessDefinitionDetailId);

      //          oBusinessProcessStateLessDefinitionDetail.ItemSource = oStatelessDefinitionWithItemsource.ItemSource;
      //  }

      //      }
      //      else {
      //        this.__bIsLoadingVisible = false;
      //}

      //      if (this.__bIsOpenedThroughURL && this.__sIsFilterApplied != null && this.__sIsFilterApplied.toLowerCase() == 'true') {
      //        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDynamicWorkflowQueryResultWithFilter/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId + "/" + this.URLEncode(this.__sParam)).then((Data) => {

      //          if (Data != null) {

      //            let oBusinessProcessStatelessInstanceViewModel: BusinessProcessStatelessInstanceViewModel = Data;

      //            this.PopulateDynamicGrid(oBusinessProcessStatelessInstanceViewModel);

      //    }
      //    else {
      //            this.__bIsLoadingVisible = false;
      //          }

      //        });
      //      }
      //      else {
      //        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDynamicWorkflowQueryResult/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId).then((Data) => {

      //          if (Data != null) {

      //            let oBusinessProcessStatelessInstanceViewModel: BusinessProcessStatelessInstanceViewModel = Data;

      //            this.PopulateDynamicGrid(oBusinessProcessStatelessInstanceViewModel);

      //      }
      //          else {
      //            this.__bIsLoadingVisible = false;
      //          }

      //        });
      //      }

      //    });

      //    }
      //    else {
      //    this.__bIsLoadingVisible = false;
      //    }

      //});
    }
  }

  PopulateDynamicGrid(e: BusinessProcessStatelessInstanceViewModel) {
    let oBusinessProcessStatelessInstanceViewModel: BusinessProcessStatelessInstanceViewModel = e;
    this.__oStatelessGridColumnDetail = null;
    //if (oBusinessProcessStatelessInstanceViewModel.IsMDX == "true")
    //{
    //  this.PopulateDynamicGridMDX(oBusinessProcessStatelessInstanceViewModel);
    //  return;
    //}

    try {
      this.__oStatelessGridColumnDetail = JSON.parse(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
    }
    catch {
      console.log(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
    }

    if (oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource != null) {
      this.__oBusinessProcessStatelessQueryResult = [];


      try {
        var oDynamicColumnDetail = JSON.parse(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
        var oDynamicQueryResult = JSON.parse(oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource);

      }
      catch {
        console.log(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
      }


      // Generating grid columns

      let iColumnIndex: number = 2;
      let oCurrentComponant = this;

      this.__oStatelessColumnDetail.push('SelectionCheckBox');
      this.__oStatelessColumnDetail.push('MasterDetail');

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {

        this.__oStatelessColumnDetail.push(oSDD.ColumnName);

        if (oSDD.IsInput == 1) {
          if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateDate',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              dataType: 'date',
              format: 'dd-MMM-yyyy'
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateCheckBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            this.__oMultiSelectControlColumnIndex.push(iColumnIndex);

            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiSelect',
              //calculateCellValue: function (rowData) {
              //  let column = this as any;
              //  return that.calculateStatelessGridMultiselectCellValue(rowData, column);
              //},
              //cellTemplate: 'cellTemplateMultiSelect',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              //setCellValue: function (rowData: any, value: any, currentRow: any) {
              //  console.log(rowData);

              //}
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Combo Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateComboBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Auto Complete Box Sql') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAutoComplete',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAmount',
              //cellTemplate: 'cellTemplateAmount',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              //allowEditing: true,
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              format: oSDD.FormatString,
              dataType: 'number'
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Reference Data') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateDataReferenceReadOnly',
              cellTemplate: 'cellTemplateDataReferenceReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              allowEditing: false
            })
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
            //this.__oStatelesscolumns.push({
            //  dataField: "DataValue[" + iColumnIndex + "]",
            //  caption: oSDD.ColumnHeader,
            //  //editCellTemplate: 'cellTemplateMultilineReadOnly',
            //  //cellTemplate: 'cellTemplateMultilineReadOnly',
            //  width: oSDD.Width,
            //  //fixed: true,
            //  //sortOrder: 'asc',
            //  allowSorting: true,
            //  allowFiltering: true,
            //  allowReordering: false,
            //  allowHiding: false,
            //  showInColumnChooser: false
            //})
          }
        }
        else {
          if (oSDD.lwfBusinessProcessStatelessInputTypeId != null) {
            if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateDateReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                dataType: 'date',
                format: 'dd-MMM-yyyy'
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateCheckBoxReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                //cellTemplate: 'cellTemplateAmountReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                format: oSDD.FormatString,
                dataType: 'number'
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Reference Data') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate: 'cellTemplateDataReferenceReadOnly',
                cellTemplate: 'cellTemplateDataReferenceReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate: 'cellTemplateMultiline',
                //cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false

              })
            }
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate:'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              allowEditing: false
            })
          }
        }

        iColumnIndex += 1;

      }


      //for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder))
      //{

      //}

      //for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' || x.IsDisplay == 0).sort(x => x.DisplayOrder)) {
      //  this.__oStatelesscolumns.push({
      //    dataField: '',
      //    caption: oSDD.ColumnName,
      //    //dataField: oSDD.ColumnHeader,
      //    //cellTemplate: 'cellTemplateMultilineInvisible',
      //    width: oSDD.Width,
      //    calculateCellValue: function (rowData) {
      //      let column = this as any;
      //      return oCurrentComponant.calculateStatelessGridCellValue(rowData, column);
      //    },
      //    calculateSortValue: function (rowData) {
      //      let column = this as any;
      //      return oCurrentComponant.calculateStatelessGridCellSortValue(rowData, column);
      //    },
      //    //sortOrder: 'asc',
      //    allowSorting: true,
      //    allowFiltering: true,
      //    allowReordering: true,
      //    allowHiding: true,
      //    visible: false,
      //    showInColumnChooser: true,
      //    dataType: 'string'
      //  })
      //}


      // Generating data context for grid

      let sXMLResult: string = oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource;

      if (sXMLResult != null && sXMLResult != undefined) {
        sXMLResult = sXMLResult.replace(/_x0020_/g, ' ');
      }

      let iRowCount: number = 1;
      let iDataTableStartIndex: number = 0;
      let iDataTableLastIndex: number = 0;
      let sData: string = "";
      let sColumnData: string = "";
      let iColumnStartIndex: number = 0;
      let iColumnLastIndex: number = 0;
      let sColumnValue: string = "";
      let sValue: string = "";

      while (sXMLResult.trim() != '') {
        iDataTableStartIndex = sXMLResult.indexOf("<Datatable1>");
        iDataTableLastIndex = sXMLResult.indexOf("</Datatable1>");

        sData = sXMLResult.substring(iDataTableStartIndex, iDataTableLastIndex + 13);

        sColumnData = sData.replace(/&amp;/g, '&').replace("<Datatable1>", "").replace("</Datatable1>", "").replace(/&gt;/g, '>').replace(/&lt;/g, '<');

        let oBusinessProcessStatelessQueryResult = new BusinessProcessStatelessQueryResult();
        oBusinessProcessStatelessQueryResult.RowNumber = iRowCount;
        oBusinessProcessStatelessQueryResult.QueryResult = [];

        for (var oDCD of oDynamicColumnDetail) {
          iColumnStartIndex = sColumnData.indexOf("<" + oDCD.ColumnName + ">");

          if (iColumnStartIndex >= 0) {
            iColumnLastIndex = sColumnData.indexOf("</" + oDCD.ColumnName + ">");

            sColumnValue = sColumnData.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oDCD.ColumnName + ">").length);

            sValue = sColumnValue.replace("<" + oDCD.ColumnName + ">", "").replace("</" + oDCD.ColumnName + ">", "");

            sColumnData = sColumnData.replace(sColumnValue, "");


          }
          else {
            sValue = "";
            if (sColumnData.indexOf("<" + oDCD.ColumnName + " />") >= 0 || sColumnData.indexOf("<" + oDCD.ColumnName + "/>") >= 0) {
              sColumnData = sColumnData.replace("<" + oDCD.ColumnName + "/>", "").replace("<" + oDCD.ColumnName + " />", "");
            }
          }

          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oDCD.ColumnName;
          oDynamicQueryResult.ColumnType = oDCD.ColumnType;
          oDynamicQueryResult.DataValue = sValue;
          oBusinessProcessStatelessQueryResult.QueryResult.push(oDynamicQueryResult);
        }

        sXMLResult = sXMLResult.replace(sData, '');
        this.__oBusinessProcessStatelessQueryResult.push(oBusinessProcessStatelessQueryResult);

        var oDC = oBusinessProcessStatelessQueryResult;

        let oDataCntext = new BusinessProcessStatelessDataContext();

        oDataCntext.RowNumber = oDC.RowNumber;
        oDataCntext.QueryResult = oDC.QueryResult;

        oDataCntext.DataValue = [];
        oDataCntext.ItemSource = [];
        oDataCntext.MultiSelectedItems = [];
        oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
        oDataCntext.Opened = [];
        oDataCntext.NumberFormat = [];
        oDataCntext.MinNum = [];
        oDataCntext.MaxNum = [];
        oDataCntext.TextSize = [];
        oDataCntext.DataTypeParameter = [];

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);
        oDataCntext.DataTypeParameter.push('');

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);
        oDataCntext.DataTypeParameter.push('');

        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          // Adding Datavalue

          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oDataCntext.DataValue.push(bValue);

          }
          else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
            let iValue: number = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              let bValue: boolean = false;

              if (Number(iValue) == 1) {
                bValue = true;
              }

              oDataCntext.DataValue.push(bValue);

            }
            else {
              oDataCntext.DataValue.push(Number(iValue));
            }

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              if (oColumnValue != null && oColumnValue != '') {
                let sValue: string = oColumn.DataValue;
                let bValue: boolean = false;

                if (sValue.toLowerCase() == 'true' || sValue == '1') {
                  bValue = true;
                }

                oDataCntext.DataValue.push(bValue);
              }
              else {
                let bValue: boolean = false;
                oDataCntext.DataValue.push(bValue);
              }
            }
            else {

              if (oColumnValue != null && oColumnValue != '') {
                oColumnValue = this.__oUtilityService.ReplaceNewLineTabCharacters(oColumnValue.toString()); //fb 37019 Rajendra tab key
                oDataCntext.DataValue.push(oColumnValue);
              }
              else {
                let oEmptyValue = '';
                oDataCntext.DataValue.push(oEmptyValue);
              }
            }
          }

          // Adding Itemsource

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {

              console.log(oSDD.ItemSource);
            }

            oDataCntext.ItemSource.push(oIS);
          }
          else {

            let oItemSource = [];
            oDataCntext.ItemSource.push(oItemSource);
          }


          //Adding multiselected items

          let oMultiSelectedKeys = [];
          oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

          //Adding opened boolean value

          oDataCntext.Opened.push(false);

          // Adding number format , min , max , Text size

          oDataCntext.NumberFormat.push(oSDD.FormatString);
          oDataCntext.MinNum.push(oSDD.Min);
          oDataCntext.MaxNum.push(oSDD.Max);
          oDataCntext.TextSize.push(oSDD.TextSize);
          //Adding a dataType parameter
          oDataCntext.DataTypeParameter.push(oSDD.DataTypeParameter);

        }


        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

          oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {
              console.log(oSDD.ItemSource);
            }
            oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
          }


          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

          }
          if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
            let iValue: number = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              let bValue: boolean = false;

              if (Number(iValue) == 1) {
                bValue = true;
              }

              oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

            }
            else {
              oBusinessProcessStateLessDefinitionDetail.DataValue = Number(iValue);
            }

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              if (oColumnValue != null && oColumnValue != '') {
                let sValue: string = oColumn.DataValue;
                let bValue: boolean = false;

                if (sValue.toLowerCase() == 'true' || sValue == '1') {
                  bValue = true;
                }

                oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;
              }
              else {
                let bValue: boolean = false;
                oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;
              }
            }
            else {

              if (oColumnValue != null && oColumnValue != '')
                oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

              oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
            }
          }

          oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
          oBusinessProcessStateLessDefinitionDetail.Opened = false;

          if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
            oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
          }


          oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

        }



        this.__oBusinessProcessStatelessDataContext.push(oDataCntext);

        iRowCount += 1;
      }

      //for (var oDQR of oDynamicQueryResult) {
      //  let oBusinessProcessStatelessQueryResult = new BusinessProcessStatelessQueryResult();

      //  let oRowNumber = oDQR[0];
      //  let oResult = oDQR[1];

      //  oBusinessProcessStatelessQueryResult.RowNumber = oRowNumber.RowNumber;
      //  oBusinessProcessStatelessQueryResult.QueryResult = [];

      //  for (var oQR of oResult) {
      //    let oDynamicQueryResult = new DynamicQueryResult();
      //    oDynamicQueryResult.ColumnName = oQR.ColumnName;
      //    oDynamicQueryResult.ColumnType = oQR.ColumnType;

      //    oDynamicQueryResult.DataValue = oQR.DataValue;

      //    oBusinessProcessStatelessQueryResult.QueryResult.push(oDynamicQueryResult);
      //  }

      //  this.__oBusinessProcessStatelessQueryResult.push(oBusinessProcessStatelessQueryResult);

      //  var oDC = oBusinessProcessStatelessQueryResult;

      //  let oDataCntext = new BusinessProcessStatelessDataContext();

      //  oDataCntext.RowNumber = oDC.RowNumber;
      //  oDataCntext.QueryResult = oDC.QueryResult;

      //  oDataCntext.DataValue = [];
      //  oDataCntext.ItemSource = [];
      //  oDataCntext.MultiSelectedItems = [];
      //  oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
      //  oDataCntext.Opened = [];
      //  oDataCntext.NumberFormat = [];
      //  oDataCntext.MinNum = [];
      //  oDataCntext.MaxNum = [];
      //  oDataCntext.TextSize = [];

      //  oDataCntext.DataValue.push('');
      //  oDataCntext.ItemSource.push([]);
      //  oDataCntext.MultiSelectedItems.push([]);
      //  oDataCntext.Opened.push(false);
      //  oDataCntext.NumberFormat.push('#,##0.##');
      //  oDataCntext.MinNum.push(0);
      //  oDataCntext.MaxNum.push(99);
      //  oDataCntext.TextSize.push(5000);

      //  oDataCntext.DataValue.push('');
      //  oDataCntext.ItemSource.push([]);
      //  oDataCntext.MultiSelectedItems.push([]);
      //  oDataCntext.Opened.push(false);
      //  oDataCntext.NumberFormat.push('#,##0.##');
      //  oDataCntext.MinNum.push(0);
      //  oDataCntext.MaxNum.push(99);
      //  oDataCntext.TextSize.push(5000);

      //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      //    // Adding Datavalue

      //    let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

      //    if (oColumn.ColumnType.includes('Boolean')) {
      //      let sValue: string = oColumn.DataValue;
      //      let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
      //      oDataCntext.DataValue.push(bValue);

      //    }
      //    else {
      //      let oColumnValue: string = oColumn.DataValue;

      //      if (oColumnValue != null && oColumnValue != '') {
      //        oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g, '\\');
      //        oDataCntext.DataValue.push(oColumnValue);
      //      }
      //      else {
      //        let oEmptyValue = '';
      //        oDataCntext.DataValue.push(oEmptyValue);
      //      }
      //    }

      //    // Adding Itemsource

      //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

      //      let oIS;

      //      try {
      //        oIS = JSON.parse(oSDD.ItemSource);
      //      }
      //      catch{

      //        console.log(oSDD.ItemSource);
      //      }

      //      oDataCntext.ItemSource.push(oIS);
      //    }
      //    else {

      //      let oItemSource = [];
      //      oDataCntext.ItemSource.push(oItemSource);
      //    }


      //    //Adding multiselected items

      //    let oMultiSelectedKeys = [];
      //    oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

      //    //Adding opened boolean value

      //    oDataCntext.Opened.push(false);

      //    // Adding number format , min , max , Text size

      //    oDataCntext.NumberFormat.push(oSDD.FormatString);
      //    oDataCntext.MinNum.push(oSDD.Min);
      //    oDataCntext.MaxNum.push(oSDD.Max);
      //    oDataCntext.TextSize.push(oSDD.TextSize);

      //  }


      //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      //    let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

      //    oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

      //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

      //      let oIS;

      //      try {
      //        oIS = JSON.parse(oSDD.ItemSource);
      //      }
      //      catch{
      //        console.log(oSDD.ItemSource);
      //      }
      //      oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
      //    }


      //    let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

      //    if (oColumn.ColumnType.includes('Boolean')) {
      //      let sValue: string = oColumn.DataValue;
      //      let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
      //      oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

      //    }
      //    else {
      //      let oColumnValue: string = oColumn.DataValue;

      //      if (oColumnValue != null && oColumnValue != '')
      //        oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

      //      oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
      //    }

      //    oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
      //    oBusinessProcessStateLessDefinitionDetail.Opened = false;

      //    if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
      //      oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
      //    }


      //    oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

      //  }



      //  this.__oBusinessProcessStatelessDataContext.push(oDataCntext);



      //}


      //for (var oDC of this.__oBusinessProcessStatelessQueryResult) {
      //  let oDataCntext = new BusinessProcessStatelessDataContext();

      //  oDataCntext.RowNumber = oDC.RowNumber;
      //  oDataCntext.QueryResult = oDC.QueryResult;

      //  oDataCntext.DataValue = [];
      //  oDataCntext.ItemSource = [];
      //  oDataCntext.MultiSelectedItems = [];
      //  oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
      //  oDataCntext.Opened = [];
      //  oDataCntext.NumberFormat = [];
      //  oDataCntext.MinNum = [];
      //  oDataCntext.MaxNum = [];
      //  oDataCntext.TextSize = [];

      //  oDataCntext.DataValue.push('');
      //  oDataCntext.ItemSource.push([]);
      //  oDataCntext.MultiSelectedItems.push([]);
      //  oDataCntext.Opened.push(false);
      //  oDataCntext.NumberFormat.push('#,##0.##');
      //  oDataCntext.MinNum.push(0);
      //  oDataCntext.MaxNum.push(99);
      //  oDataCntext.TextSize.push(5000);

      //  oDataCntext.DataValue.push('');
      //  oDataCntext.ItemSource.push([]);
      //  oDataCntext.MultiSelectedItems.push([]);
      //  oDataCntext.Opened.push(false);
      //  oDataCntext.NumberFormat.push('#,##0.##');
      //  oDataCntext.MinNum.push(0);
      //  oDataCntext.MaxNum.push(99);
      //  oDataCntext.TextSize.push(5000);

      //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      //    // Adding Datavalue

      //    let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

      //    if (oColumn.ColumnType.includes('Boolean')) {
      //      let sValue: string = oColumn.DataValue;
      //      let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
      //      oDataCntext.DataValue.push(bValue);

      //    }
      //    else {
      //      let oColumnValue: string = oColumn.DataValue;

      //      if (oColumnValue != null && oColumnValue != '') {
      //        oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g,'\\');
      //        oDataCntext.DataValue.push(oColumnValue);
      //      }
      //      else {
      //        let oEmptyValue = '';
      //        oDataCntext.DataValue.push(oEmptyValue);
      //      }
      //    }

      //    // Adding Itemsource

      //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

      //      let oIS;

      //      try {
      //         oIS = JSON.parse(oSDD.ItemSource);
      //      }
      //      catch{

      //        console.log(oSDD.ItemSource);
      //      }

      //      oDataCntext.ItemSource.push(oIS);
      //    }
      //    else {

      //      let oItemSource = [];
      //      oDataCntext.ItemSource.push(oItemSource);
      //    }


      //    //Adding multiselected items

      //    let oMultiSelectedKeys = [];
      //    oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

      //    //Adding opened boolean value

      //    oDataCntext.Opened.push(false);

      //    // Adding number format , min , max , Text size

      //    oDataCntext.NumberFormat.push(oSDD.FormatString);
      //    oDataCntext.MinNum.push(oSDD.Min);
      //    oDataCntext.MaxNum.push(oSDD.Max);
      //    oDataCntext.TextSize.push(oSDD.TextSize);

      //  }


      //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      //    let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

      //    oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

      //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

      //      let oIS;

      //      try {
      //        oIS = JSON.parse(oSDD.ItemSource);
      //      }
      //      catch{
      //        console.log(oSDD.ItemSource);
      //      }
      //      oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
      //    }


      //    let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

      //    if (oColumn.ColumnType.includes('Boolean')) {
      //      let sValue: string = oColumn.DataValue;
      //      let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
      //      oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

      //    }
      //    else {
      //      let oColumnValue: string = oColumn.DataValue;

      //      if (oColumnValue != null && oColumnValue != '')
      //        oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

      //      oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
      //    }

      //    oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
      //    oBusinessProcessStateLessDefinitionDetail.Opened = false;

      //    if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null)
      //    {
      //      oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
      //    }


      //    oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

      //  }



      //  this.__oBusinessProcessStatelessDataContext.push(oDataCntext);

      //}

    }


    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateLessActionDetail/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId).then((Data) => {

      if (Data != null) {

        this.__oBusinessProcessStateLessActionDetail = Data;

        let oStatelessAction: Action[] = [];

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
          if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oAction = new Action();
            oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            oStatelessAction.push(oAction);
          }
        }

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 1)) {
          if (this.__oBusinessProcessStateLessCommonAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oCommonAction = new Action();
            oCommonAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oCommonAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            this.__oBusinessProcessStateLessCommonAction.push(oCommonAction);
          }
        }

        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

          oBusinessProcessStatelessDataContext.Actions = oStatelessAction;

        }

        let oActionColumnWidth: number = 130;

        if (oStatelessAction.length > 0) {
          oActionColumnWidth = oStatelessAction.length * 130;
        }

        this.__oStatelesscolumns.push({
          cellTemplate: 'cellTemplate',
          width: oActionColumnWidth,
          allowHiding: false,
          showInColumnChooser: false
        })


      }
      else {
        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

        }
        this.__bIsLoadingVisible = false;
      }

    });

    //try {
    //  if (this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details').length > 0) {
    //    this.__oStatelessGridMasterDetailOption = { enabled: true, template: 'detail' };
    //  }
    //  else {
    //    this.__oStatelessGridMasterDetailOption = { enabled: false, template: 'detail' }
    //  }
    //}
    //catch{ this.__oStatelessGridMasterDetailOption = { enabled: true, template: 'detail' };}
    if (this.__oStatelessGridFilters != null && this.__oStatelessGridFilters != undefined) {
      this.dataGrid.instance.filter(this.__oStatelessGridFilters);
      this.__oStatelessGridFilters = null;
    }

    if (this.__oStatelessGridSortings != null && this.__oStatelessGridSortings != undefined && this.__oStatelesscolumns != null && this.__oStatelesscolumns != undefined) {

      for (var oColumnOptions of this.__oStatelesscolumns) {
        let oColumn = this.__oStatelessGridSortings.find(x => x.caption == oColumnOptions.caption);

        if (oColumn != null) {
          if (oColumn.sortOrder != undefined) {
            oColumnOptions.sortOrder = oColumn.sortOrder;
          }
        }
      }

      this.__oStatelessGridSortings = null;
    }

    this.__bIsLoadingVisible = false;
  }

  PopulateDynamicGridMDX(e: BusinessProcessStatelessInstanceViewModel) {
    let oBusinessProcessStatelessInstanceViewModel: BusinessProcessStatelessInstanceViewModel = e;

    if (oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource != null) {
      this.__oBusinessProcessStatelessQueryResult = [];


      try {
        var oDynamicQueryResult = JSON.parse(oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource);
      }
      catch {
        console.log(oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource);
      }




      // Generating grid columns

      let iColumnIndex: number = 2;
      let oCurrentComponant = this;

      this.__oStatelessColumnDetail.push('SelectionCheckBox');
      this.__oStatelessColumnDetail.push('MasterDetail');

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {

        this.__oStatelessColumnDetail.push(oSDD.ColumnName);

        if (oSDD.IsInput == 1) {
          if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateDate',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              dataType: 'date',
              format: 'dd-MMM-yyyy'
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateCheckBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            this.__oMultiSelectControlColumnIndex.push(iColumnIndex);

            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiSelect',
              //calculateCellValue: function (rowData) {
              //  let column = this as any;
              //  return that.calculateStatelessGridMultiselectCellValue(rowData, column);
              //},
              //cellTemplate: 'cellTemplateMultiSelect',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              //setCellValue: function (rowData: any, value: any, currentRow: any) {
              //  console.log(rowData);

              //}
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Combo Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateComboBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Auto Complete Box Sql') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAutoComplete',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAmount',
              //cellTemplate: 'cellTemplateAmount',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              //allowEditing: true,
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              format: "#,##0.00",
              dataType: 'number'
            })
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateMultilineReadOnly',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
        }
        else {
          if (oSDD.lwfBusinessProcessStatelessInputTypeId != null) {
            if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateDateReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                dataType: 'date',
                format: 'dd-MMM-yyyy'
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateCheckBoxReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateAmountReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                format: "#,##0.##",
                dataType: 'number'
              })
            }
            else {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate: 'cellTemplateMultiline',
                //cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false

              })
            }
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
        }

        iColumnIndex += 1;

      }


      //for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder))
      //{

      //}

      //for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' || x.IsDisplay == 0).sort(x => x.DisplayOrder)) {
      //  this.__oStatelesscolumns.push({
      //    dataField: '',
      //    caption: oSDD.ColumnName,
      //    //dataField: oSDD.ColumnHeader,
      //    //cellTemplate: 'cellTemplateMultilineInvisible',
      //    width: oSDD.Width,
      //    calculateCellValue: function (rowData) {
      //      let column = this as any;
      //      return oCurrentComponant.calculateStatelessGridCellValue(rowData, column);
      //    },
      //    calculateSortValue: function (rowData) {
      //      let column = this as any;
      //      return oCurrentComponant.calculateStatelessGridCellSortValue(rowData, column);
      //    },
      //    //sortOrder: 'asc',
      //    allowSorting: true,
      //    allowFiltering: true,
      //    allowReordering: true,
      //    allowHiding: true,
      //    visible: false,
      //    showInColumnChooser: true,
      //    dataType: 'string'
      //  })
      //}


      // Generating data context for grid

      for (var oDQR of oDynamicQueryResult) {
        let oBusinessProcessStatelessQueryResult = new BusinessProcessStatelessQueryResult();

        let oRowNumber = oDQR[0];
        let oResult = oDQR[1];

        oBusinessProcessStatelessQueryResult.RowNumber = oRowNumber.RowNumber;
        oBusinessProcessStatelessQueryResult.QueryResult = [];

        for (var oQR of oResult) {
          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oQR.ColumnName;
          oDynamicQueryResult.ColumnType = oQR.ColumnType;

          oDynamicQueryResult.DataValue = oQR.DataValue;

          oBusinessProcessStatelessQueryResult.QueryResult.push(oDynamicQueryResult);
        }

        this.__oBusinessProcessStatelessQueryResult.push(oBusinessProcessStatelessQueryResult);

        var oDC = oBusinessProcessStatelessQueryResult;

        let oDataCntext = new BusinessProcessStatelessDataContext();

        oDataCntext.RowNumber = oDC.RowNumber;
        oDataCntext.QueryResult = oDC.QueryResult;

        oDataCntext.DataValue = [];
        oDataCntext.ItemSource = [];
        oDataCntext.MultiSelectedItems = [];
        oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
        oDataCntext.Opened = [];
        oDataCntext.NumberFormat = [];
        oDataCntext.MinNum = [];
        oDataCntext.MaxNum = [];
        oDataCntext.TextSize = [];

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);

        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          // Adding Datavalue

          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oDataCntext.DataValue.push(bValue);

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oColumnValue != null && oColumnValue != '') {
              oColumnValue = this.__oUtilityService.ReplaceNewLineTabCharacters(oColumnValue.toString()); //fb 37019 Rajendra tab key
              oDataCntext.DataValue.push(oColumnValue);
            }
            else {
              let oEmptyValue = '';
              oDataCntext.DataValue.push(oEmptyValue);
            }
          }

          // Adding Itemsource

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {

              console.log(oSDD.ItemSource);
            }

            oDataCntext.ItemSource.push(oIS);
          }
          else {

            let oItemSource = [];
            oDataCntext.ItemSource.push(oItemSource);
          }


          //Adding multiselected items

          let oMultiSelectedKeys = [];
          oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

          //Adding opened boolean value

          oDataCntext.Opened.push(false);

          // Adding number format , min , max , Text size

          oDataCntext.NumberFormat.push(oSDD.FormatString);
          oDataCntext.MinNum.push(oSDD.Min);
          oDataCntext.MaxNum.push(oSDD.Max);
          oDataCntext.TextSize.push(oSDD.TextSize);

        }


        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

          oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {
              console.log(oSDD.ItemSource);
            }
            oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
          }


          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oColumnValue != null && oColumnValue != '')
              oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

            oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
          }

          oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
          oBusinessProcessStateLessDefinitionDetail.Opened = false;

          if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
            oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
          }


          oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

        }



        this.__oBusinessProcessStatelessDataContext.push(oDataCntext);



      }


      //for (var oDC of this.__oBusinessProcessStatelessQueryResult) {
      //  let oDataCntext = new BusinessProcessStatelessDataContext();

      //  oDataCntext.RowNumber = oDC.RowNumber;
      //  oDataCntext.QueryResult = oDC.QueryResult;

      //  oDataCntext.DataValue = [];
      //  oDataCntext.ItemSource = [];
      //  oDataCntext.MultiSelectedItems = [];
      //  oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
      //  oDataCntext.Opened = [];
      //  oDataCntext.NumberFormat = [];
      //  oDataCntext.MinNum = [];
      //  oDataCntext.MaxNum = [];
      //  oDataCntext.TextSize = [];

      //  oDataCntext.DataValue.push('');
      //  oDataCntext.ItemSource.push([]);
      //  oDataCntext.MultiSelectedItems.push([]);
      //  oDataCntext.Opened.push(false);
      //  oDataCntext.NumberFormat.push('#,##0.##');
      //  oDataCntext.MinNum.push(0);
      //  oDataCntext.MaxNum.push(99);
      //  oDataCntext.TextSize.push(5000);

      //  oDataCntext.DataValue.push('');
      //  oDataCntext.ItemSource.push([]);
      //  oDataCntext.MultiSelectedItems.push([]);
      //  oDataCntext.Opened.push(false);
      //  oDataCntext.NumberFormat.push('#,##0.##');
      //  oDataCntext.MinNum.push(0);
      //  oDataCntext.MaxNum.push(99);
      //  oDataCntext.TextSize.push(5000);

      //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      //    // Adding Datavalue

      //    let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

      //    if (oColumn.ColumnType.includes('Boolean')) {
      //      let sValue: string = oColumn.DataValue;
      //      let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
      //      oDataCntext.DataValue.push(bValue);

      //    }
      //    else {
      //      let oColumnValue: string = oColumn.DataValue;

      //      if (oColumnValue != null && oColumnValue != '') {
      //        oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g,'\\');
      //        oDataCntext.DataValue.push(oColumnValue);
      //      }
      //      else {
      //        let oEmptyValue = '';
      //        oDataCntext.DataValue.push(oEmptyValue);
      //      }
      //    }

      //    // Adding Itemsource

      //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

      //      let oIS;

      //      try {
      //         oIS = JSON.parse(oSDD.ItemSource);
      //      }
      //      catch{

      //        console.log(oSDD.ItemSource);
      //      }

      //      oDataCntext.ItemSource.push(oIS);
      //    }
      //    else {

      //      let oItemSource = [];
      //      oDataCntext.ItemSource.push(oItemSource);
      //    }


      //    //Adding multiselected items

      //    let oMultiSelectedKeys = [];
      //    oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

      //    //Adding opened boolean value

      //    oDataCntext.Opened.push(false);

      //    // Adding number format , min , max , Text size

      //    oDataCntext.NumberFormat.push(oSDD.FormatString);
      //    oDataCntext.MinNum.push(oSDD.Min);
      //    oDataCntext.MaxNum.push(oSDD.Max);
      //    oDataCntext.TextSize.push(oSDD.TextSize);

      //  }


      //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      //    let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

      //    oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

      //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

      //      let oIS;

      //      try {
      //        oIS = JSON.parse(oSDD.ItemSource);
      //      }
      //      catch{
      //        console.log(oSDD.ItemSource);
      //      }
      //      oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
      //    }


      //    let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

      //    if (oColumn.ColumnType.includes('Boolean')) {
      //      let sValue: string = oColumn.DataValue;
      //      let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
      //      oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

      //    }
      //    else {
      //      let oColumnValue: string = oColumn.DataValue;

      //      if (oColumnValue != null && oColumnValue != '')
      //        oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

      //      oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
      //    }

      //    oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
      //    oBusinessProcessStateLessDefinitionDetail.Opened = false;

      //    if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null)
      //    {
      //      oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
      //    }


      //    oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

      //  }



      //  this.__oBusinessProcessStatelessDataContext.push(oDataCntext);

      //}

    }


    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateLessActionDetail/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId).then((Data) => {

      if (Data != null) {

        this.__oBusinessProcessStateLessActionDetail = Data;

        let oStatelessAction: Action[] = [];

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
          if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oAction = new Action();
            oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            oStatelessAction.push(oAction);
          }
        }

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 1)) {
          if (this.__oBusinessProcessStateLessCommonAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oCommonAction = new Action();
            oCommonAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oCommonAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            this.__oBusinessProcessStateLessCommonAction.push(oCommonAction);
          }
        }

        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

          oBusinessProcessStatelessDataContext.Actions = oStatelessAction;

        }

        let oActionColumnWidth: number = 100;

        if (oStatelessAction.length > 0) {
          oActionColumnWidth = oStatelessAction.length * 110;
        }

        this.__oStatelesscolumns.push({
          cellTemplate: 'cellTemplate',
          width: oActionColumnWidth,
          allowHiding: false,
          showInColumnChooser: false
        })


      }
      else {
        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

        }
        this.__bIsLoadingVisible = false;
      }

    });

    //try {
    //  if (this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details').length > 0) {
    //    this.__oStatelessGridMasterDetailOption = { enabled: true, template: 'detail' };
    //  }
    //  else {
    //    this.__oStatelessGridMasterDetailOption = { enabled: false, template: 'detail' }
    //  }
    //}
    //catch{ this.__oStatelessGridMasterDetailOption = { enabled: true, template: 'detail' };}

    this.__bIsLoadingVisible = false;
  }

  TestStateLess(e: any, info: any) {
    let Value = this.__oStatelessGridSelectedKeys;
    alert(info.lTradingcounterpartyId);

  }

  ExecuteStatelessUserAction(e: any, info: any) {
    this.__oBusinessProcessStateLessActionExecuteWebUrls = [];
    let lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    let lwfBusinessProcessStatelessActionId = info.ID;

    let oBusinessProcessStateLessActionDetails: BusinessProcessStateLessActionDetail[] = this.__oBusinessProcessStateLessActionDetail.filter(x => x.lwfBusinessProcessStatelessActionId == lwfBusinessProcessStatelessActionId);

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == e);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }


    if (oBusinessProcessStateLessGridDataContext.RowStatus == undefined || oBusinessProcessStateLessGridDataContext.RowStatus == null || oBusinessProcessStateLessGridDataContext.RowStatus == '')
      sXMLData += '<RowStatus>Updated</RowStatus>';
    else
      sXMLData += '<RowStatus>' + oBusinessProcessStateLessGridDataContext.RowStatus + '</RowStatus>';

    let oBusinessProcessStatelessUserAction = new BusinessProcessStatelessUserAction();
    oBusinessProcessStatelessUserAction.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessUserAction.lwfBusinessProcessStatelessActionId = lwfBusinessProcessStatelessActionId;
    oBusinessProcessStatelessUserAction.sXMLProcessStatelessData = sXMLData;


    let bServerCallRequired: boolean = false;

    for (let owfBusinessProcessStatelessActionExecute of oBusinessProcessStateLessActionDetails) {
      if (owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != null && owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != '') {
        let sWebUrl: string = '';
        sWebUrl = owfBusinessProcessStatelessActionExecute.OpenFormWebUrl;

        let i: number = 0;

        while (i == 0) {
          let iLastIndexOpenBrace: number = 0;
          let iLastIndexCloseBrace: number = 0;

          iLastIndexOpenBrace = sWebUrl.lastIndexOf("[");
          iLastIndexCloseBrace = sWebUrl.lastIndexOf("]");

          if (iLastIndexOpenBrace > 0 && iLastIndexCloseBrace > 0) {
            if (iLastIndexOpenBrace < iLastIndexCloseBrace) {
              let sReplaceString: string = sWebUrl.substring(iLastIndexOpenBrace, iLastIndexCloseBrace + 1);

              let oReplaceDataValue = oRowData.find(x => x.ColumnName == sReplaceString.replace("[", "").replace("]", ""));

              if (sWebUrl.startsWith("mailto:")) {
                sWebUrl = sWebUrl.replace(sReplaceString, oReplaceDataValue.DataValue);
              }
              else {
                sWebUrl = sWebUrl.replace(sReplaceString, this.URLEncode(oReplaceDataValue.DataValue));
              }
            }
          }
          else {
            i = 1;
          }
        }

        this.__oBusinessProcessStateLessActionExecuteWebUrls.push(sWebUrl);



      }
      else {
        bServerCallRequired = true;
      }

    }

    if (bServerCallRequired) {

      this.service.UpdateAllDataByPromise(oBusinessProcessStatelessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostStatelessUserAction").then(
        result => this.OnSuccessSaveStateless(result)
      ).
        catch(error => this.OnErrorStateless(error))
    }
    else {
      for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
        window.open(oWebUrl, "_blank");
      }

    }


  }

  ExecuteStatelessUserActionCommon(e: any, info: any) {
    if (this.__oStatelessGridSelectedKeys != null && this.__oStatelessGridSelectedKeys.length > 0) {
      this.__oBusinessProcessStateLessActionExecuteWebUrls = [];
      let lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
      let lwfBusinessProcessStatelessActionId = info.ID;

      let oBusinessProcessStateLessActionDetails: BusinessProcessStateLessActionDetail[] = this.__oBusinessProcessStateLessActionDetail.filter(x => x.lwfBusinessProcessStatelessActionId == lwfBusinessProcessStatelessActionId);

      let sXMLData: string = '';

      for (var oSelectedRow of this.__oStatelessGridSelectedKeys) {
        let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == oSelectedRow);

        let oRowData: DynamicQueryResult[] = [];

        let iIndex: number = 0;

        // Creating column array with value

        for (var oColumnDetail of this.__oStatelessColumnDetail) {
          let oColumnName = oColumnDetail;
          let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

          let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

          let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


          if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
            if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
              oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
            }
          }
          else {
            oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
          }

          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oColumnName;
          oDynamicQueryResult.DataValue = oDataValue;

          oRowData.push(oDynamicQueryResult);

          iIndex += 1;

        }



        if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
          for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

            let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

            let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

            let oDynamicQueryResult = new DynamicQueryResult();
            let oDetailColumnDataValue;

            if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
              if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
                oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
              }
            }
            else {

              if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

                if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
                  oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
                }

              }
              else {
                oDetailColumnDataValue = oDetailColumn.DataValue;
              }

            }

            oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
            oDynamicQueryResult.DataValue = oDetailColumnDataValue;

            oRowData.push(oDynamicQueryResult);
          }

        }

        for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
          if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
            let oDynamicQueryResult = new DynamicQueryResult();
            oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

            if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
              let sValue: string = oOtherRowData.DataValue;

              if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
                oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
              }
              else {
                oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
              }
            }
            else {
              oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
            }

            oRowData.push(oDynamicQueryResult);
          }
        }

        // Creating string stateless row data in XML format

        sXMLData += "<Data>";

        for (var oStatelessRowData of oRowData) {
          sXMLData += "<" + oStatelessRowData.ColumnName + ">";

          if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
            let sValue: string = oStatelessRowData.DataValue;

            if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
              sXMLData += oStatelessRowData.DataValue;
            }
            else {
              sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
            }
          }
          else {
            sXMLData += oStatelessRowData.DataValue;
          }

          sXMLData += "</" + oStatelessRowData.ColumnName + ">";
        }

        if (oBusinessProcessStateLessGridDataContext.RowStatus == undefined || oBusinessProcessStateLessGridDataContext.RowStatus == null || oBusinessProcessStateLessGridDataContext.RowStatus == '')
          sXMLData += '<RowStatus>Updated</RowStatus>';
        else
          sXMLData += '<RowStatus>' + oBusinessProcessStateLessGridDataContext.RowStatus + '</RowStatus>'

        sXMLData += "</Data>";

      }

      sXMLData = "<RowData>" + sXMLData + "</RowData>"

      let oBusinessProcessStatelessUserAction = new BusinessProcessStatelessUserAction();
      oBusinessProcessStatelessUserAction.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
      oBusinessProcessStatelessUserAction.lwfBusinessProcessStatelessActionId = lwfBusinessProcessStatelessActionId;
      oBusinessProcessStatelessUserAction.sXMLProcessStatelessData = sXMLData;


      let bServerCallRequired: boolean = false;

      for (let owfBusinessProcessStatelessActionExecute of oBusinessProcessStateLessActionDetails) {
        if (owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != null && owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != '') {
          let sWebUrl: string = '';
          sWebUrl = owfBusinessProcessStatelessActionExecute.OpenFormWebUrl;

          //let i: number = 0;

          //while (i == 0) {
          //  let iLastIndexOpenBrace: number = 0;
          //  let iLastIndexCloseBrace: number = 0;

          //  iLastIndexOpenBrace = sWebUrl.lastIndexOf("[");
          //  iLastIndexCloseBrace = sWebUrl.lastIndexOf("]");

          //  if (iLastIndexOpenBrace > 0 && iLastIndexCloseBrace > 0) {
          //    if (iLastIndexOpenBrace < iLastIndexCloseBrace) {
          //      let sReplaceString: string = sWebUrl.substring(iLastIndexOpenBrace, (iLastIndexCloseBrace - iLastIndexOpenBrace + 1));

          //      let oReplaceDataValue = oRowData.find(x => x.ColumnName == sReplaceString.replace("[", "").replace("]", ""));

          //      if (sWebUrl.startsWith("mailto:")) {
          //        sWebUrl = sWebUrl.replace(sReplaceString, oReplaceDataValue.DataValue);
          //      }
          //      else {
          //        sWebUrl = sWebUrl.replace(sReplaceString, this.URLEncode(oReplaceDataValue));
          //      }
          //    }
          //  }
          //  else {
          //    i = 1;
          //  }
          //}

          this.__oBusinessProcessStateLessActionExecuteWebUrls.push(sWebUrl);



        }
        else {
          bServerCallRequired = true;
        }

      }

      if (bServerCallRequired) {

        this.service.UpdateAllDataByPromise(oBusinessProcessStatelessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostStatelessCommonUserAction").then(
          result => this.OnSuccessSaveStateless(result)
        ).
          catch(error => this.OnErrorStateless(error))
      }
      else {
        for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
          window.open(oWebUrl, "_blank");
        }

      }
    }
    else {
      alert('Please select row.');
    }
  }

  private OnErrorStateless(error: any) {
    this.__bIsLoadingVisible = false;
    if (error != null) {
      this.__oConfirmationComponent.show(ConfirmationType.Error,
        error,
        "Error", "Ok", "Cancel", false);
    }
  }
  private OnSuccessSaveStateless(response: any) {

    if (response != null) {

      var oResponse: string = response;

      if (oResponse == 'Success') {

        for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
          window.open(oWebUrl, "_blank");
        }

        this.__oStatelessGridFilters = this.dataGrid.instance.getCombinedFilter();
        this.__oStatelessGridSortings = this.dataGrid.instance.getVisibleColumns();

        this.RefreshStatelessGrid();
      }
      else {
        this.__oConfirmationComponent.show(ConfirmationType.Error,
          oResponse,
          "Error", "Ok", "Cancel", false);
      }

    }

  }

  GetDataForStateLessACB(ColumnIndex: any, RowIndex: any, RowNumber: any, element: any) {
    //let self = this;
    //this.__oElement = element;
    let ColumnName = this.__oStatelessColumnDetail[ColumnIndex];
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStatelessDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
      let oItemSource: ItemSource[] = oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex];

      FilterValue = this.replaceAll(FilterValue);

      if (oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
          return;
        }
      }

      let sXMLData: string = this.GetStatelessRowDataXML(oBusinessProcessStatelessDataContext);
      sXMLData = this.replaceAll(sXMLData);
      sXMLData = sXMLData.replace(/\*/g, 'staaar')
      this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(RowIndex, ColumnIndex));
      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessItemSourceForAutoCompleteBox/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + ColumnName + "/" + FilterValue + "/" + sXMLData).then((Data) => {

        if (Data != null) {

          let oIS;

          try {
            oIS = JSON.parse(Data);
          }
          catch {
            console.log(Data);
          }
          oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex] = oIS;

          let oItemSource: ItemSource[] = oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex];
          if (oItemSource != undefined && oItemSource.length > 0) { oBusinessProcessStatelessDataContext.Opened[ColumnIndex] = true; }
          this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(RowIndex, ColumnIndex));
          //self.__oElement.element.getElementsByClassName("dx-texteditor-input")[0].selectionStart = 2;
          //self.__oElement.element.getElementsByClassName("dx-texteditor-input")[0].selectionEnd = 2;
          //self.__oElement.element.setSelectionRange(2,2);
        }

      });
    }
    else {
      this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(RowIndex, ColumnIndex));
    }

    //element.element.getElementsByClassName("dx-texteditor-input")[0].selectionStart = 2;
    //element.element.getElementsByClassName("dx-texteditor-input")[0].selectionEnd = 2;

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(RowNumber);

    //let sItemSOurce1 = '[{"DisplayMember":"BarclaysACB"},{"DisplayMember":"BNPACB"}]';
    //let oIS1 = JSON.parse(sItemSOurce1);
    //oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex] = oIS1;
    //this.opened = true;

    //let Row = this.__oStatelessDataContext[0];

    //Row.ItemSource[2] = oIS1;
  }

  StateLessACBonFocusIn(ColumnIndex: any, RowIndex: any, RowNumber: any, element: any) {
    let ColumnName = this.__oStatelessColumnDetail[ColumnIndex];
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue: string = oBusinessProcessStatelessDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined && FilterValue.length > 0) {
      if (element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange) {
        element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange(FilterValue.length, FilterValue.length);
      }
      else if (element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange) {
        var range = element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange();
        range.collapse(true);
        range.moveEnd('character', FilterValue.length);
        range.moveStart('character', FilterValue.length);
        range.select();
      }

      //element.element.getElementsByClassName("dx-texteditor-input")[0].selectionStart = FilterValue.length;
      //element.element.getElementsByClassName("dx-texteditor-input")[0].selectionEnd = FilterValue.length;
      //element.element.setSelectionRange(FilterValue.length, FilterValue.length);
    }


  }

  GetDataForStateLessDetailACB(RowNumber: any, ColumnName: any) {
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    if (oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      let BusinessProcessStateLessDefinitionDetail = oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails.find(x => x.ColumnName == ColumnName);

      let FilterValue = BusinessProcessStateLessDefinitionDetail.DataValue;

      if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
        let oItemSource: ItemSource[] = BusinessProcessStateLessDefinitionDetail.ItemSource;

        FilterValue = this.replaceAll(FilterValue);

        if (oItemSource != undefined && oItemSource.length > 0) {
          if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
            return;
          }
        }

        let sXMLData: string = this.GetStatelessRowDataXML(oBusinessProcessStatelessDataContext);
        sXMLData = this.replaceAll(sXMLData);
        sXMLData = sXMLData.replace(/\*/g, 'staaar')
        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessItemSourceForAutoCompleteBox/" + this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId.toString() + "/" + ColumnName + "/" + FilterValue + "/" + sXMLData).then((Data) => {

          if (Data != null) {

            let oIS;

            try {
              oIS = JSON.parse(Data);
            }
            catch {
              console.log(Data);
            }
            BusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
            if (BusinessProcessStateLessDefinitionDetail.ItemSource != undefined && BusinessProcessStateLessDefinitionDetail.ItemSource.length > 0) { BusinessProcessStateLessDefinitionDetail.Opened = true; }
          }

        });
      }

    }

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(RowNumber);

  }

  GetStatelessRowDataXML(oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext): string {
    let sXMLData: string = '';

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    return sXMLData;

  };

  calculateCellValue(e: any) {
    return 1;
  }

  calculateStatelessGridCellValue(Row: any, Column: any) {
    //let QueryResult = Row;
    let oColumn = Row.QueryResult.find(x => x.ColumnName == Column.caption);
    let oColumnValue = oColumn.DataValue;
    return oColumnValue;
  }

  calculateStatelessGridCellSortValue(Row: any, Column: any) {
    //let QueryResult = Row;
    let oColumn = Row.QueryResult.find(x => x.ColumnName == Column.caption);

    let sType: string = oColumn.ColumnType;

    var oColumnValue;

    if (sType.includes('Int') || sType.includes('Double') || sType.includes('Decimal') || sType.includes('Float')) {
      if (oColumn.DataValue != null && oColumn.DataValue != undefined && oColumn.DataValue != '')
        oColumnValue = parseFloat(oColumn.DataValue);
      else
        oColumnValue = parseFloat('0');
    }
    else if (sType.includes('Date')) {
      if (oColumn.DataValue != null && oColumn.DataValue != undefined && oColumn.DataValue != '')
        oColumnValue = new Date(oColumn.DataValue);
      else
        oColumnValue = new Date(null);
    }
    else {
      oColumnValue = oColumn.DataValue;
    }

    return oColumnValue;
  }

  syncDataValueWithSelection(RowNumber: any, columnIndex: any) {
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[columnIndex];

    let sSelectedItems = '';

    for (var oArraySelectedItem of oArraySelectedItems) {
      if (sSelectedItems == '') {
        sSelectedItems += oArraySelectedItem;
      }
      else {
        sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
      }

    }

    oBusinessProcessStatelessDataContext.DataValue[columnIndex] = sSelectedItems;
    //this.dataGrid.instance.refresh();
  }

  calculateStatelessGridMultiselectCellValue(Row: any, Column: any) {
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == Row.RowNumber);

    let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[Column.index];

    let sSelectedItems = '';

    for (var oArraySelectedItem of oArraySelectedItems) {
      if (sSelectedItems == '') {
        sSelectedItems += oArraySelectedItem;
      }
      else {
        sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
      }

    }

    oBusinessProcessStatelessDataContext.DataValue[Column.index] = sSelectedItems;
  }





  onKeyPressNumberBoxSLGrid(e: any, RowNumber: any, ColumnIndex: any, rowIndex: any) {
    if (e.event.key.toString().toUpperCase() == "M" || e.event.key.toString().toUpperCase() == "B" || e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "H" || e.event.key.toString().toUpperCase() == "T") {
      this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(rowIndex, ColumnIndex));
      if (e.event.key.toString().toUpperCase() == "M") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);
        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
      }
      else if (e.event.key.toString().toUpperCase() == "B") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
      }
      else if (e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "T") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
      }
      else if (e.event.key.toString().toUpperCase() == "H") {
        //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
      }
    }



  }


  onKeyPressNumberBoxSLDetail(e: any, BusinessProcessStateLessDefinitionDetail: any, RowNumber: any) {
    //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    //if (oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {

    //let BusinessProcessStateLessDefinitionDetail = oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails.find(x => x.ColumnName == ColumnName);

    //if (e.event.key != 'Backspace')
    {

      if (BusinessProcessStateLessDefinitionDetail.DataValue != null && BusinessProcessStateLessDefinitionDetail.DataValue != undefined) {
        if (e.event.key == 'm' || e.event.key == "M") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
        }
        else if (e.event.key == "b" || e.event.key == "B") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
        }
        else if (e.event.key == "k" || e.event.key == "K") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
        }
        else if (e.event.key == "h" || e.event.key == "H") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
        }
        else if (e.event.key == "t" || e.event.key == "T") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
        }
      }
    }

    //}


  }

  StatelessGridColumnValueChanged(e: any, columnIndex: any) {
    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == e).length == 0)
      this.__oStatelessGridSelectedKeys.push(e);

    this.GetStatelessDependantDataItemSource(e, columnIndex);
  }

  StatelessGridDetailColumnValueChanged(e: any, header: any, ColumnName: any) {
    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == e).length == 0)
      this.__oStatelessGridSelectedKeys.push(e);

    this.GetStatelessDependantDataItemSourceDetailSection(e, ColumnName);
  }


  GetStatelessDependantDataItemSource(RowNumber: any, columnIndex: any) {

    let lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    let sColumnName = this.__oStatelessColumnDetail[columnIndex];

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    let oBusinessProcessStatelessDependantDataItemSource = new BusinessProcessStatelessDependantDataItemSource();
    oBusinessProcessStatelessDependantDataItemSource.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessDependantDataItemSource.sColumnName = sColumnName;
    oBusinessProcessStatelessDependantDataItemSource.sXMLProcessStatelessData = sXMLData;


    this.service.UpdateAllDataByPromise(oBusinessProcessStatelessDependantDataItemSource, this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessDependantDataItemSource").then(
      result => this.OnSuccessGetStatelessDependantDataItemSource(result, RowNumber, columnIndex)
    ).
      catch(error => this.OnErrorGetStatelessDependantDataItemSource(error))

  }

  GetStatelessDependantDataItemSourceDetailSection(RowNumber: any, ColumnName: any) {

    let lwfBusinessProcessDefinitionId = this.__oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId;
    let sColumnName = ColumnName;

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    let oBusinessProcessStatelessDependantDataItemSource = new BusinessProcessStatelessDependantDataItemSource();
    oBusinessProcessStatelessDependantDataItemSource.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessDependantDataItemSource.sColumnName = sColumnName;
    oBusinessProcessStatelessDependantDataItemSource.sXMLProcessStatelessData = sXMLData;


    this.service.UpdateAllDataByPromise(oBusinessProcessStatelessDependantDataItemSource, this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessDependantDataItemSource").then(
      result => this.OnSuccessGetStatelessDependantDataItemSourceDetail(result, RowNumber, ColumnName)
    ).
      catch(error => this.OnErrorGetStatelessDependantDataItemSource(error))

  }

  private OnErrorGetStatelessDependantDataItemSource(error: any) {
    console.log(error);
  }
  private OnSuccessGetStatelessDependantDataItemSource(response: any, RowNumber: any, columnIndex: any) {

    if (response != null) {

      let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);
      let iColumnIndex: number = 2;

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {


        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);

        if (oBusinessProcessStateLessDefinitionDetail != null) {

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {

              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }

            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oIS;
          }
          else {

            let oItemSource = [];
            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oItemSource;
          }



        }

        iColumnIndex += 1;


      }


      for (var oSDD of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);


        if (oBusinessProcessStateLessDefinitionDetail != null) {

          oSDD.ItemSource = [];

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {
              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            oSDD.ItemSource = oIS;
          }

        }



      }

    }

  }

  private OnSuccessGetStatelessDependantDataItemSourceDetail(response: any, RowNumber: any, ColumnName: any) {

    if (response != null) {

      let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);
      let iColumnIndex: number = 2;

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {


        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);

        if (oBusinessProcessStateLessDefinitionDetail != null) {

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {

              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }

            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oIS;
          }
          else {

            let oItemSource = [];
            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oItemSource;
          }
        }

        iColumnIndex += 1;


      }


      for (var oSDD of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);


        if (oBusinessProcessStateLessDefinitionDetail != null) {

          oSDD.ItemSource = [];

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {
              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            oSDD.ItemSource = oIS;
          }

        }



      }

    }

  }

  //onEditorPreparing(e: any) {
  //  //alert('hi editor');

  //  //e.editorOptions.onFocusOut = function (args) {
  //  //  alert('hi');
  //  //}

  //  e.editorOptions.onFocusOut = (args: any) => {
  //    alert('hi on focus');
  //  }

  //}

  onCellPrepared(e: any) {
    //alert('hi cell');
    if (e.data != undefined && e.data != null) {

      if (this.__oMultiSelectControlColumnIndex.length > 0 && this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0) {
        let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == e.data.RowNumber);

        let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[e.columnIndex];

        if (oArraySelectedItems != null && oArraySelectedItems != undefined) {
          let sSelectedItems = '';

          for (var oArraySelectedItem of oArraySelectedItems) {
            if (sSelectedItems == '') {
              sSelectedItems += oArraySelectedItem;
            }
            else {
              sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
            }

          }
          oBusinessProcessStatelessDataContext.DataValue[e.columnIndex] = sSelectedItems;

        }
      }
    }

  }

  onFocusedCellChanging(e: any) {
    if (e.data != undefined && e.data != null) {

      if (this.__oMultiSelectControlColumnIndex.length > 0 && this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0) {
        let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == e.data.RowNumber);

        let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[e.columnIndex];

        if (oArraySelectedItems != null && oArraySelectedItems != undefined) {
          let sSelectedItems = '';

          for (var oArraySelectedItem of oArraySelectedItems) {
            if (sSelectedItems == '') {
              sSelectedItems += oArraySelectedItem;
            }
            else {
              sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
            }

          }
          oBusinessProcessStatelessDataContext.DataValue[e.columnIndex] = sSelectedItems;

        }
      }
    }
  }

  OnKeyDown(e: any) {
    if (e.event.key == 'Tab') {
      if (this.__oMultiSelectControlColumnIndex.length > 0 /*&& this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0*/) {

        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {

          for (var oMultiSelectColumnIndex of this.__oMultiSelectControlColumnIndex) {

            let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[oMultiSelectColumnIndex];

            if (oArraySelectedItems != null && oArraySelectedItems != undefined) {
              let sSelectedItems = '';

              for (var oArraySelectedItem of oArraySelectedItems) {
                if (sSelectedItems == '') {
                  sSelectedItems += oArraySelectedItem;
                }
                else {
                  sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
                }

              }
              oBusinessProcessStatelessDataContext.DataValue[oMultiSelectColumnIndex] = sSelectedItems;
            }
          }
        }
      }

    }
    if (!this.__oUtilityService.IsNullOrUndefined(e)) {
      if (e.rowType == "data" && !this.__oUtilityService.IsNullOrUndefined(e.column.caption)) {
        e.cellElement.id = 'WD_StateDataSource' + '_' + e.rowIndex + '_' + e.column.caption.replace(/\s/g, '') + '_TC';
      }
    }
    if (!this.__oUtilityService.IsNullOrUndefined(e)) {
      if (e.rowType == "data" && !this.__oUtilityService.IsNullOrUndefined(e.column.caption)) {
        e.cellElement.id = 'WD_BusinessProcessStateGridDataContext' + '_' + e.rowIndex + '_' + e.column.caption.replace(/\s/g, '') + '_TC';
      }
    }
    if (!this.__oUtilityService.IsNullOrUndefined(e)) {
      if (e.rowType == "data" && !this.__oUtilityService.IsNullOrUndefined(e.column.caption)) {
        e.cellElement.id = 'WD_ItemSource' + '_' + e.rowIndex + '_' + e.column.caption.replace(/\s/g, '') + '_TC';
      }
    }
  }

  onCellClick(e: any) {
    if (this.__oMultiSelectControlColumnIndex.length > 0 /*&& this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0*/) {

      for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {

        for (var oMultiSelectColumnIndex of this.__oMultiSelectControlColumnIndex) {

          let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[oMultiSelectColumnIndex];

          if (oArraySelectedItems != null && oArraySelectedItems != undefined) {
            let sSelectedItems = '';

            for (var oArraySelectedItem of oArraySelectedItems) {
              if (sSelectedItems == '') {
                sSelectedItems += oArraySelectedItem;
              }
              else {
                sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
              }

            }
            oBusinessProcessStatelessDataContext.DataValue[oMultiSelectColumnIndex] = sSelectedItems;
          }
        }
      }
    }

    //if (e.columnIndex > 1)
    //  this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(e.rowIndex, e.columnIndex));

  }

  ClearFilter(e: any) {
    if (this.dataGrid != null && this.dataGrid != undefined) {
      this.dataGrid.instance.clearFilter();
    }

    //For stateless parent container
    //if (this.__bStatelessParentContainer) {
    //  this.oStatelessworkflowComponent.ClearFilter(e);
    //}
  }

  ClearSorting(e: any) {
    if (this.dataGrid != null && this.dataGrid != undefined) {
      this.dataGrid.instance.clearSorting();
    }
  }

  //AddRow(e: any) {
  //  //For stateless parent container
  //  //if (this.__bStatelessParentContainer) {
  //  //  this.oStatelessworkflowComponent.AddRow(e);
  //  //  return;
  //  //}

  //  //else {
  //  let oDataCntext = new BusinessProcessStatelessDataContext();

  //  oDataCntext.RowNumber = this.__oBusinessProcessStatelessDataContext.length + 1;

  //  oDataCntext.QueryResult = [];

  //  for (var oDCD of this.__oStatelessGridColumnDetail) {
  //    let oDynamicQueryResult = new DynamicQueryResult();
  //    oDynamicQueryResult.ColumnName = oDCD.ColumnName;
  //    oDynamicQueryResult.ColumnType = oDCD.ColumnType;
  //    oDataCntext.QueryResult.push(oDynamicQueryResult);
  //  }


  //  oDataCntext.DataValue = [];
  //  oDataCntext.ItemSource = [];
  //  oDataCntext.MultiSelectedItems = [];
  //  oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
  //  oDataCntext.Opened = [];
  //  oDataCntext.NumberFormat = [];
  //  oDataCntext.MinNum = [];
  //  oDataCntext.MaxNum = [];
  //  oDataCntext.TextSize = [];

  //  oDataCntext.DataValue.push('');
  //  oDataCntext.ItemSource.push([]);
  //  oDataCntext.MultiSelectedItems.push([]);
  //  oDataCntext.Opened.push(false);
  //  oDataCntext.NumberFormat.push('#,##0.##');
  //  oDataCntext.MinNum.push(0);
  //  oDataCntext.MaxNum.push(99);
  //  oDataCntext.TextSize.push(5000);

  //  oDataCntext.DataValue.push('');
  //  oDataCntext.ItemSource.push([]);
  //  oDataCntext.MultiSelectedItems.push([]);
  //  oDataCntext.Opened.push(false);
  //  oDataCntext.NumberFormat.push('#,##0.##');
  //  oDataCntext.MinNum.push(0);
  //  oDataCntext.MaxNum.push(99);
  //  oDataCntext.TextSize.push(5000);

  //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
  //    // Adding Datavalue

  //    let oColumn = this.__oStatelessGridColumnDetail.find(x => x.ColumnName == oSDD.ColumnName);

  //    if (oColumn.ColumnType.includes('Boolean')) {

  //      let bValue: boolean = false
  //      oDataCntext.DataValue.push(bValue);

  //    }
  //    else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {


  //      if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
  //        let bValue: boolean = false;
  //        oDataCntext.DataValue.push(bValue);

  //      }
  //      else {
  //        oDataCntext.DataValue.push(Number(0));
  //      }


  //    }
  //    else {


  //      if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {

  //        let bValue: boolean = false;
  //        oDataCntext.DataValue.push(bValue);

  //      }
  //      else {

  //        let oEmptyValue = '';
  //        oDataCntext.DataValue.push(oEmptyValue);

  //      }
  //    }

  //    // Adding Itemsource

  //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

  //      let oIS;

  //      try {
  //        oIS = JSON.parse(oSDD.ItemSource);
  //      }
  //      catch{

  //        console.log(oSDD.ItemSource);
  //      }

  //      oDataCntext.ItemSource.push(oIS);
  //}
  //    else {

  //      let oItemSource = [];
  //      oDataCntext.ItemSource.push(oItemSource);
  //    }


  //    //Adding multiselected items

  //    let oMultiSelectedKeys = [];
  //    oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

  //    //Adding opened boolean value

  //    oDataCntext.Opened.push(false);

  //    // Adding number format , min , max , Text size

  //    oDataCntext.NumberFormat.push(oSDD.FormatString);
  //    oDataCntext.MinNum.push(oSDD.Min);
  //    oDataCntext.MaxNum.push(oSDD.Max);
  //    oDataCntext.TextSize.push(oSDD.TextSize);

  //  }


  //  for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
  //    let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

  //    oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

  //    if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

  //      let oIS;

  //      try {
  //        oIS = JSON.parse(oSDD.ItemSource);
  //      }
  //      catch{
  //        console.log(oSDD.ItemSource);
  //      }
  //      oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
  //    }


  //    let oColumn = this.__oStatelessGridColumnDetail.find(x => x.ColumnName == oSDD.ColumnName);

  //    if (oColumn.ColumnType.includes('Boolean')) {

  //      let bValue: boolean = false
  //      oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

  //    }

  //    if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {

  //      if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
  //        let bValue: boolean = false;
  //        oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

  //      }
  //      else {
  //        oBusinessProcessStateLessDefinitionDetail.DataValue = Number(0);
  //      }

  //    }
  //    else {

  //      if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {

  //        let bValue: boolean = false;
  //        oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

  //      }
  //      else {
  //        //oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
  //      }
  //    }

  //    oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
  //    oBusinessProcessStateLessDefinitionDetail.Opened = false;

  //    if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
  //      oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
  //    }


  //    oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

  //  }

  //  let oStatelessAction: Action[] = [];

  //  for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
  //    if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
  //      let oAction = new Action();
  //      oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
  //      oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
  //      oStatelessAction.push(oAction);
  //    }
  //  }

  //  oDataCntext.Actions = oStatelessAction;

  //  this.__oBusinessProcessStatelessDataContext.unshift(oDataCntext);
  //  this.dataGrid.instance.refresh();

  //  if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
  //    this.__oStatelessGridSelectedKeys = [];
  //  }

  //  if (this.__oStatelessGridSelectedKeys.filter(x => x == oDataCntext.RowNumber).length == 0)
  //    this.__oStatelessGridSelectedKeys.push(oDataCntext.RowNumber);
  //  //}
  //}

  AddRow(e: any) {
    if (this.__oStatelessGridSelectedKeys.length == 1) {
      this.__oConfirmationComponent.show(ConfirmationType.Information,
        "Do you want to clone the selected row ?",
        "Confirmation", "Yes", "No").then(result => {
          if (result) {
            this.fnCloneRow(e);
          }
          else {
            this.fnAddRow(e);
          }
        });

      //confirm("Do you want to clone the selected row ?", "Confirmation").then((result) => {
      //  if (result) {
      //    this.fnCloneRow(e);
      //  }
      //  else {
      //    this.fnAddRow(e);
      //  }
      //});
    }
    else {
      this.fnAddRow(e);
    }
    //}
  }

  fnAddRow(e: any) {
    let oDataCntext = new BusinessProcessStatelessDataContext();

    oDataCntext.RowNumber = this.__oBusinessProcessStatelessDataContext.length + 1;
    oDataCntext.RowStatus = 'New';
    oDataCntext.QueryResult = [];

    for (var oDCD of this.__oStatelessGridColumnDetail) {
      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oDCD.ColumnName;
      oDynamicQueryResult.ColumnType = oDCD.ColumnType;
      oDataCntext.QueryResult.push(oDynamicQueryResult);
    }


    oDataCntext.DataValue = [];
    oDataCntext.ItemSource = [];
    oDataCntext.MultiSelectedItems = [];
    oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
    oDataCntext.Opened = [];
    oDataCntext.NumberFormat = [];
    oDataCntext.MinNum = [];
    oDataCntext.MaxNum = [];
    oDataCntext.TextSize = [];

    oDataCntext.DataValue.push('');
    oDataCntext.ItemSource.push([]);
    oDataCntext.MultiSelectedItems.push([]);
    oDataCntext.Opened.push(false);
    oDataCntext.NumberFormat.push('#,##0.##');
    oDataCntext.MinNum.push(0);
    oDataCntext.MaxNum.push(99);
    oDataCntext.TextSize.push(5000);

    oDataCntext.DataValue.push('');
    oDataCntext.ItemSource.push([]);
    oDataCntext.MultiSelectedItems.push([]);
    oDataCntext.Opened.push(false);
    oDataCntext.NumberFormat.push('#,##0.##');
    oDataCntext.MinNum.push(0);
    oDataCntext.MaxNum.push(99);
    oDataCntext.TextSize.push(5000);

    for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      // Adding Datavalue

      let oColumn = this.__oStatelessGridColumnDetail.find(x => x.ColumnName == oSDD.ColumnName);

      if (oColumn.ColumnType.includes('Boolean')) {

        let bValue: boolean = false
        oDataCntext.DataValue.push(bValue);

      }
      else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {


        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
          let bValue: boolean = false;
          oDataCntext.DataValue.push(bValue);

        }
        else {
          oDataCntext.DataValue.push(Number(0));
        }


      }
      else {


        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {

          let bValue: boolean = false;
          oDataCntext.DataValue.push(bValue);

        }
        else {

          let oEmptyValue = '';
          oDataCntext.DataValue.push(oEmptyValue);

        }
      }

      // Adding Itemsource

      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

        let oIS;

        try {
          oIS = JSON.parse(oSDD.ItemSource);
        }
        catch {

          console.log(oSDD.ItemSource);
        }

        oDataCntext.ItemSource.push(oIS);
      }
      else {

        let oItemSource = [];
        oDataCntext.ItemSource.push(oItemSource);
      }


      //Adding multiselected items

      let oMultiSelectedKeys = [];
      oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

      //Adding opened boolean value

      oDataCntext.Opened.push(false);

      // Adding number format , min , max , Text size

      oDataCntext.NumberFormat.push(oSDD.FormatString);
      oDataCntext.MinNum.push(oSDD.Min);
      oDataCntext.MaxNum.push(oSDD.Max);
      oDataCntext.TextSize.push(oSDD.TextSize);

    }


    for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

      oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

        let oIS;

        try {
          oIS = JSON.parse(oSDD.ItemSource);
        }
        catch {
          console.log(oSDD.ItemSource);
        }
        oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
      }


      let oColumn = this.__oStatelessGridColumnDetail.find(x => x.ColumnName == oSDD.ColumnName);

      if (oColumn.ColumnType.includes('Boolean')) {

        let bValue: boolean = false
        oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

      }

      if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {

        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
          let bValue: boolean = false;
          oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

        }
        else {
          oBusinessProcessStateLessDefinitionDetail.DataValue = Number(0);
        }

      }
      else {

        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {

          let bValue: boolean = false;
          oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

        }
        else {
          //oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
        }
      }

      oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
      oBusinessProcessStateLessDefinitionDetail.Opened = false;

      if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
        oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
      }


      oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

    }

    let oStatelessAction: Action[] = [];

    for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
      if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
        let oAction = new Action();
        oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
        oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
        oStatelessAction.push(oAction);
      }
    }

    oDataCntext.Actions = oStatelessAction;

    this.__oBusinessProcessStatelessDataContext.unshift(oDataCntext);
    this.dataGrid.instance.refresh();

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == oDataCntext.RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(oDataCntext.RowNumber);
  }

  fnCloneRow(e: any) {
    let RowNumber: number = this.__oStatelessGridSelectedKeys[0];

    let oBusinessProcessStatelessDataContextExist: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oBusinessProcessStatelessDataContextNew: BusinessProcessStatelessDataContext = new BusinessProcessStatelessDataContext();

    //oBusinessProcessStatelessDataContextNew = Object.assign({}, oBusinessProcessStatelessDataContextExist);

    oBusinessProcessStatelessDataContextNew = JSON.parse(JSON.stringify(oBusinessProcessStatelessDataContextExist));

    oBusinessProcessStatelessDataContextNew.RowNumber = this.__oBusinessProcessStatelessDataContext.length + 1;

    oBusinessProcessStatelessDataContextNew.RowStatus = 'New';

    this.__oBusinessProcessStatelessDataContext.unshift(oBusinessProcessStatelessDataContextNew);

    this.dataGrid.instance.refresh();

  }

  //#endregion

  StateLessDropDownClose(e: any) {
    if (e.data != undefined && e.data != null) {

      if (this.__oMultiSelectControlColumnIndex.length > 0 && this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0) {
        let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == e.data.RowNumber);

        let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[e.columnIndex];

        if (oArraySelectedItems != null && oArraySelectedItems != undefined) {
          let sSelectedItems = '';

          for (var oArraySelectedItem of oArraySelectedItems) {
            if (sSelectedItems == '') {
              sSelectedItems += oArraySelectedItem;
            }
            else {
              sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
            }

          }
          oBusinessProcessStatelessDataContext.DataValue[e.columnIndex] = sSelectedItems;

        }
      }
    }
  }

  GenerateStateTabs() {
    this.__oWFTabs = [];

    let iIndex: number = 1;

    let oWorkflowTabs: WorkFlowTab[] = [];

    for (let oCurrentInstanceWithItemSource of this.__oBusinessProcessInstanceCurrentStateDatas) {
      let sTabName: string = oCurrentInstanceWithItemSource.TabName;

      if (oWorkflowTabs.filter(x => x.Name == sTabName).length == 0) {
        let oTab: WorkFlowTab = new WorkFlowTab();

        oTab.ID = iIndex
        oTab.Name = sTabName;
        oTab.DisplayOrder = oCurrentInstanceWithItemSource.TabDisplayOrder;

        oWorkflowTabs.push(oTab);
      }

      iIndex += 1;

    }

    for (let oWFT of oWorkflowTabs.sort(x => x.DisplayOrder)) {
      this.__oWFTabs.push(oWFT);
    }

    if (this.__oWFBusinessProcessDefinition && this.__oWFBusinessProcessDefinition.IsComments == 1) {
      iIndex += 1;
      let oCommentTab: WorkFlowTab = new WorkFlowTab();

      oCommentTab.ID = iIndex;
      oCommentTab.Name = "Comment";

      this.__oWFTabs.push(oCommentTab);
    }

    // select tab
    if (!this.__oUtilityService.IsNullOrUndefined(this.__sParam) && this.__sParam.indexOf('TabName:') > -1) {
      let sTabName: string = this.selectStateTab();
      this.selectedTabIndex = this.__oWFTabs.findIndex(x => x.Name.toLowerCase() == sTabName.toLowerCase());
      this.__sParam = this.__sParam.replace('~TabName:' + sTabName, '').replace('TabName:' + sTabName, '');
    }
    else { this.selectedTabIndex = 0; };


  }

  selectStateTab(): string {
    let sParamValueWithDataCaptions: string[] = this.__sParam.split('~');
    let sTabParam: string = sParamValueWithDataCaptions.find(x => x.indexOf('TabName:') >= 0);
    let sDataValue: string = sTabParam.substring(sTabParam.indexOf(":") + 1);
    return sDataValue; // return the tab name
  }


  private __bSLDropDownOpened: boolean = false;

  get gridBoxValue(): boolean {
    return this.__bSLDropDownOpened;
  }

  set gridBoxValue(value: boolean) {
    this.__bSLDropDownOpened = value;
    if (this.__bSLDropDownOpened == false) {
      if (this.__oMultiSelectControlColumnIndex.length > 0 /*&& this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0*/) {

        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {

          for (var oMultiSelectColumnIndex of this.__oMultiSelectControlColumnIndex) {

            let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[oMultiSelectColumnIndex];

            if (oArraySelectedItems != null && oArraySelectedItems != undefined) {
              let sSelectedItems = '';

              for (var oArraySelectedItem of oArraySelectedItems) {
                if (sSelectedItems == '') {
                  sSelectedItems += oArraySelectedItem;
                }
                else {
                  sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
                }

              }
              oBusinessProcessStatelessDataContext.DataValue[oMultiSelectColumnIndex] = sSelectedItems;
            }
          }
        }
      }
    }
  }


  get gridBoxValueStateDataGrid(): boolean {
    return this.__bSLDropDownOpened;
  }

  set gridBoxValueStateDataGrid(value: boolean) {
    this.__bSLDropDownOpened = value;
    if (this.__bSLDropDownOpened == false) {

      for (let oBPISD of this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => x.DataType == "Data Grid")) {
        for (let oSDGIS of oBPISD.ItemSource) {
          let oBusinessProcessStateGridDataContext: BusinessProcessStateGridDataContext = oSDGIS;

          for (let iIndex in oBusinessProcessStateGridDataContext.MultiSelectedItems) {
            let oArraySelectedItems = oBusinessProcessStateGridDataContext.MultiSelectedItems[iIndex];

            if (oArraySelectedItems != null && oArraySelectedItems != undefined && oArraySelectedItems.length > 0) {
              let sSelectedItems = '';

              for (var oArraySelectedItem of oArraySelectedItems) {
                if (sSelectedItems == '') {
                  sSelectedItems += oArraySelectedItem;
                }
                else {
                  sSelectedItems = sSelectedItems + ',' + oArraySelectedItem;
                }

              }
              oBusinessProcessStateGridDataContext.DataValue[iIndex] = sSelectedItems;
            }
          }

        }
      }

    }
  }

  private replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'frtwrdslsh101')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'neewwlliine').replace(/\\r/g, 'neewwlliine');//.replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  /* Start FB 25619 - Vidya */

  private replaceAllSpecialCharacters(str: any) {
    let strToBeReturned = "";

    strToBeReturned = str.replace(/backslaaash/g, "\\\\").replace(/annnd/g, "&").replace( 'frtwrdslsh101',"/").replace(/pluuuus/g, "+").replace(/cln100/g, ":").replace(/leeesthan/g, "<").replace(/greeeterthan/g, ">").replace(/hassh/g, "#")
      .replace(/aaat/g, "@").replace(/staaar/g, "*").replace(/dolllaar/g, "$").replace(/perseent/g, "%").replace(/exclammmaation/g, "!").replace(/quoootes/g, '\\"').replace(/ampersand/g, "&").replace(/forwardslaaash/g, "\\\\"); //FB 30669 - Vidya

    return strToBeReturned;
  }

  /* End FB 25619 - Vidya */

  private replaceFilePath(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/\\/g, 'bckwrdslsh101').replace(/:/g, 'cln100').replace(/#/g, 'hassh').replace(/\$/g, 'dolllaar')
      .replace(/\%/g, 'perseent').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus');
    return strToBeReturned;
  }

  private replaceAllExportString(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101')
      .replace(/#/g, 'hassh').replace(/@/g, 'aaat').replace(/%/g, 'perseent').replace(/\*/g, 'staar')
      .replace(/\$/g, 'dolllaar').replace(/\%/g, 'perseent').replace(/!/g, 'exclamation '); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }


  private GetSqlTypeStringFromArray(oStrArray: any[]) {
    let sResult: string = '';
    oStrArray.forEach(x => {
      let svalue: string = x;
      if (this.__oUtilityService.IsNullOrEmpty(sResult)) {

        if (svalue.includes(','))
          sResult = svalue.replace(',', 'commma');
        else
          sResult = svalue;
      }
      else {

        if (svalue.includes(','))
          sResult = sResult + "," + svalue.replace(',', 'commma');
        else
          sResult = sResult + "," + svalue;


      }
    })

    return sResult;
  }

  private URLEncode(str: any) {
    let strToBeReturned = "";
    //strToBeReturned = str.replace(/&/g, '%26');
    if (str != null && str != undefined && str != "") {
      strToBeReturned = str.toString().replace(/\%/g, '%25').replace(/&/g, '%26').replace(/#/g, '%23').replace(/\?/g, '%3F').replace(/\//g, '%2F').replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\' '/g, "%20").replace(/\+/g, "%2B");//.replace(/\\/g, '%2F');//.replace(/</g, "%3C").replace(/>/g, "%3E").replace(/&/g, "%26").replace(/!/g, "%21").replace(/@/g, "%40").replace(/#/g, "%23").replace(/\$/g, "%24").replace(/\%/g, "%25").replace(/\^/g, "%5E").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/-/g, "%2D").replace(/\+/g, "%2B").replace(/=/g, "%3D").replace(/:/g, "%3A").replace(/;/g, "%3B").replace(/\?/g, "%3F").replace(/~/g, "%7E").replace(/\./g, "%2E").replace(/,/g, "%2C").replace(/\//g, "%2F").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/\[/g, "%5B").replace(/]/g, "%5D");//.replace(/'/g, "Quotes1").replace(/`/g, "Tilde2");
      //strToBeReturned = str.toString().replace(/\%/g, '%25').replace(/&/g, '%26').replace(/#/g, '%23').replace(/\?/g, '%3F').replace(/\//g, '%2F');//.replace(/\\/g, '%2F');//.replace(/</g, "%3C").replace(/>/g, "%3E").replace(/&/g, "%26").replace(/!/g, "%21").replace(/@/g, "%40").replace(/#/g, "%23").replace(/\$/g, "%24").replace(/\%/g, "%25").replace(/\^/g, "%5E").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/-/g, "%2D").replace(/\+/g, "%2B").replace(/=/g, "%3D").replace(/:/g, "%3A").replace(/;/g, "%3B").replace(/\?/g, "%3F").replace(/~/g, "%7E").replace(/\./g, "%2E").replace(/,/g, "%2C").replace(/\//g, "%2F").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/\[/g, "%5B").replace(/]/g, "%5D");//.replace(/'/g, "Quotes1").replace(/`/g, "Tilde2");
    }
    else {
      strToBeReturned = str;
    }
    return strToBeReturned;
    //&#%?/
  }

  private changeIcon() {
    if ($($('p.pCollapsable>a')[0]).hasClass('collapsed')) {
      $($('p.pCollapsable>a')[0]).find('span').removeClass('bluetab_1');
      $($('p.pCollapsable>a')[0]).find('span').addClass('bluetab_2');
      $('p.pCollapsable').css({ 'background': '#FFFFFF', 'width': '1.3rem', 'border-radius': '5px' });
      $('p.pCollapsable>a').css({ 'margin-left': '-0.2rem' });
      if (this.__bStateWorkflowVisible) {
        $('#divStateWF').css({ 'padding': '0 0 0 2rem' });
      }
      else if (this.__bStatelessWorkflowVisible) {
        $('#divStatelessWF').css({ 'padding': '0 0 0 2rem' });
      }
    }
    else {
      $($('p.pCollapsable>a')[0]).find('span').removeClass('bluetab_2');
      $($('p.pCollapsable>a')[0]).find('span').addClass('bluetab_1');
      $('p.pCollapsable').css({ 'background': 'transparent', 'width': '1px' });
      $('p.pCollapsable>a').css({ 'margin-left': '-1.1rem' });
      if (this.__bStateWorkflowVisible) {
        $('#divStateWF').css({ 'padding': '0 0 0 1rem' });
      }
      else if (this.__bStatelessWorkflowVisible) {
        $('#divStatelessWF').css({ 'padding': '0 0 0 1rem' });
      }
    }


  }

  hideSidePanelForStatelessWorkflow() {
    this.__sParam = this.route.snapshot.paramMap.get('BPS');
    if (this.__sParam != null) {
      let hideParam: string = this.__sParam.substring(0, this.__sParam.indexOf(":"));
      let hideParamValue: string = this.__sParam.substring(this.__sParam.indexOf(":") + 1);
      if (hideParam != null && hideParamValue != null) {
        if (hideParam.toLowerCase() == "hidesidepanel") {
          if (hideParamValue.toLowerCase() == "true") {
            this.hideSidePanel();
          } else {
            this.showSidePanel();
          }
        }
      }
    }
  }

  private changeStateCollapseIcon() {
    if ($($('p.pStateCollapsable>a')[0]).hasClass('collapsed')) {
      $($('p.pStateCollapsable>a')[0]).find('span').removeClass('bluetab_1');
      $($('p.pStateCollapsable>a')[0]).find('span').addClass('bluetab_2');
      $('p.pStateCollapsable').css({ 'background': '#FFFFFF', 'width': '1.3rem', 'border-radius': '5px' });
      $('p.pStateCollapsable>a').css({ 'margin-left': '-0.2rem' });
      $('#div-state-content').css({ 'padding': '0 0 0 2.3rem' });
      $('#div-state-right-panel').css({ 'padding': '0 0 0 2.1rem' });
    }
    else {
      $($('p.pStateCollapsable>a')[0]).find('span').removeClass('bluetab_2');
      $($('p.pStateCollapsable>a')[0]).find('span').addClass('bluetab_1');
      $('p.pStateCollapsable').css({ 'background': 'transparent', 'width': '1px' });
      $('p.pStateCollapsable>a').css({ 'margin-left': '-1.1rem' });
      $('#div-state-content').css({ 'padding': '0 0 0 1rem' });
      $('#div-state-right-panel').css({ 'padding': '0 0 0 0.8rem' });
       if (this.__oBusinessProcessDefinitionName == 'Counterparty Bank details Approval') {
        $('#div-state-right-panel').css({ 'padding': '0 1rem 0 0.8rem' });
      }
    }
    if (!this.__bStateRightPanelVisisble) {
      //$('#div-state-right-panel').css({ 'padding': '0' });
    }
    if (!this.__bStateRightPanelVisisble) {
      $('#div-state-right-panel').css({ 'padding': '0' });
    }
    if (this.hideDashboardMenu) {
      $('#statesPane').addClass('hide-dashboard-menu');
    }
  }

  workflowChildTabSelectionChanged(e: any) {
    if (e.addedItems) {
      var item = this.__lStatelessWorkflowTabs.find(x => x.lwfBusinessProcessTabDefinitionId == e.addedItems[0].lwfBusinessProcessTabDefinitionId);
      if (item != null && !this.__oUtilityService.IsNullOrUndefined(item.widgetInstance)) {
        this.RefreshTab(item.widgetInstance, item.lwfBusinessProcessTabDefinitionId);
        this.RefershBusinessProcessCount();
      }
      else {
        if (!this.__oUtilityService.IsNullOrUndefined(item)) {
          item.IsWidgetLoaded = false;
        }
      }
    }
  }

  RefreshTab(e: any, lwfBusinessProcessTabDefinitionId: number) {
    this.oStatelessworkflowComponent = e;
    this.oStatelessworkflowComponent.__iWfBusinessProcessDefinitionId = lwfBusinessProcessTabDefinitionId;
    this.oStatelessworkflowComponent.RefreshGrid();
    this.hideSidePanelForStatelessWorkflow();
    this.RefreshTabCount();
    
  }

  Initialize(e: any, lwfBusinessProcessTabDefinitionId: number) {    
    var item = this.__lStatelessWorkflowTabs.find(x => x.lwfBusinessProcessTabDefinitionId == lwfBusinessProcessTabDefinitionId);
    if (item != null)
    {
      item.widgetInstance = e;
      
      let param: any = {};
      
      let selectedItem: any[] = [];      
      selectedItem.push(item);
      param.addedItems = selectedItem;

      if (this.__oUtilityService.IsNullOrUndefined(item.IsWidgetLoaded)) {
        item.IsWidgetLoaded = true;
      }

      if (!item.IsWidgetLoaded)
        this.workflowChildTabSelectionChanged(param);
    };
  }

  InitializeNonParent(e: any, lwfBusinessProcessTabDefinitionId: number) {
    this.oStatelessworkflowComponentNonParent = e;
    this.oStatelessworkflowComponentNonParent.__iWfBusinessProcessDefinitionId = lwfBusinessProcessTabDefinitionId;
    this.oStatelessworkflowComponentNonParent.RefreshGrid();
    this.hideSidePanelForStatelessWorkflow();
  }

  RefreshTabCount() {

    for (var tab of this.__lStatelessWorkflowTabs) {

      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/BusinessProcessStatelessTabCount/" + tab.lwfBusinessProcessStatelessTabId).then((Data) => {
        if (Data != null) {
          try {
            var oCount = JSON.parse(Data);
          }
          catch {
            console.log(Data);
          }
          let oBusinessProcessTabs: any = this.__lStatelessWorkflowTabs.find(x => x.lwfBusinessProcessStatelessTabId == oCount[0].lwfBusinessProcessStatelessTabId);

          if (oBusinessProcessTabs.ItemCount == null || oBusinessProcessTabs.ItemCount == undefined || oCount[0].ItemCount == -1) {
            oBusinessProcessTabs.ItemCount = 0;
          }
          else
            oBusinessProcessTabs.ItemCount = oCount[0].ItemCount;
        }

      });
    }
  }

  RefershBusinessProcessCount()
  {
    for (let oBPVM of this.__oBusinessProcessViewModels) {
      let oBP: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == this.__oWFBusinessProcessDefinition.wfBusinessProcessDefinition);
      if (oBP != null) {
        let iIndex = this.__oBusinessProcessViewModels.indexOf(oBPVM);
        this.__iBusinessProcessAccordionSelectedIndex = iIndex;
        for (var oBPS of oBPVM.BusinessProcesses) {
          this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessesCount/" + oBPS.BusinessProcess.replace("&", "annd").replace('+', 'pluuus').replace("/", "backslaaash").replace("\\", "forwardslaaash")).then((Data) => {
            if (Data != null) {

              try {
                var oCount = JSON.parse(Data);
              }
              catch {
                console.log(Data);
              }
              let oBusinessProcessHTML: BusinessProcessHTML = oBPVM.BusinessProcesses.find(x => x.BusinessProcess == oCount[0].BusinessProcess);
              oBusinessProcessHTML.ItemCount = oCount[0].ItemCount;
            }
          });
        }
        oBPVM.GetIsCountFetched = 1;
        return;
      }
    }
  }

  OpenReferenceDataURLStateLess(ColumnIndex: any, RowIndex: any, RowNumber: any) {
    // let oBusinessProcessInstanceCurrentStateData: BusinessProcessStateLessDefinitionDetail = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == e);

    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let dataValue = oBusinessProcessStatelessDataContext.DataValue[ColumnIndex];

    let sInstance: string = dataValue;

    let sWebURL: string = this.__oSwitchPortal.UrlAngular; //UrlSilverLIght;

    //sWebURL = sWebURL.replace('RCPortalFrameWork.aspx', '');

    if (oBusinessProcessStatelessDataContext.DataTypeParameter[ColumnIndex] != null &&
      oBusinessProcessStatelessDataContext.DataTypeParameter[ColumnIndex].indexOf('EntityGroup') > 0) {

      let sDataTypeParameter: string = oBusinessProcessStatelessDataContext.DataTypeParameter[ColumnIndex];

      let EntityGroup: string = sDataTypeParameter.substring(sDataTypeParameter.indexOf('<EntityGroup>') + 13, sDataTypeParameter.indexOf('</EntityGroup>'));

      sInstance = this.URLEncode(dataValue);
      let sURL = this.OpenEntityGroupInstance(sWebURL, EntityGroup, sInstance);
      window.open(sURL, "_blank");
    }
    else { window.open(sInstance, "_blank"); }
  }

  OpenEntityGroupInstance(sWebURL: string, EntityGroup: string, sInstance: string): string {
    if (EntityGroup != null && EntityGroup != '') {
      // sWebURL = sWebURL + "/wfDataCaptureFormSL.aspx?Form=" + EntityGroup + "&Name=" + sInstance;
      if (EntityGroup.toLocaleLowerCase().trim() == 'counterparty management') {
        sWebURL = sWebURL + "TradingCounterparty/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'cash collateral') {
        sWebURL = sWebURL + "CashManagement/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'credit support annex') {
        sWebURL = sWebURL + "CreditSupportAnnex/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'letter of credit') {
        sWebURL = sWebURL + "LetterOfCredit/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'credit insurance management') {
        sWebURL = sWebURL + "CreditInsurance/" + sInstance;
      }
      //else if (EntityGroup.toLocaleLowerCase().trim() == 'netting contract clause') {
      //  sWebURL = sWebURL + "NettingContractClause/" + sInstance;
      //}
      else if (EntityGroup.toLocaleLowerCase().trim() == 'parent counterparty guarantee') {
        sWebURL = sWebURL + "CustomerGuarantee/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'netting contract') {
        sWebURL = sWebURL + "TradeNettingContract/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'our entity management') {
        sWebURL = sWebURL + "OurEntityManagement/13/" + sInstance;
      }//Fb 28022 Workflow> Reference data> opening silverlight screen for Limit Management or Call Memo Entity Group
      else if (EntityGroup.toLocaleLowerCase().trim() == 'call memo') {
        sWebURL = sWebURL + "CallMemo/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'limit management') {
        sWebURL = sWebURL + "CounterpartyManagement/9/CounterpartyLimits?tradingcounterparty=" + sInstance;
      }
      else {
        let silverlightURL = this.__oSwitchPortal.UrlSilverLIght.replace('RCPortalFrameWork.aspx', '');
        sWebURL = silverlightURL + "/wfDataCaptureFormSL.aspx?Form=" + EntityGroup + "&Name=" + sInstance;
      }
      return sWebURL;
    }
    else {
      return sInstance.replace(/%2F/g, '');
    }
  }

  OpenURLFromGridRow(ColumnIndex: any, RowIndex: any, RowNumber: any, lBusinessProcessInstanceCurrentStateDataId) {
    // let oBusinessProcessInstanceCurrentStateData: BusinessProcessStateLessDefinitionDetail = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == e);

    let oBusinessProcessInstanceCurrentStateData: BusinessProcessInstanceCurrentStateData = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == lBusinessProcessInstanceCurrentStateDataId);
    let ColumnData = oBusinessProcessInstanceCurrentStateData.StateDataGridColumns[ColumnIndex - 1];
    let GridData = oBusinessProcessInstanceCurrentStateData.BusinessProcessStateGridData.find(x => x.ColumnHeader == ColumnData.caption);
    let oBusinessProcessDataContext: BusinessProcessStateGridDataContext = oBusinessProcessInstanceCurrentStateData.ItemSource[RowNumber - 1];
    let link = oBusinessProcessDataContext.QueryResult.find(x => x.ColumnName == GridData.DataTypeParameter);
    if (link != null) {
      let _link = link.DataValue.replace(/\(/g, "%28").replace(/\)/g, "%29");
      if (GridData.IsOpenOnNewTab == 0) {
        window.open(_link);
      }
      else {
        this.__oConfirmationComponent.show(ConfirmationType.Information, Constants.OPEN_URL_NEW_TAB_CONFIRMATION, "Confirmation", "Continue", "Cancel")
          .then(result => {
            if (result) {
              window.open(_link);
            }
          });
      }


    }
  }


  ///document template
  LoadDocumentTemplate(template: any) {
    if (template == null) {
      this.selectedTemplate = null;
      this.templates = [];
      if(!this.__bIsDataGridDocumentGeneratePopup) {
        this.documentTemplatesInstance.instance.option('templates', []);
      }
      $("#documentGenerateModal input[type='hidden']").val("");
      $("#documentGenerateModal input.dx-texteditor-input").val("");
      this.templateContent = "";
    }
    else {
      if (template.value != null)
        this.selectedTemplate = template.value;
      else {
        this.selectedTemplate = template;
        this.templates.push(template.lDocumentTemplateId);
      }
      this.GetDocumentTemplateFunctionResult(template);

    }

  }
  private GetDocumentTemplateFunctionResult(template: any) {
    this.templateContent = "";
    let oDocumentTemplateData: DocumentTemplateData = new DocumentTemplateData();

    if (this.isDocumentGenerateFroStateAction && this.templates.length > 0) {
      oDocumentTemplateData.lwfBusinessProcessRuleActionId = this.lwfBusinessProcessRuleActionId;
      oDocumentTemplateData.lwfBusinessProcessStateDataGridActionId = 0;
    }
    else {
      oDocumentTemplateData.lwfBusinessProcessRuleActionId = 0;
      oDocumentTemplateData.lwfBusinessProcessStateDataGridActionId = this.lwfBusinessProcessStateDataGridActionId;
    }
    oDocumentTemplateData.sXMLStateData = this.__sXMLProcessStateData;

    if (this.templates && this.templates.length > 0) {
      oDocumentTemplateData.sDocumentTemplateIds = this.templates.join("|");
      this.service.UpdateAllDataByPromise(oDocumentTemplateData, this.__sGetApiUrl + "api/WorkflowDashBoard/PostDocumentTemplateFunctionResult").then(
        result => this.OnSuccessSaveDocumentTemplateFunctionResult(result)
      ).
        catch(error => this.OnErrorDocumentTemplateFunctionResult(error))
    }

  }
  private OnSuccessSaveDocumentTemplateFunctionResult(response: any) {
    this.documentTemplateKeyValuePairs = [];
    let sHtmlLineBreak = "<br style='page-break-before: always;'>";
    let oDocumentTemplateFunctionResults: DocumentTemplateFunctionResult[] = [];
    if (response != null) {
      let result = JSON.parse(response);
      if (result) {
        Object.assign(oDocumentTemplateFunctionResults, result)
        for (let i = 0; i < oDocumentTemplateFunctionResults.length; i++) {
          let oTemplateKeyValuePairs: any = [];
          if (i> 0) {
            this.templateContent = this.templateContent + sHtmlLineBreak;
          }
          let matchingTemplate: DocumentTemplate = this.__oDocumentTemplates.find(node => node.lDocumentTemplateId == parseInt(oDocumentTemplateFunctionResults[i].sDocumentTemplateId));
          let documentTemplateDetails: DocumentTemplateDetail[] = matchingTemplate.DocumentTemplateDetail;
          if (oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumnDetails && oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumnDetails.length > 0) {
            for (let j = 0; j < oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumnDetails.length; j++) {
              oTemplateKeyValuePairs = [];
              if (oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumnDetails[j] && oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumnDetails[j].FunctionResults) {
                if (j > 0) {
                  this.templateContent = this.templateContent + sHtmlLineBreak;
                }
                oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumns.forEach((ColumnName: string) => {
                  oTemplateKeyValuePairs[ColumnName] = oDocumentTemplateFunctionResults[i].DocumentTemplateFunctionColumnDetails[j].FunctionResults[ColumnName];
                });
                let replacedContent = this.ReplaceParameters(matchingTemplate.Content, documentTemplateDetails, oTemplateKeyValuePairs);
                this.templateContent = this.templateContent + replacedContent;
              }
            }
          }
          else {
            this.templateContent = this.templateContent + matchingTemplate.Content; 
          }
          if (matchingTemplate.DocumentTag) {
            let sDocumentTag = matchingTemplate.DocumentTag;
            let replacedDocumentTag = this.ReplaceParameters(sDocumentTag, documentTemplateDetails, oTemplateKeyValuePairs);
            matchingTemplate.DocumentTag = replacedDocumentTag;
          }   

        }
      }
    }

  }
  private OnErrorDocumentTemplateFunctionResult(error: any) {
    console.log(error);
  }

  private ReplaceParameters(originalContent: string, documentTemplateDetails: DocumentTemplateDetail[], oTemplateKeyValuePairs: any) {
    let replacedContent: string = originalContent;

    for (let keyParameter of Object.keys(oTemplateKeyValuePairs)) {
      let documentTemplateDetail = documentTemplateDetails.find(x => x.PlaceHolderName == "{" + keyParameter + "}");

      if (documentTemplateDetail != null) {
        replacedContent = this.replaceDocumentTemplateParameter(replacedContent, documentTemplateDetail.PlaceHolderName, oTemplateKeyValuePairs[keyParameter]);
      }

    }

    return replacedContent;
  }

  private replaceDocumentTemplateParameter(string: string, search: string, replace: string) {
    return string.split(search).join(replace);
  }

  //close document template
  onPopupCloseButtonClick(event: any) {
    this.CloseDocumentGeneratePopup();
  }


  onPopupSaveAndDownloadButtonClick(event: any) {
    let oDocumentTemplateContent: DocumentTemplateContent = new DocumentTemplateContent();
    if (!this.selectedTemplate || (Array.isArray(this.selectedTemplate) && this.selectedTemplate.length == 0)) {
      this.__oConfirmationComponent.show(ConfirmationType.Error,
        "Please make sure you have selected a template and the content is not empty.",
        "Error", "Ok", "Cancel", false);
      return;
    }
    let sDocumentTag: string[] = [];
    let sTitle;
    if (Array.isArray(this.selectedTemplate)) {
      for (var DocumentTemplateId of this.selectedTemplate) {
        var oDocumentTemplate = this.__oDocumentTemplates.find(x => x.lDocumentTemplateId == DocumentTemplateId);
        if (oDocumentTemplate && oDocumentTemplate.DocumentTag) {
          sDocumentTag.push(oDocumentTemplate.DocumentTag);
        }
      }
    }
    else {
      if (this.selectedTemplate.DocumentTag) {
        sDocumentTag.push(this.selectedTemplate.DocumentTag);
      }
    }
    sTitle = (sDocumentTag.length > 0) ? sDocumentTag.join(";") : '';
    let header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta><title>" + sTitle + "</title></head><body><div>";
    let footer = "</div></body></html>";

    let html = header + this.templateContent + footer;

    let url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    let filename = "";

    if (this.selectedTemplate.DocumentNamePrefix) {
      filename = this.selectedTemplate.DocumentNamePrefix;
    }
    filename += this.documentTemplateFunctionParameter["Id"];
    if (this.selectedTemplate.DocumentNamePostfix) {
      filename += this.selectedTemplate.DocumentNamePostfix;

    }
    if (filename.length == 0) {
      filename = "Document";
    }
    filename += '.docx';
    oDocumentTemplateContent.Content = html;
    oDocumentTemplateContent.Filename = filename;
    oDocumentTemplateContent.Title = sTitle;
    oDocumentTemplateContent.IsHtml = true
    let headers = new Headers();

    let options = new Object({ headers: headers, withCredentials: true, responseType: ResponseContentType.ArrayBuffer });

    this.__bIsLoadingVisible = true;
    this.http.post(this.__sGetApiUrl + `api/WorkflowDashBoard/DownloadDocumentTemplate`, oDocumentTemplateContent, options).subscribe(data => {
      this.exportService.Export(data, oDocumentTemplateContent.Filename);
       this.__bIsLoadingVisible = false;
       this.CloseDocumentGeneratePopup();
    });

  }

  private CloseDocumentGeneratePopup() {
    this.LoadDocumentTemplate(null);
    this.__bIsDataGridDocumentGeneratePopup = false;
    this.__selectedCategory = [];
  }

  IsFileManagerReady(item: BusinessProcessInstanceCurrentStateData) {
    if (item) {
      let hasFileSystem: boolean = item.ItemSource?.toString().length > 0;
      let hasDirectory: boolean = item.DataValue?.toString().length > 0;
      if (hasFileSystem && hasDirectory) return true;
    }
    return false;
  }

  ParseCSVArrayWithStringLiteralHandling(csvString: string): string[] {
    if (csvString == null) return [];

    const quotedRegex = /'([^']*)'/g;
    const unquotedRegex = /(?<=^|,)\s*([^,]*)(?=,|$)/g;
    let matches: RegExpMatchArray[] = []
    if (csvString.includes("'")) {
      matches = [...csvString.matchAll(quotedRegex)];
    }
    else {
      matches = [...csvString.matchAll(unquotedRegex)];
    }

    const parseValues = [...matches].map(match => match[1].trim());
    if (parseValues.length == 1 && parseValues[0] == "") return [];
    return parseValues;
  }


  normalize(parent: any, idToHighlight: number) {
    try {
      if (parent && parent.TradingCounterpartyLegalHierarchyOwnershippings) {
        if (parent.Level == -1 && parent.lChildTradingCounterpartyId == idToHighlight) {
          parent.isExpanded = true;
        }
        for (let i = 0, l = parent.TradingCounterpartyLegalHierarchyOwnershippings.length; i < l; ++i) {
          let child = parent.TradingCounterpartyLegalHierarchyOwnershippings[i];
          child.isSelected = false;
          child.isExpanded = ((parent.isExpanded == null || parent.isExpanded == undefined) ? false : parent.isExpanded);
          if ((child.lChildTradingCounterpartyId == idToHighlight)) {
            child.isSelected = true;
            child.isExpanded = true;
            //this.extractCPIds(child);
          }
          this.normalize(child, idToHighlight);
        }

      }
    }
    catch (e) {
      //this.Logger.Write(e, 'Error', 'GOButtonClicked CP management');
    }
  }

  IsField(item: any) {
    let FullDataTypes = ['File Manager', 'Rich Text Box', 'Qualitative Grid', 'Quantitative Grid', 'Score Analysis', 'Final Score Analysis', 'PowerBI Report', 'Grid', 'Data Grid', 'Content Frame']
    let HalfDataTypes = ['Data Grid', 'Content Frame']
    if (!FullDataTypes.includes(item.DataType)) {
      return true
    }
    if (HalfDataTypes.includes(item.DataType)) {
      if (item.PositionGridWithFields == 1 || item.IsHalfWidth == 1) {
        return true;
      }
    }
    return false;
  }

  TabHasFields(company: any) {
    let tab = this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => company.Name == x.TabName && x.GroupName == null);
    let field = tab.find(x => this.IsField(x));
    if (field) {
      return true;
    }
    return false;
  }

  isSingleDataGridinTab(company: any) {
    let tab = this.__oBusinessProcessInstanceCurrentStateDatas.filter(x => company.Name == x.TabName && x.GroupName == null);
    return (tab.length == 1 && tab.find(x => x.DataType == 'Data Grid')) ? true : false;
  }

  GetStateWorkflowTitle() {

    let oBPS = this.__oBusinessProcessStates?.find(x => x.wfBusinessProcessState == this.__oBusinessProcessStateName);
    if (!!oBPS?.wfBusinessProcessStateDisplayName) {
      return oBPS.wfBusinessProcessStateDisplayName
    }
    else {
      return (this.__oBusinessProcessStateName ?? '') + (this.__sInstanceName ?? '');
    }

  }


  DocumentCategoryDropDownBoxValue(category: any) {
    this.__oTemplatesByCategory = [];
    this.documentTemplatesInstance.instance.option('dataSource', []);
    this.LoadDocumentTemplate(null);
    this.__selectedCategory = category.value;

    let selectedCategoryTemplates = this.__oDocumentCategories.filter(cat =>
      category.value.some(val => cat.lDocumentCategoryId === val)
    );


    let allDocumentTemplates = selectedCategoryTemplates.flatMap(cat => cat.DocumentTemplates);


    let uniqueDocumentTemplates = Array.from(new Set(allDocumentTemplates.map(template => template.lDocumentTemplateId)))
      .map(id => allDocumentTemplates.find(template => template.lDocumentTemplateId === id));

    uniqueDocumentTemplates.sort(function(template1, template2) {
      if(template1.Name.toLowerCase() < template2.Name.toLowerCase()) { return -1; }
      if(template1.Name.toLowerCase() > template2.Name.toLowerCase()) { return 1; }
      return 0;
    });

    for (let documentTemplate of uniqueDocumentTemplates) {
      if (this.__oTemplatesByCategory.length == 0 || !this.__oTemplatesByCategory.find(x => x.lDocumentTemplateId == documentTemplate.lDocumentTemplateId)) {
        let oDocumentTemplate: DocumentTemplate = new DocumentTemplate();
        oDocumentTemplate.lDocumentTemplateId = documentTemplate.lDocumentTemplateId;
        oDocumentTemplate.Name = documentTemplate.Name;
        oDocumentTemplate.Content = documentTemplate.Content;
        oDocumentTemplate.DocumentNamePrefix = documentTemplate.DocumentNamePrefix;
        oDocumentTemplate.DocumentNamePostfix = documentTemplate.DocumentNamePostfix;
        oDocumentTemplate.DocumentTag = documentTemplate.DocumentTag;

        let childs: DocumentTemplateView[] = this.__oDocumentTemplateDetails.filter(x => x.lDocumentTemplateId == oDocumentTemplate.lDocumentTemplateId);
        oDocumentTemplate.DocumentTemplateDetail = [];

        for (let child of childs) {
          let oDocumentTemplateDetail: DocumentTemplateDetail = new DocumentTemplateDetail();
          oDocumentTemplateDetail.lDocumentTemplateDetailId = child.lDocumentTemplateDetailId;
          oDocumentTemplateDetail.lDocumentTemplateId = child.lDocumentTemplateId;
          oDocumentTemplateDetail.MappingColumnName = child.MappingColumnName;
          oDocumentTemplateDetail.PlaceHolderName = child.PlaceHolderName;

          oDocumentTemplate.DocumentTemplateDetail.push(oDocumentTemplateDetail);
        }

        this.__oTemplatesByCategory.push(oDocumentTemplate);
      }
    }

    if (category.value.length === 0)
      this.__oTemplatesByCategory = this.__oDocumentTemplates;

  }

  btnSaveFiletoSharepoint_Click(event: any) {
    if (!this.selectedTemplate || (Array.isArray(this.selectedTemplate) && this.selectedTemplate.length == 0)) {
      this.__oConfirmationComponent.show(ConfirmationType.Error,
        Constants.DOCUMENT_TEMPLTE_MANDATORY_CONDITION,
        Constants.Error, Constants.Ok, Constants.CANCEL, false);
      return;
    }
    else {
      this.__bSharepointDocumentGeneratePopup = true;
    }
  }
  btnUploadSharepointClose_Click(event: any) {
    this.__bSharepointDocumentGeneratePopup = false;

  }
  btnUploadSharepoint_Click(event: any) {
    let oFileContent: FileContent = new FileContent();
    if (this.selectedTemplate == null) {
      this.__oConfirmationComponent.show(ConfirmationType.Error,
        Constants.DOCUMENT_TEMPLTE_MANDATORY_CONDITION,
        Constants.Error, Constants.Ok, Constants.CANCEL, false);
      return;
    }
    let sDocumentTag: string[] = [];
    let sTitle;
    if (Array.isArray(this.selectedTemplate)) {
      for (var DocumentTemplateId of this.selectedTemplate) {
        var oDocumentTemplate = this.__oDocumentTemplates.find(x => x.lDocumentTemplateId == DocumentTemplateId);
        if (oDocumentTemplate && oDocumentTemplate.DocumentTag) {
          sDocumentTag.push(oDocumentTemplate.DocumentTag);
        }
      }
    }
    else {
      if (this.selectedTemplate.DocumentTag) {
        sDocumentTag.push(this.selectedTemplate.DocumentTag);
      }
    }
    sTitle = (sDocumentTag.length > 0) ? sDocumentTag.join(";") : '';
    let header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta><title>" + sTitle + "</title></head><body><div>";
    let footer = "</div></body></html>";

    let html = header + this.templateContent + footer;

    let url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    let filename = "";

    if (this.selectedTemplate.DocumentNamePrefix) {
      filename = this.selectedTemplate.DocumentNamePrefix;
    }
    filename += this.documentTemplateFunctionParameter["Id"];
    if (this.selectedTemplate.DocumentNamePostfix) {
      filename += this.selectedTemplate.DocumentNamePostfix;

    }
    if (filename.length == 0) {
      filename = "Document";
    }
    filename += '.docx';
    oFileContent.Content = html;
    oFileContent.Filename = filename;
    oFileContent.FilePath = this.__oFileManagerSharePoint.__sSelectedDirectory;
    oFileContent.FileSystem = this.__sFileSystem;
    oFileContent.Directory = this.__sDirectory;
    oFileContent.Title = sTitle;
    oFileContent.IsHtml = true
    let headers = new Headers();

    let options = new Object({ headers: headers, withCredentials: true, responseType: ResponseContentType.ArrayBuffer });

    this.__bIsLoadingVisible = true;
    this.http.post(this.__sGetApiUrl + `api/FileManager/UploadDocumentToSharePoint`, oFileContent, options).subscribe(data => {
      let response: any = data;
      if (response != null && response != undefined) {
        this.__oFileManagerSharePoint.__oFileManager?.instance?.refresh().then((data) => {
          this.__oConfirmationComponent.show(ConfirmationType.Success, Constants.DOCUMENT_MANAGEMENT_SAVE_SUCCESS_MESSAGE, Constants.SUCCESS, Constants.Ok, "", false);
        },
          (error) => { })
        this.__bIsLoadingVisible = false;
      }
    },
      (error) => {
        this.__bIsLoadingVisible = false;
      }
    );
  }

  onExporting(e: any, filename: string) {
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet('Sheet');
    const name = filename + '.xlsx';

    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      selectedRowsOnly: e.selectedRowsOnly,
      customizeCell: (options: any) => {
        const exportedValue = options.excelCell?.value;
        if (typeof exportedValue === 'string') {
          options.excelCell.value = exportedValue.trim();
        }
      }
    }).then(function() {
      workbook.xlsx.writeBuffer()
        .then(function(buffer: BlobPart) {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), name);
        });
    });
    e.cancel = true; 
  }
  
  handleDateValueChange(event, index){
    this.oDataGridAddRowPopupItemSource.DataValue[index]=event.value;
  }

}
